import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, AfterViewInit, ViewChildren, QueryList, ElementRef, ChangeDetectorRef, Inject } from '@angular/core';
import { ActivatedRoute, GuardsCheckEnd, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
import { Subscription } from 'rxjs';

import { AppLayer, LayerService, LayerLoadState, FishboneLayer } from 'app/services/layer.service';
import { TableColumn, CommonTableService, TableRow } from 'app/services/common-table.service';
import { FeatureTab, FeatureVerticalTabsComponent } from 'app/components/feature-vertical-tabs/feature-vertical-tabs.component';
import { ColumnFilter, Gfo, GfoService } from 'app/services/gfo.service';
import { AppinfoService } from 'app/services/appinfo.service';
import { LayerQcService, FishboneState, QcEditFilter } from 'app/services/layer-qc.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { ToastrService } from 'ngx-toastr';
import { PagingParam } from 'app/services/common-request.service';
import { CommonMapService, GeometryType } from 'app/services/common-map.service';
import { SortObject, CommonDatagridComponent } from 'app/components/common-datagrid/common-datagrid.component';
import { UserService } from 'app/services/user.service';
import { LayerCategoryStandardSchema, FieldMappingService, SchemaMappingItem, LayerCategory } from 'app/services/field-mapping.service';
import { EditService, BoundaryFeatProp, JsonbInfo, EditCardColumn, LeaveWarningResponse } from 'app/services/edit.service';
import { DemarcationService } from 'app/services/demarcation.service';
import { EnablePublishLayerService } from 'app/services/enable-publish-layer.service';

import * as topojsonClient from "topojson-client";
import { v1 as uuidv1 } from 'uuid';
// import * as jsts from 'jsts';
import * as jstsOperation from 'jsts/org/locationtech/jts/operation';
import * as condition from 'ol/events/condition';
import Feature from 'ol/Feature';
import {
	LinearRing,
	LineString,
	MultiLineString,
	MultiPoint,
	MultiPolygon,
	Point,
	Polygon,
} from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import { getCenter, createEmpty, extend, containsExtent, containsXY } from 'ol/extent';
import WKT from 'ol/format/WKT';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';

import { CommonColumnFilterComponent } from 'app/components/common-column-filter/common-column-filter.component';
import { EditCardComponent, EditDataEmitter, SelectRecordEmitter, EditRecordListChangeData } from 'app/components/content-edit/edit-card/edit-card.component';
import { ConfirmModalData, ConfirmModalComponent } from 'app/components/modal/confirm-modal/confirm-modal.component';
import { CommonModalService } from 'app/services/common-modal.service';
import { Gto, GtoService } from 'app/services/gto.service';
import { CommonMapComponent } from 'app/components/common-map/common-map.component';
import { ArcmapConnectService } from 'app/services/arcmap-connect.service';
import { ContextMenuService } from 'ngx-contextmenu';
import { AddExceptionModalComponent, AddExceptionInputData, AddExceptionOutputData } from '../add-exception-modal/add-exception-modal.component';
import { ExceptionService, ExceptionItem } from 'app/services/exception.service';
import { colors } from 'assets/TS/StyleConfig';
import { PaneHeaderService } from 'app/services/pane-header.service';
import { ComponentCanDeactivate } from 'app/guards/pending-changes.guard';
import { EditCardFishboneComponent } from 'app/components/content-edit/edit-card-fishbone/edit-card-fishbone.component';
import { SelectTopoErrorData, ResolveData as TopoResolveData, TopoErrorType } from 'app/components/content-edit/edit-topo-error/edit-topo-error.component';
import { ActivityService, TabKey } from 'app/services/activity.service';
import { TopoCheckOutput, TopoService, TopoCheckAreaIndex, TopoCheckArea, TopoCheckOutputExt, TopoCheckCrevice, TopoCheckInterLayerOutputExt } from 'app/services/topo.service';
import { MainDataMapService, EditLineTopo } from 'app/services/main-data-map.service';
import { MainDataMapLayersService } from 'app/services/main-data-map-layers.service';
import { AttrFilter, AttributeFilterService } from 'app/services/attribute-filter.service';
import { ContentMenuLayerItemKey, FilterOption, LabelCalc, MainDataService, ModelMenuItemKey, SchemaDefinedByKey, QcFilterInfo } from 'app/services/main-data.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { BatchEditableColumn } from 'app/components/content-edit/edit-batch/edit-batch.component';
import { TooltipHelpService } from 'app/services/tooltip-help.service';
// import { FeatLayerControlComponent, LayerControlModalData } from 'app/components/feat-layer-control/feat-layer-control.component';
import { PanelToggleOutput } from 'app/components/feat-panel-toggle/feat-panel-toggle.component';
import { MapBrowserEvent } from 'ol';
import { AddressFishboneInfo, FishboneCardType, FishboneRoads, FishboneService } from 'app/services/fishbone.service';
import { ArchiveModeService } from 'app/services/archive-mode.service';
import { JstsService } from 'app/services/jsts.service';
import { QaResolverFeed, ResolutionCenterService } from 'app/services/resolution-center.service';
import { ResolutionCenterDomainService } from 'app/services/resolution-center-domain.service';
import { DomainService } from 'app/services/domain.service';
import { CommonTemplatesService } from 'app/services/common-templates.service';
import { MapControlsService } from 'app/services/map-controls.service';
import { MapSharedService } from 'app/services/map-shared.service';
import { ResolutionInspectorComponent } from 'app/components/feat-resolution-center/resolution-inspector/resolution-inspector.component';
import { DomainResolutionInspectorComponent } from 'app/components/feat-resolution-center/domain-resolution-inspector/domain-resolution-inspector.component';
import { AfterFlipData, FlipRoadService } from 'app/services/flip-road.service';
import { StoredRecord } from 'app/models/data-index.model';
import { FloatPopupService } from 'app/services/float-popup.service';
import { EditSplitMergeService } from 'app/services/edit-split-merge.service';
import { LineSplitComponent } from 'app/components/feat-edit/line-split/line-split.component';
import { LineMergeComponent } from 'app/components/feat-edit/line-merge/line-merge.component';
import { transform } from 'ol/proj';
import { SocketSidekickService } from 'app/services/socket-sidekick.service';
import { EditFeatureService } from 'app/services/edit-feature.service';

export interface InterLayer {
	name: string;
	type: 'FISHBONE';
	info: {
		addrStdSchema: LayerCategoryStandardSchema[];
		centerlineStdSchema: LayerCategoryStandardSchema[];
		addrCols: EditCardColumn[];
		centerlineCols: EditCardColumn[];
	}
}
export interface CollaborativeLayer {
	name: string;
	id;
	category: LayerCategory; // 'MatchPoint';
	state: LayerLoadState;

	// type?: 'MatchPoint';
}

interface MapLegend {
	text: string;
	className: string;
	tooltip: string;
	isOn?: boolean;
}

interface TableContextmenuItem {
	row: any;
	column: TableColumn;
}
//
interface GetDataOptions {
	gfo?: false | Gfo;
	keepPrevData?: boolean;
	keepPrevColumns?: boolean;
	keepSorts?: boolean;
	keepEditedData?: boolean;
	keepSelectedData?: boolean
}

// Interactive 

		// interface FishboneSpikeDataFeatAttr {
		// 	addNum?;
		// 	fullSt?;
		// 	placeName?;
		// 		// // Road
		// 		// roads: FishboneRoadsAttr[];
		// 	//
		// 	fishboneQaCodes: {
		// 		cd;
		// 		msg;
		// 	};
		// }
		// interface FishboneRoadsAttr {
		// 	fromAddrLeft?;
		// 	fromAddrRight?;
		// 	toAddrLeft?;
		// 	toAddrRight?;
		// 	fullSt?;
		// 	placeName?;
		// }

export interface QaNotes {
	[colProp: string]: {
		cd: string;
		col: string;
		msg: string;
	}[];
}
export interface MapNote {
	cd: string;
	wkt?: string[];
	lab?: string[];
}
export interface SchemaNote {
	cd: string;
	msg: string;
}
export interface RecordExceptions {
	[col: string]: {
		[cd: string]: ExceptionItem
	}
}

@Component({
	selector: 'app-layer-complex',
	templateUrl: './layer-complex.component.html',
	styleUrls: ['./layer-complex.component.css']
})
export class LayerComplexComponent implements OnInit, OnDestroy, AfterViewInit, ComponentCanDeactivate {

	@ViewChild('verticalTabs', { static: false }) verticalTabsComp: FeatureVerticalTabsComponent;
	@ViewChild('resoInspector', { static: false }) resoInspectorComp: ResolutionInspectorComponent;
	@ViewChild('resoDomainInspector', { static: false }) resoDomainInspectorComp: DomainResolutionInspectorComponent;

	//
	@ViewChild('tabTopoCheck', { static: false }) tabTopoCheckTemp;
	@ViewChild('tabDataTable', { static: false }) tabDataTemp;
	@ViewChild('tabDataAddrTable', { static: false }) tabDataAddrTemp;
	@ViewChild('tabDataCenterlineTable', { static: false }) tabDataCenterlineTemp;
	@ViewChild('tabResolutionCenterTable', { static: false }) tabResoCenterTemp;
	@ViewChild('tabResolutionCenter_Domain', { static: false }) tabResoCenterDomainTemp;
	@ViewChild('tabQcFilter', { static: false }) tabQcFilterTemp;
	@ViewChild('tabBatch', { static: false }) tabBatchTemp;
	@ViewChild('tabA3i', { static: false }) tabA3iTemp;
	@ViewChild('tabException', { static: false }) tabExceptionTemp;
	@ViewChild('tabSchemaError', { static: false }) tabSchemaErrorTemp;
	@ViewChild('tabRefDocument', { static: false }) tabRefDocumentTemp;
	disableTabSwitching = false;
	// protectTabSwitch = false;
	//
	@ViewChild('tableContextmenu', { static: false }) tableContextmenu;
	// Table header template
	@ViewChild('featTableHeaderTempl', { static: false }) myLayerDataTableHeaderTempl: TemplateRef<any>;
	@ViewChild('featTableHeaderIconTempl', { static: false }) tableHeaderIconTempl: TemplateRef<any>;
		// Table cell component
	@ViewChild('qcCellTempl', { static: false }) qcCellTempl: TemplateRef<any>;
	// Table error column component such as geom_qc col, topo_qc col
	@ViewChild('geomErrorColumnTempl', { static: false }) geomErrorColumnTempl: TemplateRef<any>;
	// Table fields Describtion tooltip
	@ViewChild('schemaTooltipTempl', { static: false }) schemaTooltipTempl: TemplateRef<any>;
	//
	@ViewChild('fishboneColTempl', { static: false }) fishboneColTemplate: TemplateRef<any>;
	//
	@ViewChild('dataTable', { static: false }) dataTable: CommonDatagridComponent;

	isEdgePoint: boolean;

	showFishboneLayer: boolean; // Affected by selectedLayer
	fishboneSchema: {
		addrStdSchema: LayerCategoryStandardSchema[];
		centerlineStdSchema: LayerCategoryStandardSchema[];
	};
	fishboneColsByModel: {
		[model in ModelMenuItemKey]?: {
			addrCols;
			centerlineCols;
		}
	} = {
		N: {
			addrCols: [],
			centerlineCols: []
		},
		L: {
			addrCols: [],
			centerlineCols: []
		}
	};
	fishboneState: {
		[model in ModelMenuItemKey]?: FishboneState;
	} = {};

	private fishboneMaxReso = 6;
		// private isDrawFishboneBg = false; // Draw fishbone background or not

	//
	defaultGutterSize: number;
	//
	mapSplitRatio = 50;
	mapHideRatio = 2;

	showTable: boolean;
	showRightTabs: boolean;

	tabs: FeatureTab<TabKey>[] = [];
	selectedTab?: FeatureTab<TabKey>;
	isSchemaTab: boolean;
	isA3iTab: boolean;
	hasLayerChangedInSchemaTab: boolean;
	//
	contentKey: ContentMenuLayerItemKey;
	schemaKey: SchemaDefinedByKey;
	modelKey: ModelMenuItemKey;
	hasModelMenu: boolean;
	isMapFilterOn: boolean;
	selectedLayer: AppLayer;
	private prevSelectedLayer: AppLayer;

// Data
	isSample: boolean;
	private isDisplaySample: boolean;
	private isStoredDataSample: boolean;
	private displaySampleLimit = 2100;
	private sampleNum = 2000;

	private isIdOnly: boolean; // When map filter is on, the data retrieved might only have id column
	private isDataAllFields: boolean;
	private latestGetDataStamp; // To mark the latest getData call and only draw the lates on map
	private pauseGettingData = false;

	//
	editModeDisabled: boolean;
	private enableDiscrepancyAgencyRule = true; // If true, under collaborative layers, only feature owned by customer can be edited.
	// Selected customer (can be same as customerId, or one of its children agency id)
	private isTooltipHelpOn: boolean;

	private selectedCustomerId: number;

	private schemas: {
		layerId: any;
		cols: {
			[key in SchemaDefinedByKey]: TableColumn[];
		};
	} = {
		layerId: null,
		cols: {
			standard: null,
			state: null,
			local: null
		}
	};
	private hoverCoordTimeout;
	private mouseoverCellTimeout;
	private resizeTimeout;

// Table
	readonly tableId = 'mainDataTable';
	tableSelectionType: 'multi' | 'single' = 'multi';// = 'single';
	columns: TableColumn[] = [];
	rows: any[] = [];
	selectedRows: any[] = [];
	// Stores the info that vary during to content key / qcFilter /...
	tableInfo: {
		isPaging?: boolean;
		hidePaging?: boolean;
		totalCounts?: number;
		sortType?: string;
		tableSorts?: SortObject[];
		sortColumns?: string[]; 
		onActivate?: (e) => any;
		onPaging?: (e) => any;
		onSelect?: (e) => any;
		onSort?: (e) => any;
		onScroll?: (e) => any;
		onContextmenu?: (e) => any;
		rowClass?: Function;
	} = {};
	pageSize: number;
	private rowsAll: any[] = []; // used when map filter is turned on.
	private pageSizeDefault: number;

// Attr filters
	@ViewChildren('attrFilter') attrFilterComponents: QueryList<CommonColumnFilterComponent>;
	hideAttrFilters: boolean;
	attrFilters: AttrFilter[] = [{
		filter: null
	}];
	//
	editBatchColumns: BatchEditableColumn[] = [];

// Card
	@ViewChild('EditCard', { static: false }) editCardRef: EditCardComponent;
	@ViewChild('EditCardFishboneCenterline', { static: false }) fishboneCenterlineCardRef: EditCardFishboneComponent;
	// cardSelectedRecord;
	// selectedRecord;
	currentCardId;
	recordExceptions: RecordExceptions;

	// editRecordList: any[];
	// Interlayers
	cardSelectedAddr;
	cardSelectedCenterline;
	editAddrList: any[] = [];
	editCenterlineList: any[] = [];
	originAddrList: any[] = [];
	originCenterlineList: any[] = [];
	fishboneOrigin: any[];

// Map
	@ViewChild('dataMap', { static: false }) mapComponent: CommonMapComponent;
	// collaborative
	@ViewChild('BackgroundTooltip', { static: false }) bgTooltipElem;
	@ViewChild('MapContextmenu', { static: false }) mapContextmenu;

	readonly mapElemId = 'data-map';
	readonly bgTooltipElemId = 'map-background-tooltip';


	showPrecisionPlacement = false;
	disableReasonMapEditing = '';
	isMapEditing: boolean; // map editing mode on
	isPickingFeatureInEditing: boolean; // is user picking a feature to edit after begin map editing
	isAddingLabel = false;
	hasRclLabels = false; // Is there any rcl labels on map
	showPolygonEditContextmenu: boolean;
	polygonEditContextmenuText: string;
	isBdryWizardOn: boolean;
	//
	isSplitLine = false;
	isMergeLine = false;

	isTopologyOn: boolean; // is topologyJson layer on
	// isTopoErrorEditing = false;
	isTopoEditing = false;
	topoCheck: TopoCheckOutputExt;
	topoCheckInter: TopoCheckInterLayerOutputExt;

	// private isLayerControlOpen = false;
	//
	private isMapWithinDetailReso: boolean; // Is map extent small enough to get data with details or only id & geom
	private detailReso = 10;
	private mapExtent: number[]; // Store map extent
	private mapReso: number;
	private mapMoveTimeout;
	private qcFlashInterval;
	private mapInfo: {
		selectionLayerNames: string[]; // ol layer name for selection
	};
	private rightClickFeature: Feature;
	public rightClickVertex: number[];
	private rightClickCoord;

	private isProcessingMapMoving: boolean;

	private coordsAtModifystart: any[]; // Store coordinates at modify start
	selectedCoords: {
		x: number;
		y: number;
		unit: 'lat/long' | 'meters'
	} = {
		x: null,
		y: null,
		unit: 'lat/long'
	};
	stateLegends: MapLegend[] = [
		{
			text: 'Unresolved',
			isOn: true,
			className: 'shape-diamond legend-unresolved',
			tooltip: 'unresolved match points'
		}, {
			text: 'Resolved',
			isOn: true,
			className: 'shape-diamond legend-resolved',
			tooltip: 'match points'
		}, {
			text: 'Edited',
			isOn: true,
			className: 'shape-diamond legend-edited',
			tooltip: 'Edited but not saved match points'
		}, {
			text: 'Outside',
			isOn: true,
			className: 'shape-circle legend-other-agency',
			tooltip: 'Match points in other counties'
		}, {
			text: 'Boundary',
			className: 'shape-dashline',
			tooltip: ''
		}
	];

	isSsapRclLinkModeOn: boolean;
	private onMapClick_addressesOnRoad;

	private onMapClick_addLabel;
	private onMapClick_lineSplit;
	private onMapClick_lineMerge;
	isAddingInteractiveFB = false;
	hasInteractiveFishbones = false;
	private onMapClick_addFB: (e) => any;
	isAddingFeature = false;
	private onMapClick_addNewFeat: (e) => any;
		// private onMapClick_addPolygon: (e) => any; // callback function to pass to map click when adding polygon
		// private onMapPointermove_addPolygon: (e) => any; // callback function to pass to map pointermove when adding polygon
	// On select a feature from map in editing mode
	private onMapSelect_editing: (e) => any;
	private pointermoveTimeout;

	private tableClickTimeout;

	private isNavigationStart: boolean;

	isFishboneOn = false;


// Map feature keys
	private attrKey: string;
	// private originDataKey: string;
	private isIdOnlyKey: string;
	private isTopoEditedKey = 'isTopoEdited';
	//
	private isEditedCol: string;
	toDeleteCol: string;
	//
	exceptionColName: string;
	//
	qaNotesColName: string;
	qaErrorLevelColName: string;
	private mapNotesColName: string;
	qaNotesGeomColName: string;
	qaNotesGeomCurrentColName = 'current_selected_geom_err';
	// geomQcColName = 'geom_qc';
	// topoQcColName = 'topo_qc';
	private nguidColName: string;
	private addrLabelColName = 'gad_add_number';
	private geomColName: string;
	geomColName_manual: string;
	private addrGeomColName_manual = 'addrWkt_manual'; // fishbone address wkt
	private fishboneCenterlineIdsColName = 'fb_centerline_ids'; // For fishbone ADDRESS record use to connect centerline
	private fishboneAddrIdColName = 'fb_addr_id'; // For fishbone CENTERLINE record use to connect to address
	private uuidColName: string;
	private discrepancyAgencyIdColName: string;
	private addrFishboneCol: string;

	private fishboneAddrLayerIdCol = 'gad_gly_id';
	private addrUuidCol: string;
	private fishboneRcLayerIdCol: string;
	private rcUuidCol2: string;
	private rcUuidCol: string;
	private rcToAddrLeftCol = 'grd_toaddr_l';
	private rcToAddrRightCol = 'grd_toaddr_r';
	private rcFromAddrLeftCol = 'grd_fromaddr_l';
	private rcFromAddrRightCol = 'grd_fromaddr_r';
	private addrGeomCol = 'gad_geom';

	private schemaDefinedBySub: Subscription;
	private schemaDataSub: Subscription;
	// private viewSub: Subscription;
	private modelSub: Subscription;
	private hoverCoordSub: Subscription;
	private selectedCustomerSub: Subscription;
	private qcFinishSub: Subscription;
	private fbFinishSub: Subscription;
	private attrFilterSub: Subscription;
	private qcFilterInfoSub: Subscription;
	// private editCardsSub: Subscription;
	private fishboneFilterInfoSub: Subscription;
	private interactiveFishboneSub: Subscription;
	private tooltipHelpSub: Subscription;
	private refreshDataSub: Subscription;
	private cancelSub: Subscription;
	private applyAttrFilterSub: Subscription;
	// private layerControlSub: Subscription;
	private layerListSub: Subscription;
	private bgRefLayerUpdateSub: Subscription;
	private bgBdryLayerUpdateSub: Subscription;
	private selectedLayerSub: Subscription;
	// private selectedRecordSub: Subscription;
	private selectedRecordsSub: Subscription;
	private currentCardSub: Subscription;
	private selectedTabSub: Subscription;
	private mapFilterSub: Subscription;
	private mapLabelSub: Subscription;
	private mapAddressesOnRoadModeSub: Subscription;
	private mapEditingSub: Subscription;
	private featMapAddSub: Subscription;
	private zoomToRecordSub: Subscription;
	private flipRoadSub: Subscription;
	private updateExceptionsSub: Subscription;
	private resetFeatureSub: Subscription;
	private rcDrawAdditionalSub: Subscription;
	private splitLineSub: Subscription;
	private splitLineToolSub: Subscription;
	private mergeLineToolSub: Subscription;
	private mergeLineSub: Subscription;
	private showPolygonEditSub: Subscription;
	private bdryWizardSub: Subscription;
	private changeTabSub: Subscription;
	private fishboneControlSub: Subscription;
	private routerEventSub: Subscription;

	constructor(
		@Inject(DOCUMENT) private document: Document,
		private cdRef: ChangeDetectorRef,
		private elemRef: ElementRef,
		private route: ActivatedRoute,
		private router: Router,
		private location: Location,
		private toastr: ToastrService,
		private activityService: ActivityService,
		private appinfoService: AppinfoService,
		private archiveModeService: ArchiveModeService,
		private attrFilterService: AttributeFilterService,
		private attrIndexService: AttrIndexService,
		private commonService: CommonFunctionService,
		private connectService: ArcmapConnectService,
		private contextmenuService: ContextMenuService,
		private cMapService: CommonMapService,
		private commonTemplateService: CommonTemplatesService,
		private editFeatureService: EditFeatureService,
		private mapControlsService: MapControlsService,
		private mapService: MainDataMapService,
		private mapLayerService: MainDataMapLayersService,
		private mapSharedService: MapSharedService,
		private mainDataService: MainDataService,
		private enablePublishLayerService: EnablePublishLayerService,
		private modalService: CommonModalService,
		private demarcationService: DemarcationService,
		private domainService: DomainService,
		private editService: EditService,
		private splitMergeService: EditSplitMergeService,
		private exceptionService: ExceptionService,
		private fieldMappingService: FieldMappingService,
		private fishboneService: FishboneService,
		private flipRoadService: FlipRoadService,
		private floatPopupService: FloatPopupService,
		private gfoService: GfoService,
		private gtoService: GtoService,
		private jstsService: JstsService,
		private layerService: LayerService,
		private qcService: LayerQcService,
		private paneHeaderService: PaneHeaderService,
		private resoCenterService: ResolutionCenterService,
		private resoCenterDomainService: ResolutionCenterDomainService,
		private socketSidekickService: SocketSidekickService,
		private tableService: CommonTableService,
		private tooltipHelpService: TooltipHelpService,
		private topoService: TopoService,
		private userService: UserService
	) { }


// #region Interlayers
		// private async onSelectFishboneLayer() {
		// 	// const isContinue = await this.preventUnsavedEdits();
		// 	// if (!isContinue) {
		// 	// 	this.btnFishbone = !this.btnFishbone;
		// 	// 	return;
		// 	// }
		// 	// this.isFishboneOn = this.btnFishbone;
		// 	const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		// 	const fishboneLayer = this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName];
		// 	dataLayer.setVisible(!this.isFishboneOn);
		// 	fishboneLayer.setVisible(this.isFishboneOn);
		// 	const bgLayer = this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
		// 	const bgStyle = this.isFishboneOn ? this.mapLayerService.getFishboneBgLayerStyle : this.mapLayerService.getDataBgSurroundingLayerStyle;
		// 	bgLayer.setStyle(bgStyle);
		// 	// if (this.isFishboneOn) {

		// 			// // Update view to map
		// 			// if (this.viewKey === 'attr') {
		// 			// 	this.contentLayerService.selectViewFromCode.next('map');
		// 			// }
		// 		//
		// 		this.updateFishboneTableConfig();
		// 		this.updateFishboneMapConfig();
		// 		this.initTabs();
		// 		this.mapService.addFishboneSelectInteraction(fishboneLayer, this.onSelectFromMap_Fishbone);
		// 		// Update filterOptions
		// 		await this.updateFishboneFilterOptions();
		// 		// Fetch data
		// 		if (this.fishboneState[this.modelKey].id === 1) {
		// 			await this.getData();
		// 		} else {
		// 			const data: ConfirmModalData = {
		// 				message: 'Fishbone has not been built yet, would you like to run it now?'
		// 			};
		// 			const rsp = await this.modalService.openModalWindow(ConfirmModalComponent, {
		// 				data: data
		// 			});
		// 			if (rsp) {
		// 				this.qcService.buildFishbone();
		// 			}
		// 		}
		// 	// } else {
		// 	// 	this.contentLayerService.modelOptionBS.next({
		// 	// 		hasAllFields: true
		// 	// 	});
		// 	// 	this.updateMyLayerTableConfig();
		// 	// 	this.initTabs();
		// 	// 	this.mapService.removeFishboneSelectInteraction();
		// 	// 	await this.getData();
		// 	// }
		// }
		// private async updateFishboneFilterOptions(skipGetData?: boolean) {
		// 	const options = await this.mainDataService.getFilterOptions_fishbone(this.layerService.fishboneLayer.layerType);
		// 	const fishboneFilterInfo = this.mainDataService.fishboneFilterInfo.getValue();
		// 	fishboneFilterInfo.selectedLayerFilterOptions = options;
		// 	fishboneFilterInfo.source = null;
		// 	this.mainDataService.fishboneFilterInfo.next(fishboneFilterInfo);
		// }
	private checkHasFishbone() {

		return true;
	}
	private async updateFishboneState(isPopup?: boolean) {
		const fbStateNena = await this.qcService.getFishboneState(this.userService.getCustomerIdByType(), 'N');
		const fbStateLegacy = await this.qcService.getFishboneState(this.userService.getCustomerIdByType(), 'L');
		this.fishboneState = {
			N: fbStateNena,
			L: fbStateLegacy
		};
		if (this.fishboneState.N.id === 1 && this.fishboneState.L.id === 1) {
			const addrLayer = this.layerService.layerListBS.getValue().layers.find(l => l.category && l.category.code === this.attrIndexService.cateCodeAddress);
			const centerlineLayer = this.layerService.layerListBS.getValue().layers.find(l => l.category && l.category.code === this.attrIndexService.cateCodeCenterline);
			const addrStdSchema = await this.fieldMappingService.getStandardSchema(addrLayer.category.id);
			const centerlineStdSchema = await this.fieldMappingService.getStandardSchema(centerlineLayer.category.id);
			this.fishboneSchema = {
				addrStdSchema: addrStdSchema,
				centerlineStdSchema: centerlineStdSchema,
			};
		} else {
			if (isPopup) {
				this.toastr.warning('Fishbone: ' + this.fishboneState[this.modelKey].desc);
			}
		}
	}

	private i_onPaging = async (pageNum: number) => {
		const paging: PagingParam = {
			pageSize: this.pageSize,
			pageNumber: pageNum,
			rowCount: 0
		};
		this.getData(paging, {
			keepPrevColumns: true
		});
	}
	private i_onSortData = async (e) => {
		this.tableInfo.tableSorts = e.sorts;
		if (e.prevValue && e.newValue === 'asc') {
			const idx = this.tableInfo.tableSorts.findIndex(s => s.prop === e.column.prop);
			this.tableInfo.tableSorts.splice(idx, 1);
		}
		this.updateFeatTableSortColumns(this.tableInfo.tableSorts);

		// todo: which call? within map?
		await this.getData({
			rowCount: 1
		}, {
			keepPrevColumns: true
		});
	}

	private highlightFishbones(ids) {
		const layer = this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName];
		this.mapService.map.interactions.selectSingleClick.getFeatures().clear();
		ids.forEach((id) => {
			const feat = layer.getSource().getFeatureById(id);
			if (feat) {
				this.mapService.map.interactions.selectSingleClick.getFeatures().push(feat);
			}
		});
	}

	// private async drawFishbone_mapFilter(features) {
	// 	this.clearLayer(this.fishboneLayerName_map);
	// 	this.drawFishboneRoads(this.mapService.map.addedLayers[this.fishboneLayerName_map]);
	// 	this.mapService.map.addedLayers[this.fishboneLayerName_map].getSource().addFeatures(features);
	// }

	private async getFishbonesWithinMap(isGetRoutes?: boolean, isOverrideFishboneRoads?: boolean) {
		const olMap = this.mapService.map.olMap;
		const extent = olMap.getView().calculateExtent(olMap.getSize());
		const rsp = await this.qcService.getQcInterLayerReportByMap(this.selectedCustomerId, this.layerService.fishboneLayer.layerType, extent);
		let addressFeatures = [];
		let spikeFeatures = [];
		let routes: {layerId; uuids;};
		let fishboneRoads: FishboneRoads;
		if (rsp && rsp.data) {
			const results = this.fishboneService.getFeaturesFromFishboneData(rsp.data);
			addressFeatures = results.addressFeatures;
			spikeFeatures = results.spikeFeatures;
			routes = results.routes;
			// rsp.data.forEach(d => {
			// 	const wkt = d[this.attrIndexService.addrWktCol];
			// 	const geocodeWkt = d[this.attrIndexService.interLayerWktCol];
			// 	const fishboneId = this.getRecordId(d);
			// 	const addrUuid = d[this.addrUuidCol];
			// 	// const rcUuids = d[this.rcUuidCol2];
			// 	const feats = this.fishboneService.createAddressAndSpikeFeatures({
			// 		addrWkt: wkt,
			// 		addrGeocodeWkt: geocodeWkt,
			// 		fishboneId: fishboneId,
			// 		addrUuid: addrUuid,
			// 		attrs: d,
			// 		// attrs: {
			// 		// 	addNum: d[this.addrNumCol],
			// 		// 	fullSt: d[this.fullStCol],
			// 		// 		// roads: rcUuids ? rcUuids.map(recId => {
			// 		// 		// 	return {
			// 		// 		// 		rcRecId: recId
			// 		// 		// 	}
			// 		// 		// }) : [],
			// 		// 	fishboneQaCodes: d[this.qaNotesColName] ? d[this.qaNotesColName] : {}
			// 		// }
			// 	});
			// 	if (feats.spikeFeatures) {
			// 		spikeFeatures = spikeFeatures.concat(feats.spikeFeatures);
			// 	}
			// 	if (feats.addressFeature) {
			// 		addressFeatures.push(feats.addressFeature);
			// 	}
			// 	if (isGetRoutes) {
			// 		// route layer
			// 		const layerId = d[this.fishboneRcLayerIdCol];
			// 		const roadIds = d[this.rcUuidCol2];
			// 		if (layerId && roadIds) {
			// 			routes.layerId = layerId;
			// 			roadIds.forEach(i => {
			// 				if (routes.uuids.indexOf(i) === -1) {
			// 					routes.uuids.push(i);
			// 				}
			// 			});
			// 		}
			// 	}
			// });
		}
		// Check cross bones for features
		this.fishboneService.checkCrossBones(spikeFeatures);
		if (isGetRoutes) {
			fishboneRoads = await this.fishboneService.calcFishboneRoads(routes, isOverrideFishboneRoads);
				// // Update features with roads attrs
				// features.forEach(f => {
				// 	const attrs: FishboneSpikeDataFeatAttr = f.getProperties()[this.fishboneAttrKey];
				// 	if (attrs.roads && attrs.roads.length) {
				// 		attrs.roads.forEach(r => {
				// 			const recId = r.rcRecId;
				// 			const route = fishboneRoads[recId];
				// 			if (route) {
				// 				r.fromAddrLeft = route.attrs.fromAddrLeft;
				// 				r.fromAddrRight = route.attrs.fromAddrRight;
				// 				r.toAddrLeft = route.attrs.toAddrLeft;
				// 				r.toAddrRight = route.attrs.toAddrRight;
				// 				r.fullSt = route.attrs.fullSt;
				// 				r.placeName = route.attrs.placeName;
				// 			}
				// 		});
				// 	}
				// 	const props = {};
				// 	props[this.fishboneAttrKey] = attrs;
				// 	f.setProperties(props);
				// });
		}
		return {
			roads: fishboneRoads,
			spikesFeatures: spikeFeatures,
			addressFeatures: addressFeatures,
			rsp: rsp
		};
	}

	private getFullStNameFromRcData(data) {
		const parts = ['grd_st_premod', 'grd_st_predir', 'grd_st_pretyp', 'grd_st_presep', 'grd_st_name', 'grd_st_postyp', 'grd_st_posdir', 'grd_st_posmod'];
		let fullStName = '';
		parts.forEach(p => {
			if (data[p]) {
				fullStName += data[p].trim() + ' ';
			}
		});
		fullStName = fullStName.trim();
		return fullStName;
	}
	private getPlaceNameFromRcRcData(data) {
		const parts = ['grd_incmuni_l', 'grd_incmuni_r', 'grd_uninccom_l', 'grd_uninccom_r', 'grd_msagcomm_l', 'grd_msagcomm_r', 'grd_postcomm_l', 'grd_postcomm_r'];
		for (const p of parts) {
			if (data[p]) {
				return data[p];
			}
		}
	}
	private clearLayer(layerName) {
		this.mapService.map.addedLayers[layerName].getSource().clear();
	}

//#endregion Interlayers

// #region Address Fishbone
	private drawAddrFishbone() {
		if (this.mapReso > this.mapLayerService.fishboneReso) {
			return;
		}
		const cateCode = this.selectedLayer.category.code;
		if (cateCode !== this.attrIndexService.cateCodeAddress && cateCode !== this.attrIndexService.cateCodeCenterline) {
			return;
		}
		// const dataLayer: VectorLayer<any> = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		// const bgSurroundingLayer = this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
		// const bgRefLayer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
			// const dataFishboneLayer = this.mapService.map.addedLayers[this.mapLayerService.addrFishboneLayerName];
			// const bgFishboneLayer = this.mapService.map.addedLayers[this.mapLayerService.addrBgFishboneLayerName];

		// Store current style & Change style to fishbone, then draw
		// const updateStyle = (olLayer, isBg?: boolean) => {
		// 	if (!olLayer.getProperties()[this.attrIndexService.layerStyleKey]) {
		// 		const props = {};
		// 		props[this.attrIndexService.layerStyleKey] = olLayer.getStyle();
		// 		olLayer.setProperties(props);
		// 	}
		// 	// if (olLayer.getStyle() !== fbStyleFunc) {
		// 	// 	olLayer.setStyle(fbStyleFunc);
		// 	// }
		// 	const styleFunc = (feat, reso) => {
		// 		const styles: any[] = olLayer.getProperties()[this.attrIndexService.layerStyleKey](feat, reso);
		// 		const fbSpikeStyle = this.mapLayerService.getFishboneSpikeStyle(feat, reso, this.modelKey, isBg);
		// 		if (this.mapReso < this.mapLayerService.fishboneReso && fbSpikeStyle) {
		// 			return styles.concat([fbSpikeStyle])
		// 		} else {
		// 			return olLayer.getProperties()[this.attrIndexService.layerStyleKey](feat, reso)
		// 		}
		// 	}
		// 	olLayer.setStyle(styleFunc);
		// }
		// // Address
		// if (cateCode === this.attrIndexService.cateCodeAddress) {
		// 	// updateStyle(dataLayer, (feat, reso) => {
		// 	// 	if (this.mapReso < this.mapLayerService.fishboneReso) {
		// 	// 		const spikeStyle = this.mapLayerService.getFishboneSpikeStyle(feat, reso, this.modelKey);
		// 	// 		return spikeStyle
		// 	// 		// return this.mapLayerService.getFishboneAddressLayerStyle(feat, reso, this.modelKey);
		// 	// 	} else {
		// 	// 		return dataLayer.getProperties()[this.attrIndexService.layerStyleKey](feat, reso)
		// 	// 	}
		// 	// })
		// 	updateStyle(dataLayer)
		// 	updateStyle(bgSurroundingLayer, true);
		// } else { // Centerline
		// 	updateStyle(bgRefLayer, true);
		// }
	}

	// Format fishbone info for features obtained from MVT
	private formatFishboneInfo_map(f: Feature) {
		const fb = f.getProperties()[this.addrFishboneCol];
		if (fb && typeof fb === 'string') {
			const props = {};
			props[this.addrFishboneCol] = JSON.parse(fb);
			if (props[this.addrFishboneCol]) {
				props[this.attrIndexService.fishboneGeocodeCoordsByModelKey] = this.getGeocodeCoordsFromFishboneInfo(props[this.addrFishboneCol]);
			}
			f.setProperties(props);
		}
	}
	// Add fishbone info to feature created from attributes
	private addFishboneInfoToFeature(f: Feature, fbInfo: AddressFishboneInfo) {
		const props = {};
		props[this.addrFishboneCol] = fbInfo;
		if (fbInfo) {
			props[this.attrIndexService.fishboneGeocodeCoordsByModelKey] = this.getGeocodeCoordsFromFishboneInfo(fbInfo);
		}
		f.setProperties(props);
	}
	private getGeocodeCoordsFromFishboneInfo(fbInfo: AddressFishboneInfo) {
		const wktFormat = new WKT;
		const coordsByModel: any = {};
		if (fbInfo.nena && fbInfo.nena.geocode) {
			const addrGeocodeGeomNena = (<Point | MultiPoint>wktFormat.readGeometry(fbInfo.nena.geocode));
			let coords = addrGeocodeGeomNena.getCoordinates();
			if (addrGeocodeGeomNena.getType() === 'Point') {
				coordsByModel.N = [coords];
			} else {
				coordsByModel.N = coords;
			}
		}
		if (fbInfo.legacy && fbInfo.legacy.geocode) {
			const addrGeocodeGeomLegacy = (<Point | MultiPoint>wktFormat.readGeometry(fbInfo.legacy.geocode));
			coordsByModel.L = addrGeocodeGeomLegacy.getCoordinates();
			let coords = addrGeocodeGeomLegacy.getCoordinates();
			if (addrGeocodeGeomLegacy.getType() === 'Point') {
				coordsByModel.L = [coords];
			} else {
				coordsByModel.L = coords;
			}
		}
		return coordsByModel;
	}
	private manuallyTriggerFishboneStyle() {
		this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].changed();
		this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName].changed();
		this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName].changed();
	}
	
// #endregion

// #region Collaborative
	public switchCoordsUnit() {
		let fromProj, toProj
		if (this.selectedCoords.unit === 'lat/long') {
			fromProj = 'EPSG:4326';
			toProj = this.cMapService.mapProj;
			this.selectedCoords.unit = 'meters';
		} else {
			fromProj = this.cMapService.mapProj;
			toProj = 'EPSG:4326';
			this.selectedCoords.unit = 'lat/long';
		}
		if (this.selectedCoords.x && this.selectedCoords.y) {
			const transformed = this.cMapService.mapUtility.transformProjection('POINT', [this.selectedCoords.x, this.selectedCoords.y], fromProj, toProj);
			this.selectedCoords.x = transformed[0];
			this.selectedCoords.y = transformed[1];
		}
	}
	// transform epsg 3857 coords to required selected coords'format
	private updateSelectedCoordsFromXy(coord: number[]) {
		if (!coord) {
			this.selectedCoords.x = null;
			this.selectedCoords.y = null;
			return;
		}
		switch (this.selectedCoords.unit) {
			case 'meters':
				this.selectedCoords.x = coord[0];
				this.selectedCoords.y = coord[1];
				break;
			case 'lat/long':
				const latlong = this.cMapService.mapUtility.transformProjection('POINT', coord, this.cMapService.mapProj, 'EPSG:4326');
				this.selectedCoords.x = latlong[0];
				this.selectedCoords.y = latlong[1];
		}
	}

		// // Update selected table with selectedRecord
		// private updateSelectedRecordFromTable() {
		// 	// if (this.cardSelectedRecord !== this.selectedRows[0]) {
		// 	// 	this.editCardRef.changeSelectedRecord(this.selectedRows[0]);
		// 	// }
		// 	this.cardSelectedRecord = this.selectedRows[0];
		// }

	public onContextmenuPprecisionPlace() {
		this.togglePrecisionPlacement(true);
	}
		// // On change the coords in precise placement dialog
		// public onPrecisePlacement() {
		// 	if (this.cardSelectedRecord) {
		// 		// Update geometry
		// 		const feat = this.mapService.map.addedLayers[this.demarcationService.dmLayerName].getSource().getFeatureById(this.cardSelectedRecord[this.demarcationService.dmIdColumn]);
		// 		if (feat) {
		// 			let coord = [this.selectedCoords.x, this.selectedCoords.y];
		// 			if (this.selectedCoords.unit === 'lat/long') {
		// 				coord = this.cMapService.mapUtility.transformProjection('POINT', coord, 'EPSG:4326', this.cMapService.mapProj);
		// 			}
		// 			coord = this.adjustCoordInsideBdry(coord);
		// 			feat.setGeometry(new Point(coord));
		// 			this.editCardRef.onChange();
		// 			// this need to go after onCHange
		// 			this.onEdgePointGeomChange(coord, feat.getId());
		// 		}
		// 	}
		// }
	public togglePrecisionPlacement(isOn: boolean) {
		this.showPrecisionPlacement = isOn;
	}
	private onEdgePointGeomChange(coord: number[], id) {
		// Check agency
		const parser = this.jstsService.getJstsParser();
		const geomPoint = parser.read(new Point(coord));
		const involvedAgencies = [];
		const tolerance = 500; // Max distance from point to boundary to involve that boundary's agency
		const adjacentBoundaries = this.mapService.map.addedLayers[this.mapLayerService.countyBoundaryLayerName].getSource().getFeatures();
		adjacentBoundaries.forEach(bdry => {
				const geomBdry = parser.read(bdry.getGeometry());
				const distanceOp = new jstsOperation.distance.DistanceOp(geomBdry, geomPoint);
				const distance = distanceOp.distance();
				if (distance <= tolerance) {
					const prop: BoundaryFeatProp = bdry.getProperties();
					involvedAgencies.push(prop.cusId);
				}
		});
		// Update agency
		const record = this.mainDataService.getDataAttrs(id);
		if (record) {
			involvedAgencies.unshift(this.userService.getCustomerIdByType());
			record[this.attrIndexService.epAgencyColumn] = involvedAgencies.join(',');
		}
	}

			// private checkCoordinateOutsideBdry(coord) {
			// 	const bdry = this.mapService.map.addedLayers[this.mapLayerService.countyBoundaryLayerName].getSource().getFeatures()[0];
			// 	if (bdry) {
			// 		const isInside = bdry.getGeometry().intersectsCoordinate(coord);
			// 		debugger
			// 	}
			// }

		// TODO
	private adjustCoordInsideBdry(coord) {
		// Check if coord is outside boundary
		const bdry = this.mapService.map.addedLayers[this.mapLayerService.countyBoundarySelfLayerName].getSource().getFeatures()[0];
		if (bdry) {
			const isOnEdge = bdry.getGeometry().intersectsCoordinate(coord);
			if (!isOnEdge) {
				// return bdry.getGeometry().getClosestPoint(coord);
				const parser = this.jstsService.getJstsParser();
				const geomPoint = parser.read(new Point(coord));
				const geomBdry = parser.read(bdry.getGeometry());
				const distanceOp = new jstsOperation.distance.DistanceOp(geomBdry, geomPoint);
				const points = distanceOp.nearestPoints();
				if (points && points[0]) {
					const nearestPointOnBdry = [points[0].x, points[0].y];
					return nearestPointOnBdry;
				}
			}
		}
		return coord;
	}

	// public async onToggleUnresolvedOnly() {
	// 	await this.getData(null, {
	// 		keepPrevColumns: true,
	// 		keepEditedData: true
	// 	});
	// }
	private getMatchPointAgencyFilter(isOtherAgencyOnly?: boolean) {
		let agencyFilter: ColumnFilter;
		const agencyCol = this.appinfoService.columnMap[this.attrIndexService.epAgencyColumn];
		if (isOtherAgencyOnly) {
			agencyFilter = this.gfoService.getFilter(agencyCol.name, this.appinfoService.filterOperators['not contains'].name, this.userService.getUserInfo().customerId, agencyCol.type);
		} else {
			agencyFilter = this.gfoService.getFilter(agencyCol.name, this.appinfoService.filterOperators.contains.name, this.userService.getUserInfo().customerId, agencyCol.type);

		}
		return agencyFilter;
	}
	private getMatchPointUnresolvedFilter() {
		const unresolvedFilter = this.gfoService.getFilter(
			this.attrIndexService.epResolvedColumn,
			this.appinfoService.filterOperators.eq.name,
			false);
		return unresolvedFilter;
	}
	private onPaging = async (pageNum: number) => {
		if (!this.isMapFilterOn) {
			const paging: PagingParam = {
				pageSize: this.pageSize,
				pageNumber: pageNum,
				rowCount: 0
			};
			await this.getData(paging, {
				keepPrevColumns: true, // keepPrevColumns so that the filter will keep
				keepEditedData: true
			});
		} else {
			const rows = this.getRowsByPageNum(pageNum);
			if (this.isIdOnly) {
				await this.updateRowsDetail(rows);
			}
			this.setRows(rows);
		}
	}
//#endregion Collaborative

// #region Data
	private clearStoredData(keepEdited?: boolean) {
		const dataIndex: {
			[id: string]: StoredRecord
		} = {};
		const editedIds = this.activityService.editRecordListBS.getValue().ids;
		if (keepEdited && editedIds) {
			editedIds.forEach(id => {
				dataIndex[id] = {
					attrs: this.mainDataService.getDataAttrs(id),
					originalAttrs: this.mainDataService.getDataOriginAttrs(id)
				};
			});
		}
		this.mainDataService.replaceDataIndex(dataIndex);
		this.mainDataService.retrievedData = {
			ids: []
		};
	}
	private clearBgSurroundingData() {
		this.mainDataService.wholeBgData = {};
	}
	private async getData(paging?: PagingParam, options?: GetDataOptions) {
		console.log('get data')
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const latestGetDataStamp = uuidv1();
			this.latestGetDataStamp = latestGetDataStamp;
			this.isStoredDataSample = false;
			this.isDisplaySample = false;
			// this.mainDataService.wholeData = {};
			this.clearStoredData(true);
			this.pageSize = this.pageSizeDefault; // this might get changed in getDataByMap
			this.activityService.sqlForBatch = null;

			const selectedLayer = this.selectedLayer;
			options = options || {};
			// if (this.viewKey === 'attr') {
			if (selectedLayer) {
				if (!this.isMapFilterOn) {
					// For layer at SCREEN state
					if (selectedLayer.state.num >= 1.51 && selectedLayer.state.num <= 1.52) {
						await this.getScreenDataByAttr(paging, options, latestGetDataStamp);
					} else if (selectedLayer.state.num >= 1.53) {
						await this.getQcFeatureDataByAttr(paging, options, latestGetDataStamp);
					}
					this.isIdOnly = false;
				} else {
					await this.getDataByMap(options, latestGetDataStamp);
				}
				if (options && options.keepSelectedData) { // (options.keepEditedData || options.keepPrevData)
					await this.selectAfterRetrieveData();
				} else {
					// this.activityService.selectedRecord.next(null);
					this.activityService.selectedRecordsBS.next(null);
				}
			}
	
			this.isDataAllFields = !this.hasModelMenu || this.modelKey === '';
	
			this.manuallyScrollOnTable();

			this.updateIsSample();
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	// Table
	private setTablePaging(totalCount: number) {
		if (!this.dataTable) {
			return;
		}
		if (totalCount && totalCount > 0) {
			this.tableInfo.totalCounts = totalCount;
			//
			this.dataTable.reset(1, totalCount); // TODO: might be problem.
		} else if (totalCount === 0) {
			this.tableInfo.totalCounts = 0;
			this.dataTable.reset(1, totalCount);
		}
	}
	private clearTableSortColumns() {
		this.tableInfo.sortColumns = [];
	}
	private updateFeatTableSortColumns(sorts: SortObject[]) {
		this.tableInfo.sortColumns = sorts.map(s => {
			return s.prop + ' ' + s.dir;
		});
	}
// #endregion

// #region Data
	private getLayerIdFromIdcols(idCols: string[]) {
		// https://stackoverflow.com/questions/4607745/split-string-only-on-first-instance-of-specified-character
		return idCols.find(c => c.split(/_(.+)/)[1] === this.attrIndexService.layerIdColumn);
	}
	private async getFeaturesInMapView(layerIdCol, layerId: string | number | any[], filters: ColumnFilter[], sourceTable, attrList, sql?, primaryKey?, featIdCol?: string, cateCode?: string) {
		// Get features by tiles
		const vtLayer = this.mapService.map.addedLayers[this.mapLayerService.vectorTileRefLayerName];
		const vtSource = vtLayer.getSource();
		const tileGrid = vtSource.getTileGrid();
		const ext = this.mapService.map.olMap.getView().calculateExtent();
		const zoom = Math.floor(this.mapService.map.olMap.getView().getZoom());

		// Gfo
		let layerIdFilter: ColumnFilter;
		if (Array.isArray(layerId)) {
			layerIdFilter = this.gfoService.getFilter(layerIdCol, this.appinfoService.filterOperators.in.name, layerId);
		} else {
			layerIdFilter = this.gfoService.getFilter(layerIdCol, this.appinfoService.filterOperators.eq.name, layerId);
		}
		filters.push(layerIdFilter);
					// // Match point layer
			// if (this.isMatchPoint) {
			// 	// Only get data that involves current agency
			// 	// filters.push(this.getMatchPointAgencyFilter());
			// 	// unresolved -only filter
			// 	if (this.isUnresolvedOnly) {
			// 		filters.push(this.getMatchPointUnresolvedFilter());
			// 	}
			// }
			//
		const results = await this.mapService.getFeaturesFromTileGrid(tileGrid, ext, zoom, sourceTable, filters, attrList, sql, primaryKey);
		let features = results.features;
		// Format fishbone col
		if (cateCode === this.attrIndexService.cateCodeAddress) {
			features.forEach(f => {
				this.formatFishboneInfo_map(f);
			})
		}

		// Filter features with unique id // Because line/polygon features might appear cross tiles and thus obtained more than once, we need to filter out duplicates
		if (featIdCol) {
			const featById = {};
			features.forEach(f => {
				const id = f.getProperties()[featIdCol];
				if (id || id === 0) {
					f.setId(id);
					featById[id] = f;
				}
			});
			features = Object.keys(featById).map(id => featById[id]);
		}
		
		return {
			features: features,
			isSample: results.isSample
			// labelCalc: results.labelCalc
		};
	}
	private async getDataByMap(options?: GetDataOptions, latestStamp?: string) {
		const selectedLayer = this.selectedLayer;
		if (!selectedLayer) {
			return;
		}
		options = options || {};
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			let sourceTable: string, sql: string, primaryKey: string, layerIdCol: string, attrList: string;
			//
			const isIdOnly = !this.isMapWithinDetailReso;
			this.isIdOnly = isIdOnly;
			let sqlFilter;

			const isSchemaLevel = selectedLayer.state.num >= 1.51 && selectedLayer.state.num <= 1.52;
			if (isSchemaLevel) {
				const info = this.editService.layerInfo[selectedLayer.category.code];
				sourceTable = info.sourceTable;
				layerIdCol = info.layerIdCol;
				attrList = isIdOnly ? this.getIdCol() : '*';
			} else {
				const qaCodes = this.mainDataService.getQaCodesFromFilterOptions();
				const gfo = this.getAttrFiltersGfo();
					// TODO
					// if (!this.qcFilterInfo.reportQuery) {
					// 	this.qcFilterInfo.reportQuery = await this.qcService.getQcFeatureReportQuery(selectedLayer.id, qaCodes, gfo, true);
					// }
					// const query = this.qcFilterInfo.reportQuery;
					const query = await this.qcService.getQcFeatureReportQuery(selectedLayer.id, qaCodes, gfo, true, this.hasModelMenu ? this.modelKey : null);
				sql = query.sql;
				sqlFilter = query.sql_filter;
				primaryKey = query.pkey;
				// attrList = this.isMapWithinDetailReso ? '*' : null;
				attrList = isIdOnly ? this.getIdCol() : query.cols;
				// attrList = '*';
				// attrList = 'grd_id';
				layerIdCol = this.getLayerIdFromIdcols(query.cols.split(','));
			}

			const filters: ColumnFilter[] = this.attrFilters.filter(f => f.filter).map(f => f.filter);

			const results = await this.getFeaturesInMapView(layerIdCol, selectedLayer.id, filters, sourceTable, attrList, sql, primaryKey, this.getIdCol(), selectedLayer.category.code);
			const features = results.features;
			this.isStoredDataSample = results.isSample;

			if (latestStamp && latestStamp !== this.latestGetDataStamp) {
				this.commonService.setLoadingSpinner(false, spinnerId);
				return;
			}
			// Store sql
			this.activityService.sqlForBatch = sqlFilter;
			
			// const wktFormat = new WKT();
			const ext = this.mapService.map.olMap.getView().calculateExtent();
			const filtered = features.filter(f => {
				// Filter features within extent
				const geom = f.getGeometry();
				if (!geom.intersectsExtent(ext)) {
					return;
				}
				return true;
			});
			const records = this.mapService.transformFeaturesToStoredRecords(filtered, isIdOnly);
			this.mainDataService.replaceDataIndex(Object.assign(records, this.mainDataService.getDataIndex())); // Update stored records
			const retrievedIds = filtered.map(f => f.getId());
			//
			this.updateSameLocationPoint(filtered);

				// // Set properties for features
				// features.forEach(f => {
				// 	// Filter features within extent
				// 	const geom = f.getGeometry();
				// 	if (!geom.intersectsExtent(ext)) {
				// 		return;
				// 	}
				// 	const properties = f.getProperties() || {};
				// 	if (!properties[this.attrKey]) {
				// 		properties[this.attrKey] = {};
				// 	}
				// 	// Store geom in properties
				// 	properties[this.attrKey][this.geomColName_manual] = wktFormat.writeGeometry(f.getGeometry());
				// 	//
				// 	if (!this.isMapWithinDetailReso) {
				// 		properties[this.attrKey][this.isIdOnlyKey] = true;
				// 	}
				// 	//
				// 	f.setProperties(properties);
				// 	filtered.push(f);
				// });
			//
			const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
			const source = dataLayer.getSource();
			// This should be done before clearing source
			// Add back edited features if needed
			const prevEditedFeatures = [];
			const editedIds = this.activityService.editRecordListBS.getValue().ids;
			if (options.keepEditedData && editedIds.length) {
				// Remove duplicated from the previous edited records (instead of removing from prev edited features since you need keep the edited feature )
				editedIds.forEach(id => {
					const uuid = id;
					const editedFeat = source.getFeatureById(uuid);
					if (editedFeat) {
						prevEditedFeatures.push(editedFeat);
						let featIdx = filtered.findIndex(f => f.getId() === uuid);
						if (featIdx > -1) {
							filtered.splice(featIdx, 1);
						}
					}
				});
			}


			// Update batchFilterCount // This has to go before check isDisplaySample
			if (!results.isSample) {
				this.activityService.batchFilterCount.next({
					count: filtered.length
				});
			} else {
				let gfo: Gfo;
				if (filters && filters.length) {
					gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, filters);
				}
				const count = await this.layerService.getFilterCount(selectedLayer.id, ext, gfo);
				this.activityService.batchFilterCount.next({
					count: count
				});
			}

			// Add features to vector layer
			source.clear();

			let finalFeatsOnMap: Feature[] = filtered;
			if (filtered.length > this.displaySampleLimit) {
				this.isDisplaySample = true;
				finalFeatsOnMap = this.sampleFeatures(filtered);
			}
			source.addFeatures(finalFeatsOnMap);

			//
			let rowsAll: any[];
			const rowsAllStored = retrievedIds.map(id => this.mainDataService.getDataAttrs(id));
			// Update table
			await this.updateColumns([], options, primaryKey, isIdOnly ? attrList : null);
			// This processRows has to go after updateColumns since columns is used in the function
			this.processRows(rowsAllStored);
			rowsAll = rowsAllStored.filter(r => finalFeatsOnMap.find(f => f.getId() === this.getRecordId(r)));
			if (!this.isStoredDataSample && !this.isIdOnly) {
				this.mainDataService.retrievedData = {
					ids: retrievedIds,
					extent: ext
				}

				// const rowsAllStored = await this.handleFeatureProps_dataByMap(filtered, options, primaryKey, isIdOnly ? attrList : null);
				// // Update table
				// // This has to go after the above steps to set feature props under attrKey and handle qaNotes col
				// await this.updateColumns([], options, primaryKey, isIdOnly ? attrList : null);
				// // This processRows has to go after updateColumns since columns is used in the function
				// this.processRows(rowsAllStored);
				// //
				// this.mainDataService.wholeData = {
				// 	feats: filtered, // instead of finalFeatsOnMap
				// 	rows: rowsAllStored,
				// 	extent: ext
				// };
				// rowsAll = rowsAllStored.filter(r => finalFeatsOnMap.find(f => f.getId() === this.getRecordId(r)));
			} else {
				this.mainDataService.retrievedData = {
					ids: retrievedIds
				}
			}

			//
			if (options.keepEditedData) {
				source.addFeatures(prevEditedFeatures);
				// rowsAll = this.editRecordList.concat(rowsAll);
			} else {
				this.clearDataCards();
			}
			this.rowsAll = rowsAll;
			//
			this.setTablePaging(this.rowsAll.length);
			const rows = this.getRowsByPageNum(1);
			if (this.isIdOnly) {
				await this.updateRowsDetail(rows);
			}
			await this.getExceptionsForRows(rows);
			this.setRows(rows);
			this.setColumns(this.columns.map(c => c));
			this.tableService.updateColumnsSmartDisplay(this.rows, this.columns);

			// Get background surrounding/reference/bdry Data
			await this.drawBgSurroundings(this.mapReso);
		} catch (err) {
			this.toastr.error(err.message);
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}

	private getRowsByPageNum(pageNum) {
		return this.tableService.getRowsInPage(pageNum, this.rowsAll, this.pageSize);
	}
	private getPageNumByRowIdx(idx) {
		return Math.floor(idx / this.pageSize) + 1;
	}

	private async handleFeatureProps_dataByMap(feats: Feature[], options?: { keepPrevColumns?: boolean}, primKey?: string, onlyIdColumn?: string) {
		// Store properties under [this.attrKey]
		const rows = [];
		if (feats.length) {
			const excludeAttrs = ['geometry', 'layer', this.attrKey]; // Hard coded the not-used attributes that come in tile feature
			feats.forEach(f => {
				// Move feature attrs under attrKey
				const props = f.getProperties();
				if (!props[this.attrKey]) {
					props[this.attrKey] = {};
				}
				const attrKeys = Object.keys(props);
				attrKeys.forEach(k => {
					if (excludeAttrs.find(a => a.toLowerCase() === k.toLowerCase())) {
						return;
					}
					if (k === this.mapNotesColName || k === this.qaNotesColName) {
						if (props[k]) {
							props[k] = JSON.parse(props[k]);
						}
					}
					props[this.attrKey][k] = props[k];
					delete props[k];
					f.unset(k);
				});
				f.setProperties(props);
				rows.push(f.getProperties()[this.attrKey]);
			});
		}
		return rows;
	}

	private async getScreenDataByAttr(paging?: PagingParam, options?: GetDataOptions, latestStamp?: string) {
		options = options || {};
		const selectedLayer = this.selectedLayer;
		if (!selectedLayer) {
			return;
		}
		// Clear table data
		this.clearTableData({
			keepPrevColumns: options.keepPrevColumns
		});
		// Clear map data
		if (this.mapService.map) {
			this.clearMapData(true, true);
		}
		// Get gfo
		let gfo;
		if (options.gfo === false) {
			gfo = null;
		} else {
			gfo = options.gfo || this.getAttrFiltersGfo();
		}
		this.commonService.setLoadingSpinner(true);
		paging = paging ? paging : { pageSize: this.pageSize };
		paging.pageSize = paging.pageSize ? paging.pageSize : this.pageSize;
		try {
			const rsp = await this.layerService.getLayerContents(selectedLayer.id, gfo, paging, this.hasModelMenu ? this.modelKey : null);

			if (latestStamp && latestStamp !== this.latestGetDataStamp) {
				this.commonService.setLoadingSpinner(false);
				return;
			}
			try {
				if (!options.keepPrevData) {
					await this.setTable_dataByAttr_myLayers(rsp.data, {keepPrevColumns: options.keepPrevColumns});
					this.setTablePaging(rsp.totalCount);
				}
			} catch (err) {
				console.log(err);
			}
			// Update batchFilterCount
			if (paging.rowCount === 1) {
				this.activityService.batchFilterCount.next({
					count: rsp.totalCount
				});
			}
		} catch (err) {
			this.dataTable.reset(1, 0);
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false);
	}
	// Get feature report contents
	private async getQcFeatureDataByAttr(paging?: PagingParam, options?: GetDataOptions, latestStamp?: string) {
		const selectedLayer = this.selectedLayer;
		options = options || {};
		if (!options.keepPrevData) {
			// Clear table data
			this.clearTableData({
				keepPrevColumns: options.keepPrevColumns
			});
			// Clear map data
			if (this.mapService.map) {
				this.clearMapData(true, true);
			}
		}
		if (!options.keepSorts) {
			// Clear sorting
			this.clearTableSortColumns();
		}

		if (!selectedLayer) {
			return;
		}
		// Get gfo
		// Default options of gfo is true and will be obtained from currentFilters
		// If options.gfo is false, pass no gfo
		let gfo;
		if (options.gfo === false) {
			gfo = null;
		} else {
			gfo = options.gfo || this.getAttrFiltersGfo();
		}
		// Get qaCodes
		const qaCodes = this.mainDataService.getQaCodesFromFilterOptions();
			// if (!qaCodes.length) { return; }
		// Call service
		const randomId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, randomId);
		try {
			const rsp = await this.qcService.getQcFeatureReport(selectedLayer.id, qaCodes, gfo, paging, this.tableInfo.sortColumns, this.hasModelMenu ? this.modelKey : null);
			
			if (latestStamp && latestStamp !== this.latestGetDataStamp) {
				this.commonService.setLoadingSpinner(false, randomId);
				return;
			}

			// Store sql
			this.activityService.sqlForBatch = rsp.misc.sql_filter;

			try {
				if (!options.keepPrevData) {
					await this.setTable_dataByAttr_myLayers(rsp.data, {keepPrevColumns: options.keepPrevColumns});
					this.setTablePaging(rsp.totalCount);
				}
			} catch (err) {
				console.log(err);
			}

			// Update batchFilterCount
			if (paging.rowCount === 1) {
				this.activityService.batchFilterCount.next({
					count: rsp.totalCount
				});
			}
		} catch (err) {
			this.dataTable.reset(1, 0);
		}
		this.commonService.setLoadingSpinner(false, randomId);
	}
	//
	private async setTable_dataByAttr_myLayers(data: any[], options?: { keepPrevColumns?: boolean}) {
		// await this.setColumnsAndRows_myLayers(data, options);
		const output = await this.updateColumns(data, options);
		this.mainDataService.addDataToStoredRecords(data, this.getIdCol(), 'prev');
		// Set rows after columns are updated since it's using columns
		this.processRows(data, output.isGetSchema);
		this.setRows(data);
		await this.getExceptionsForRows(data);
		//
		this.tableService.updateColumnsSmartDisplay(this.rows, this.columns);
		setTimeout(() => {
			this.tableService.extendTableFull(this.elemRef, this.tableId, this.columns);			
			this.setColumns(this.columns.map(c => c));
		});
	}
	private updateSameLocationPoint(feats: Feature<Point>[]) {
		if (this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
			if (this.isSample) {
				return;
			}
			const coordList = feats.map(f => {
				const attrs = this.mainDataService.getDataAttrs(f.getId());
				const lat = attrs[this.attrIndexService.addrLatitudeCol];
				const long = attrs[this.attrIndexService.addrLongitudeCol];
				if ((lat || lat === 0) && (long || long === 0)) {
					const coord = transform([long, lat], 'EPSG:4326', 'EPSG:3857');
					return coord;
				} else {
					return null;
				}
			});
			const sortedIndexes = this.mapSharedService.sortPointsAtSameLocation(coordList);
			Object.keys(sortedIndexes).forEach(k => {
				const props = {};
				if (sortedIndexes[k].length > 1) {
					props[this.attrIndexService.sameLocationKey] = feats[sortedIndexes[k][0]].getId();
					sortedIndexes[k].forEach(idx => {
						feats[idx].setProperties(props);
					});
				} else if (sortedIndexes[k].length === 1) {
					props[this.attrIndexService.sameLocationKey] = null;
					feats[sortedIndexes[k][0]].setProperties(props);
				}
			})
		}
	}

	private async updateColumns(data?: any[], options?: { keepPrevColumns?: boolean}, primKey?: string, onlyIdColumn?: string) {
		options = options || {};
		const output = {
			isGetSchema: false
		};
		if (!this.selectedLayer) {
			this.clearTableData(options);
			return output;
		}
		const layer = this.selectedLayer;
		data = data || [];
		// Id column only
		if (onlyIdColumn) {
			if (!primKey) {
				primKey = this.editService.getPrimKeyCol(layer.category.colPrefix);
			}
			//
			if (!options.keepPrevColumns) {
				this.setColumns([this.tableService.setNewColumn(primKey, null, {
					skipGdoCheck: true
				})]);
				this.updateFilterColumns();
				this.updateBatchColumns();
				this.updateColumnsAttr(this.columns);
			}
			// await this.getExceptions();
			return output;
		}
		// All columns
		// If the columns have not been saved before, get and save schema
		if (!this.schemas.cols[this.schemaKey] || this.schemas.layerId !== layer.id) {
			output.isGetSchema = true;
			const existingColumns = this.tableService.setColumnsFromRows(data);
			const columnsByName: {[colName: string]: TableColumn} = existingColumns.reduce((acc, col) => {
				// Take out column prop's prefix
				const prop = col.prop.substring(col.prop.indexOf('_') + 1);
				acc[prop.toUpperCase()] = col;
				return acc;
			}, {});
			const layerCate = layer.category;
			const promiseStdSchema = new Promise<LayerCategoryStandardSchema[]>(async (resolveStd, rejectStd) => {
				if (!layerCate.standardCols) {
					try {
						const stdSchema = await this.fieldMappingService.getStandardSchema(layerCate.id);
						layerCate.standardCols = stdSchema;
						resolveStd(stdSchema);
					} catch (err) {
						rejectStd(err);
					}
				} else {
					resolveStd(layerCate.standardCols);
				}
			});
			const promiseLocalSchema = new Promise<SchemaMappingItem[]>(async (resolveLocal, rejectLocal) => {
				try {
					const mapping = await this.fieldMappingService.getSchemaMapping(layerCate.id);
					resolveLocal(mapping);
				} catch (err) {
					rejectLocal(err);
				}
			});
			await Promise.all([promiseStdSchema, promiseLocalSchema])
			.catch()
			.then((rsp) => {
				// Set standard columns
				const stdColumnsNena: TableColumn[] = []; // Nena standard columns
				const stdColumnsState: TableColumn[] = []; // State standard columns
				rsp[0].forEach((item) => {
					let col = columnsByName[item.colName.toUpperCase()];
					if (!col) {
						col = this.tableService.setNewColumn(`${layer.category.colPrefix}_${item.colName.toLowerCase()}`);
						// Add to columnsByName for future reference (loop rsp[1] and add isMapped attribute)
						columnsByName[item.colName.toUpperCase()] = col;
					}
					// Set column template for data under nena and arizona schema
					
					col.info.tooltip = item.htmlTooltip; //
					// col.info.tooltip = item.desc;
					col.info.standardColName = item.colName;
					col.info.isUppercase = item.isUppercase;
					// col.info.isStdSchema = true; // To separate from the topo/geom cols which will be added later
					col.headerTemplate = this.myLayerDataTableHeaderTempl;
							// Set domains
							// let domain: GivColumnDomain;
							// const nenaDomainValueList = this.editCardService.findNenaDomainValueListByColumn(item.colName);
							// if (nenaDomainValueList && nenaDomainValueList.length) {
							// 	domain = {
							// 		type: 'nena',
							// 		list: nenaDomainValueList,
							// 		colNameNoPrefix: item.colName
							// 	};
							// } else if (item.valueDomainNameNct) {
							// 	const nctDomain = this.editCardService.nctDomains[item.valueDomainNameNct];
							// 	if (nctDomain) {
							// 		domain = {
							// 			type: 'nct',
							// 			list: this.editCardService.getNctDomainValueList(item.valueDomainNameNct, nctDomain), // nctDomain.isNested ? nctDomain.list.map(i => i.value) : nctDomain.list,
							// 			domainName: item.valueDomainNameNct
							// 		};
							// 	} else {
							// 		domain = {
							// 			type: 'nct',
							// 			list: [],
							// 			domainName: item.valueDomainNameNct
							// 		};
							// 	}
							// } else if (item.valuePattern) {
							// 	domain = {
							// 		type: 'pattern',
							// 		pattern: item.valuePattern
							// 	};
							// } else if (item.valueRange) {
							// 	domain = {
							// 		type: 'range',
							// 		range: item.valueRange
							// 	}
							// }
							// col.info.domain = domain;
					col.info.models = item.models;
					col.seq = item.seq;

					//
					if (item.definedBy === 'NENA' || item.definedBy === 'GIV') {
						stdColumnsNena.push(col);
						stdColumnsState.push(col);
					} else {
						stdColumnsState.push(col);
					}
				});
				// Set local columns
				// Local columns consist of 2 parts: mapped columns (from schemaMapping) & unmapped columns (from json in attrs_nstd in data)
				let localColumns: TableColumn[] = [];
				// Set mapped columns
				rsp[1].forEach((item) => {
					const col = columnsByName[item.standardColumn.toUpperCase()];
					if (col) {
						//
						col.info.isMapped = true;
						const clonedCol = Object.assign({}, col);
						clonedCol.name = item.layerColumn;
						localColumns.push(clonedCol);
					}
				});
				// Special qc Columns
				let columns = [];
				// let idx;
				const qaCol = this.tableService.setNewColumn(this.qaNotesColName, this.qaNotesColName); // this.tableService.getColumnByProp(columns, this.qaNotesColName);
				// idx = columns.findIndex(c => c.prop === this.qaNotesColName);
				// if (idx > -1) {
				// 	columns.splice(idx, 1);
				// }
				const mapNotesCol = this.tableService.setNewColumn(this.mapNotesColName, this.mapNotesColName); // this.tableService.getColumnByProp(columns, this.mapNotesColName);
				// idx = columns.findIndex(c => c.prop === this.mapNotesColName);
				// if (idx > -1) {
				// 	columns.splice(idx, 1);
				// }
				const geomQcCol = this.tableService.setNewColumn(this.qaNotesGeomColName, ' ', {
					align: 'C'
				});
				// idx = columns.findIndex(c => c.prop === this.qaNotesGeomColName);
				// if (idx > -1) {
				// 	columns.splice(idx, 1);
				// }
				// Add qa_notes column for download use.
				// qa_notes column should be hidden
				this.tableService.hideColumn(qaCol);
				stdColumnsNena.push(qaCol);
				stdColumnsState.push(qaCol);
				localColumns.push(qaCol);
				columns.push(qaCol);

				this.tableService.hideColumn(mapNotesCol);
				stdColumnsNena.push(mapNotesCol);
				stdColumnsState.push(mapNotesCol);
				localColumns.push(mapNotesCol);
				columns.push(mapNotesCol);
					// // Fishbone col
					// if (layer.category.code === this.attrIndexService.cateCodeAddress) {
					// 	const fishboneCol =  this.tableService.getColumnByProp(columns, this.addrFishboneCol);
					// 	if (fishboneCol) {
					// 		stdColumnsNena.unshift(fishboneCol);
					// 		stdColumnsState.unshift(fishboneCol);
					// 		localColumns.unshift(fishboneCol);
					// 	}
					// }

					// // Move nguid col to front
					// this.tableService.moveColToFront(stdColumnsNena, this.nguidColName, true);
					// this.tableService.moveColToFront(stdColumnsState, this.nguidColName, true);
					// this.tableService.moveColToFront(localColumns, this.nguidColName, true);

				// GeomQc Col before nguid col
				geomQcCol.width = 30;
				geomQcCol.info.skipSmartDisplay = true;
				geomQcCol.info.hideFromEditing = true;
				// geomQcCol.headerTemplate = this.tableHeaderIconTempl;
				columns.push(geomQcCol);
				stdColumnsNena.unshift(geomQcCol);
				stdColumnsState.unshift(geomQcCol);
				localColumns.unshift(geomQcCol);

				const qaErrLevelCol = this.tableService.setNewColumn(this.qaErrorLevelColName, ' ', {
					align: 'C'
				}); // this.tableService.getColumnByProp(columns, this.qaErrorLevelColName);
				// idx = columns.findIndex(c => c.prop === this.qaErrorLevelColName);
				// if (idx > -1) {
				// 	columns.splice(idx, 1);
				// }
				columns.push(qaErrLevelCol);
				columns = columns.concat(stdColumnsState);

				this.processQcColumns(columns);

				// Set unmapped local columns !!!!!!!!!!!!!!!!!!!!!!!!!!!
				// unmapped local cols are added through transformJsonData !!!!!!!!!!!!!!!!!!!!!!
				stdColumnsNena.sort(this.tableService.columnSort);
				stdColumnsState.sort(this.tableService.columnSort);
				localColumns.sort(this.tableService.columnSort);
				// push qaErrLevelCol after sorting
				stdColumnsNena.unshift(qaErrLevelCol);
				stdColumnsState.unshift(qaErrLevelCol);
				localColumns.unshift(qaErrLevelCol);

				this.schemas.layerId = layer.id;
				this.schemas.cols.standard = stdColumnsNena;
				this.schemas.cols.state = stdColumnsState;
				this.schemas.cols.local = localColumns;

				// Update filter columns
				if (!options.keepPrevColumns) {
					this.setColumns(this.filterColumnsByModel());
					this.updateFilterColumns();
					this.updateBatchColumns();
					this.updateColumnsAttr(this.columns);
				}
						// // Set offsetX manually so that table header won't stay at last position
						// this.dataTable.table.offsetX = 0;
			});

		} else {
			this.processQcColumns(this.schemas.cols[this.schemaKey]);

			this.setColumns(this.filterColumnsByModel());
					// // Set offsetX manually so that table header won't stay at last position
					// this.dataTable.table.offsetX = 0;
			// Update filter columns
			if (!options.keepPrevColumns) {
				this.updateFilterColumns();
				this.updateBatchColumns();
				this.updateColumnsAttr(this.columns);
			}
		}
		return output;
	}
	// private setTableSelectionType() {
	// 	if (!this.isSample) {
	// 		this.tableSelectionType = 'multi';
	// 	} else {
	// 		this.tableSelectionType = 'single';
	// 	}
	// }
	private setRows(data) {
		this.rows = data;
		// this.mainDataService.rows = this.rows;
	}
	private setColumns(data) {
		this.columns = data;
		this.mainDataService.currentColumns = this.columns;
	}
	private processRows(data: any[], addJsonbColumns?: boolean) {
		if (!data || !data.length) {
			return;
		}
		const prefix = this.tableService.getTablePrefixByRow(data[0]) || '';
		this.setQaNotesCells(data, prefix);
		// Set attr cols every time data's been updated
		this.mainDataService.unpackJsonbData_myLayers('nstd', data, this.schemas.cols, addJsonbColumns);
		this.mainDataService.unpackJsonbData_myLayers('state', data, this.schemas.cols, addJsonbColumns);
	}
	// Update columns attribute like editable
	private updateColumnsAttr(columns: TableColumn[]) {
		const disabledCols = [this.uuidColName, this.attrIndexService.addrLatitudeCol, this.attrIndexService.addrLongitudeCol, this.attrIndexService.addrFishboneCol];
		if (this.selectedLayer) {
			switch (this.selectedLayer.category.code) {
				case this.attrIndexService.cateCodeMatchPoint:
					disabledCols.push(this.attrIndexService.epAgencyColumn);
					break;
				case this.attrIndexService.cateCodeProvBdry:
					disabledCols.push(this.discrepancyAgencyIdColName);
					break;
			}
		}
		columns.forEach(c => {
			if (disabledCols.indexOf(c.prop) > -1) {
				c.info.isEditDisabled = true;
			} else if (c.info.standardColName === this.attrIndexService.nguidCol) {
				c.info.isEditDisabled = true;
			} else if (this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
				const standardCol = this.selectedLayer.category.standardCols.find(s => s.colName === c.info.standardColName);
				if (standardCol) {
					// Disable fishbone col editing except for address number column in Address layer
					if (standardCol.isFishboneCol && c.prop !== this.attrIndexService.addrAddNumCol) {
						c.info.isEditDisabled = true;
						c.info.isFishbone = true;
					}
				}
			}
		})
	}
	// #region Set columns & rows
		private setQaNotesCells(rows: TableRow[], prefix: string) {
			// Format qa_notes cell for each row
			rows.forEach((row) => {
				// Qa notes
				let notes = row[this.qaNotesColName];
				if (typeof(notes) === 'string') {
					notes = JSON.parse(notes);
				}
				// Transform qa notes to an object with column props as properties
				row[this.qaNotesColName] = {};
				// Empty notes
				if (!notes || !notes.length) { return; }
					// // For geom column and topo column, they don't have prefix and have their names passed in 'col' property
					// const geomQcNotesColName = row[this.geomQcColName] ? row[this.geomQcColName].col : '';
					// const topoNotesColName = row[this.topoQcColName] ? row[this.topoQcColName].col : '';
				notes.forEach((n) => {
					let prop;
					if (n.col === this.qaNotesGeomColName) {
						// Geom column
						prop = n.col;
						if (!row[this.qaNotesGeomColName]) {
							row[this.qaNotesGeomColName] = [];
							row[this.qaNotesGeomCurrentColName] = n;
						}
						row[this.qaNotesGeomColName].push(n);
					} else {
						// Regular columns
						prop = (prefix + '_' + n.col).toLowerCase();
					}
					if (!row[this.qaNotesColName][prop]) {
						row[this.qaNotesColName][prop] = [];
					}
					row[this.qaNotesColName][prop].push(n);
				});
			});
		}
		// Process columns for adding cellClass, cellTemplate and headerTemplate
		private processQcColumns(columns: TableColumn[]) {
			const qcFilterOptions = this.mainDataService.qcFilterInfo.getValue().filterOptions;
			// Find error cell from qa_notes and set cellClass
			columns.forEach((col) => {
				const fixedClass = this.tableService.fixedCellClassToString(col.info.fixedCellClass);
				col.cellClass = (event: { row; column: TableColumn; value; }) => {
					let cellClass = fixedClass;
					const notes: QaNotes = event.row[this.qaNotesColName];
					const colNotes = notes ? notes[col.prop] : null;
					const exceptions = event.row[this.exceptionColName];
					if ((colNotes || (exceptions && exceptions[col.prop])) && qcFilterOptions.length) {
						const qcCellClass = this.qcService.getQcCellClassName(colNotes, exceptions, col.prop, qcFilterOptions);
						if (qcCellClass) {
							cellClass += ' ' + qcCellClass;
						}
					}
					return cellClass;
				};
				// apply template to error columns, apply tooltip template to schema standard fields, and apply cell template to other and error note tooltip
				if (col.prop === this.qaNotesGeomColName) {
					col.cellTemplate = this.geomErrorColumnTempl;
				} else
				if (col.prop === this.nguidColName) {
					col.cellTemplate = this.commonTemplateService.nguidCellTemplate;
					col.width = 40;
					col.info.skipSmartDisplay = true;
				} else if (col.prop === this.uuidColName) {
					col.cellTemplate = this.commonTemplateService.globalIdCellTempl;
					col.width = 40;
					col.info.skipSmartDisplay = true;
					// Manually add model info
					col.info.models = ['L', 'N'];
				} else if (col.prop === this.addrFishboneCol) {
					col.cellTemplate = this.fishboneColTemplate;
					col.width = 60;
					// col.frozenLeft = true;
					col.info.skipSmartDisplay = true;
					// Manually add model info
					col.info.models = ['L', 'N'];
				} else if (col.prop === this.qaErrorLevelColName) {
					col.width = 15;
					col.cellTemplate = this.commonTemplateService.qaErrorLevelCellTempl;
					col.info.skipSmartDisplay = true;
					col.cellClass = (event: { row; column: TableColumn; value; }) => {
						let cellClass = fixedClass;
						const errorLevel = event.row[col.prop];
						cellClass += ' ' + this.qcService.getQcErrorLevelCellClassName(errorLevel);
						return cellClass;
					}
				}
				else {
					col.cellTemplate = this.qcCellTempl;
					//
					const schemaData = this.mainDataService.schemaDataBS.getValue().data;
					const schemaInfo = schemaData.find(i => i[this.attrIndexService.standFieldColName] === col.info.standardColName);
					if (schemaInfo) {
						col.info.schemaErrors = this.mainDataService.getTooltipFromSchemaNotes(schemaInfo[this.attrIndexService.schemaNotesColName]);
					}
				}
			});
		}
			// Note: prefix are obtained at selecting layer now
					// // For QC & Non-QC: Set geom column and record column
					// private setGeomRecCol(row: TableRow) {
					// 	// Get table prefix
					// 	const prefix = this.tableService.getTablePrefixByRow(row) || '';
					// 	// Set geom column name
					// 	this.geomColName = prefix + '_' + this.geomCol;
					// 	// Set id column name
					// 	this.uuidColName = prefix + '_' + this.layerService.globalIdColStandard;
					// }
	private updateColsPrefix(prefix) {
		// Set geom column name
		this.geomColName = prefix + '_' + this.attrIndexService.geomCol;
		// Set id column name
		this.uuidColName = prefix + '_' + this.attrIndexService.globalIdColStandard;
		//
		this.nguidColName = `${prefix}_${this.attrIndexService.nguidCol.toLowerCase()}`;
		//
		this.discrepancyAgencyIdColName = prefix + '_' + this.attrIndexService.discrepancyAgencyIdStandardLower;
	}
	// #endregion
	private onSortQcFeatureData = async (e) => {
		this.tableInfo.tableSorts = e.sorts;
		// if (this.viewKey === 'attr') {
		if (!this.isMapFilterOn) {
			if (e.prevValue && e.newValue === 'asc') {
				const idx = this.tableInfo.tableSorts.findIndex(s => s.prop === e.column.prop);
				this.tableInfo.tableSorts.splice(idx, 1);
			}
			this.updateFeatTableSortColumns(this.tableInfo.tableSorts);
			await this.getData({
				rowCount: 1
			}, { keepSorts: true, keepSelectedData: true });
		} else {
			// TODO
		}
	}
	private onScrollTable = async (e) => {
		if (!this.isMapFilterOn) {
			return;
		}
		if (e.isPageEnd && this.rows.length < this.rowsAll.length) {
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				const nextPage = this.rowsAll.slice(this.rows.length, this.rows.length + this.pageSizeDefault);
				this.pageSize = this.rows.length + nextPage.length;
				await this.updateRowsDetail(nextPage);
				await this.getExceptionsForRows(nextPage);
				this.setRows(this.rows.concat(nextPage));
			} catch (err) {
				console.log(err);
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		}

		// // check if we scrolled to the end of the viewport
		// if (!this.isLoading && offsetY + viewHeight >= this.rows.length * this.rowHeight) {
		// 	// total number of results to load
		// 	let limit = this.pageLimit;

		// 	// check if we haven't fetched any results yet
		// 	if (this.rows.length === 0) {
		// 		// calculate the number of rows that fit within viewport
		// 		const pageSize = Math.ceil(viewHeight / this.rowHeight);

		// 		// change the limit to pageSize such that we fill the first page entirely
		// 		// (otherwise, we won't be able to scroll past it)
		// 		limit = Math.max(pageSize, this.pageLimit);
		// 	}
		// 	this.loadPage(limit);
		// }




		
	}

// #endregion

// #region Select
	private async onSelectLayer_(keepFilters?: boolean) {
		console.log('ooooooooooon SelectLayer_')
		const layer = this.selectedLayer;
		if (!layer) { return; }
		this.updateMyLayerTableConfig();
		this.updateMyLayerMapConfig();
		// Get schema data 
		await this.mainDataService.getSchemaData();
		// Add Background matchpoint layer for centerline layer
		if (layer.category.code === this.attrIndexService.cateCodeCenterline) {
			this.mapLayerService.addBackgroundMatchPointLayer(this.mapService.map);
			this.mapService.addSnapInteractionToBgEdgePoint(this.mapService.map, this.mapLayerService.bgReferenceEdgePointLayerName);
		} else {
			this.mapService.map.removeLayer(this.mapLayerService.bgReferenceEdgePointLayerName);
			this.mapService.removeSnapInteractionFromBgEdgePoint(this.mapService.map);
		}
		await this.updateFilterOptions(null, keepFilters);

		// Do not update data if it's in schema tab
		if (!this.isSchemaTab) {
			// Get data
			await this.updateDataAfterLayerChange();	
		} else {
			this.hasLayerChangedInSchemaTab = true;
		}
		if (layer.state.name === 'TOPOLOGY') { // TOPOLOGY state
			const topoTab = this.tabs.find(t => t.key === 'topoCheck');
			if (!this.selectedTab || this.selectedTab !== topoTab) {
				this.verticalTabsComp.selectTab(this.tabs.indexOf(topoTab));
			}
			const topoCheck = await this.topoService.getTopologizedzedAreasByLayer(layer.id);
			this.topoCheck = topoCheck;
			if (this.topoCheck.overlap.length || this.topoCheck.gap.length || this.topoCheck.crevice.length) {
				this.mapService.addTopoErrorSelectInteraction();
				this.drawTopoCheckResultOnMap(topoCheck);
				this.drawResolvedAreasOnMap(this.topoCheck.resolved_areas);
			}
			// await this.topoService.qcLayerAreaTopo(layer.id);
		} else { // Domain state
			if (layer.state.name === 'DOMAIN' || layer.state.name === 'CONTENT') {
				// Reso center
				const qaResolverFeeds_domain = await this.resoCenterDomainService.getQaResolverFeedsDomain(layer.id, layer.category.code);
				this.resoCenterDomainService.resoFeedDomainBS.next({
					feeds: qaResolverFeeds_domain,
					layerId: layer.id
				});
					// const resocenterDomainTab = this.tabs.find(t => t.key === 'resoCenter_domain');
					// if (!this.selectedTab || this.selectedTab !== resocenterDomainTab) {
					// 	this.verticalTabsComp.selectTab(this.tabs.indexOf(resocenterDomainTab));
					// }
			}
			if (layer.state.name !== 'DOMAIN') {
				const dataTab = this.tabs.find(t => t.key === 'data');
				if (!this.selectedTab || this.selectedTab.hidden || (this.selectedTab === dataTab && !this.currentCardId)) {
					// Select filter tab
					const filterTabIdx = this.tabs.findIndex(t => t.key === 'filterOptions');
					this.verticalTabsComp.selectTab(filterTabIdx);
				}
			}
		}
		this.updateTabsVisibility(); // update tab visibility after getting resoFeedDomain

		// Update url without navigating
		const url = this.router.createUrlTree(['../', layer.id ], {
			relativeTo: this.route
		}).toString();
		this.location.go(url);
		// Organize layers in different orders.
		// Address Point need to put dataLayer on top while others need error/topo layers on top.
		this.mapService.reOrderQcLayers(this.mapService.map, layer);
	}
	private async updateFilterOptions(skipGetData?: boolean, keepSelected?: boolean) {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const layer = this.selectedLayer;
			const qcFilterInfo = this.mainDataService.qcFilterInfo.getValue();
			const options = await this.mainDataService.getFilterOptions(layer.id, qcFilterInfo.isCheckAll);
			// Put the ones with count in the front
			options.feature.sort(this.qcService.sortFilterByCount);
			if (keepSelected && qcFilterInfo.filterOptions) {
				const prevSelected = qcFilterInfo.filterOptions.filter(i => i.isSelected);
				prevSelected.forEach(i => {
					const selected = options.feature.find(op => op.value === i.value);
					if (selected) {
						selected.isSelected = true;
					}
				});
			}
			const newInfo: QcFilterInfo = {
				filterOptions: options.feature,
				source: 'code',
				skipGetData: skipGetData
			};
			if (qcFilterInfo.isCheckAll) {
				newInfo.isCheckAll = true;
			}
			// qcFilterInfo.filterOptions = options.feature;

			// For domain layer, at least one filter should be checked
			if (layer.state.name === 'DOMAIN') {
				if (!newInfo.filterOptions.find(i => i.isSelected)) {
					// Select the smallest count that's not zero
					let min: FilterOption;
					newInfo.filterOptions.forEach(i => {
						if (!i.count) { return; }
						if (!min) {
							min = i;
						} else if (min.count > i.count) {
							min = i;
						}
					});
					if (min) {
						min.isSelected = true;
					}
				}
			}

			// qcFilterInfo.source = 'code';
			// qcFilterInfo.skipGetData = skipGetData;
			this.mainDataService.qcFilterInfo.next(newInfo);
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	private async updateDataAfterLayerChange() {
		await this.getData({
			rowCount: 1
		});
		await this.drawBgRefLayer(this.mapReso);
	}
	private onSelectFromTable = (e, zoomToRec?: boolean) => {
		if (!e.selected[0]) { return; }
		if (!this.selectedLayer) {
			return;
		}
		if (this.isMapEditing) {
			if (!this.isTopoEditing) {
				this.stopMapEditing();
			} else {
				// TODO
			}
		}
		this.activityService.selectedRecordsBS.next({
			ids: e.selected.map(i => this.getRecordId(i)),
			source: 'table',
			zoomToRec: zoomToRec
		});

		// this.fishboneService.getQrInterlayerFishboneInteractiveBySsap(this.userService.customerInfo.id, [e.selected[0].gad_id])
	}
	private async drawRecordsOnMap (recIds: any[], selectedLayer: AppLayer) {
		if (!recIds) {
			return;
		}
		const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName]
		const qcLayer = this.mapService.map.addedLayers[this.mapLayerService.qcErrorLayerName];
		dataLayer.getSource().clear();
		qcLayer.getSource().clear();
		const promises = [];
		recIds.forEach(async id => {
			const attrs = this.mainDataService.getDataAttrs(id);
			if (!attrs) {
				console.log('Attrs not found. id: ', id);
				return;
			}
			let wkt: string = attrs[this.geomColName_manual];
			if (!wkt) {
				const wktPromise = this.layerService.getLayerGeometry(selectedLayer.id, id);
				promises.push(wktPromise);
				const rsp = await wktPromise;
				wkt = rsp.data[0][this.geomColName];
				// Store geom in properties
				this.mainDataService.setDataAttrs(id, this.geomColName_manual, wkt);
				this.mainDataService.setDataOriginAttrs(id, this.geomColName_manual, wkt);
			}
			let label;
			if (selectedLayer && selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
				label = attrs[this.addrLabelColName];
			}
			if (wkt) {
				const feature = this.cMapService.drawDataByWkt(this.mapService.map, [{
					wkt: wkt,
					id: id,
					// props: recInfo.attrs
				}], dataLayer, {
					skipZoomToLayer: true,
					skipClearLayer: true,
					labelArr: [label]
				})[0];
				// Set fishbone info on feature
				if (this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
					this.addFishboneInfoToFeature(feature, attrs[this.addrFishboneCol]);
				}
			} else {
				this.toastr.info('Geometry not found.');
			}
			// Draw if there is geom/topo error
			if (attrs[this.mapNotesColName] && attrs[this.mapNotesColName].length) {
				this.drawMapNotes(attrs);
			}
		});
		await Promise.all(promises);
		// Tell ArcMap to zoom to the area
		// Note: this step should go after map is drawn so that the extent is updated
		this.connectService.noticeArcMap(this.mapService.map);
	}
	private async drawRecOnMap_m (rec, selectedLayer: AppLayer) {
		if (!rec) {
			return;
		}
		let wkt: string = rec[this.geomColName_manual];
		if (!wkt) {
			const rsp = await this.layerService.getLayerGeometry(selectedLayer.id, this.getRecordId(rec));
			// Store geom in properties
			rec[this.geomColName_manual] = rsp.data[0][this.geomColName];
			wkt = rec[this.geomColName_manual];
		}
		const props = {};
		props[this.attrKey] = rec;
		let label;
		if (selectedLayer && selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
			label = rec[this.addrLabelColName];
		}
		if (wkt) {
			const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName]
			this.cMapService.drawDataByWkt(this.mapService.map, [{
				wkt: wkt,
				id: this.getRecordId(rec),
				props: props
			}], dataLayer, {
				skipZoomToLayer: true,
				labelArr: [label]
			});
		} else {
			this.toastr.info('Geometry not found.');
		}
		// Draw if there is geom/topo error
		if (rec[this.mapNotesColName] && rec[this.mapNotesColName].length) {
			this.drawMapNotes(rec);
		}
				// // Zoom to all features on dataLayer, topoDataLayer, and errorDataLayer
				// const extent = createEmpty();
				// this.mapService.map.olMap.getLayers().forEach((layer) => {
				// 	const title = layer.get('layerName');
				// 	if (title === 'dataLayer' || title === 'topoDataLayer' || title === 'errorDataLayer') {
				// 		extend(extent, (<VectorLayer<VectorSource>>layer).getSource().getExtent());
				// 	}
				// });
				// if (this.mapService.map.checkExtentValid(extent)) {
				// 	this.mapService.map.olMap.getView().fit(extent, {
				// 		size: this.mapService.map.olMap.getSize(),
				// 		minResolution: this.cMapService.zoomToLayerMinReso,
				// 		padding: [20, 60, 20, 60]
				// 	});
				// }

		// Tell ArcMap to zoom to the area
		// Note: this step should go after map is drawn so that the extent is updated
		this.connectService.noticeArcMap(this.mapService.map);
	}
	private drawMapNotes(row) {
		const mapNotes: MapNote[] = row[this.mapNotesColName];
		const current = row[this.qaNotesGeomCurrentColName];
		if (mapNotes && current) {
			const mapNote = mapNotes.find(n => n.cd === current.cd);
			if (mapNote && mapNote.wkt) {
				const geoms = mapNote.wkt; // geoms is an array of wkt string
				this.cMapService.drawDataByWkt(
					this.mapService.map,
					geoms.map(g => {
						return {
							wkt: g
						};
					}),
					this.mapService.map.addedLayers[this.mapLayerService.qcErrorLayerName],
					{
					skipZoomToLayer: true,
					labelArr: mapNote.lab
				});
			}
		}
	}
	// private async myLayerdrawBackgroundPointLayer (selectedRow) {
	// 	const mapScale = this.mapService.map.olMap.getView().getResolution();
	// 	if (mapScale < 2) {
	// 		const currentExtent = this.mapService.map.olMap.getView().calculateExtent(this.mapService.map.olMap.getSize());
	// 		const qaNotes: any[] = Object.values(selectedRow[this.qaNotesColName]);
	// 		const isBackgroundPoints = qaNotes.some((col) => col.cd === 'DAD' || col.cd === 'ASQ' );
	// 		if (isBackgroundPoints === true) {
	// 			const layerId = (<MyLayer>this.current.selectedLayer).id;
	// 			const result = await this.layerService.getLayerGeomBoundingBox(layerId, currentExtent);
	// 			const labels = [];
	// 			const points = [];
	// 			if (result) {
	// 				result.forEach((p) => {
	// 					points.push(p.geom);
	// 					labels.push(p.gad_add_number);
	// 				});
	// 			}
	// 			this.cMapService.drawDataByWkt(this.mapService.map, points.map(g => {
	// 				return {
	// 					wkt: g
	// 				};
	// 			}), this.mapService.map.addedLayers[this.bgReferenceLayer], {
	// 				skipZoomToLayer: true,
	// 				labelArr: labels
	// 			});
	// 		}
	// 	}
	// }
	private async getAddressTilesMindist() {
		
	}
	private async drawBgSurroundings(reso: number) {
		const bgLayerName = this.mapLayerService.bgSurroundingsLayerName;
		const bgLayer = this.mapService.map.addedLayers[bgLayerName];
		const layer = this.selectedLayer;
		const cateCode = layer.category.code;
		if (reso > this.mapLayerService.refLayerResolution[cateCode]) {
			return;
		}
		try {
			const ext = this.mapService.map.olMap.getView().calculateExtent();
			let featuresInExt;
			if (this.mainDataService.wholeBgData.extent && containsExtent(this.mainDataService.wholeBgData.extent, ext) && this.mainDataService.wholeBgData.layerId === layer.id) {
				featuresInExt = this.mapService.filterFeaturesInExtent(this.mainDataService.wholeBgData.surroundingFeats, ext);
			} else {
				const info = this.editService.layerInfo[cateCode];
				const sourceTable = info.sourceTable;
				const layerIdCol = info.layerIdCol;
				let attrList = this.layerService.getRefLayerAttrList(cateCode, this.modelKey);
				const idCol = `${info.prefix}_${this.attrIndexService.globalIdColStandard}`;
				if (!attrList) {
					attrList = idCol;
				} else {
					attrList += ',' + idCol;
				}
				// Add fishbone col
				if (cateCode === this.attrIndexService.cateCodeAddress) {
					attrList = this.addrFishboneCol + ',' + attrList
				}
				// let attrList = this.getIdCol();
				// if (layer.category.code === this.attrIndexService.cateCodeAddress) {
				// 	attrList += `,${this.attrIndexService.addrLabelCol}`;
				// } else if (layer.category.code === this.attrIndexService.cateCodeCenterline) {
				// 	attrList += `,${this.attrIndexService.rcIdCol}`;
				// }
		
				const results = await this.getFeaturesInMapView(layerIdCol, layer.id, [], sourceTable, attrList, null, null, this.getIdCol(), cateCode);
				featuresInExt = results.features;
				// Store
				if (!results.isSample) {
					this.mainDataService.wholeBgData = {
						extent: ext,
						surroundingFeats: results.features,
						layerId: layer.id
					}
				}
			}
	
			// const features = featuresInExt;
					// Do not filter out features in data layer because if so, when data layer is cleared the features cleared will be missing from surrounding layer
			// Need to filter. If not filtering, when editing data the original rec of the edited data will show on surrounding layer
			const dataLayerSource = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].getSource();
			const features = featuresInExt.filter(f => { // Filter out features that are in data layer
				if (dataLayerSource.getFeatureById(f.getId())) {
					return false;
				}
				return true;
			});
			const olLayerSource = bgLayer.getSource();
			olLayerSource.clear();
			olLayerSource.addFeatures(features);
		} catch (err) {
			console.log(err);
		}
	}
	private async drawBgSurroundings_fishbone() {
		const spinnerId = uuidv1();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const reso = this.mapReso;
			const withinReso = reso <= this.fishboneMaxReso;
			const isDraw = withinReso && this.fishboneState[this.modelKey] && this.fishboneState[this.modelKey].id === 1;
			if (isDraw) {
				const fishbones = await this.getFishbonesWithinMap(true, false);
				// Fishbone roads are drawn inside the draw function
				this.clearLayer(this.mapLayerService.bgSurroundingsLayerName);
				this.fishboneService.drawFishboneRoads(this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName], fishbones.roads);
				this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName].getSource().addFeatures(fishbones.addressFeatures);

			}
		} catch (err) {
			console.log(err);
			this.toastr.error(err.message);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	private async drawBgRefLayer(reso: number) {
		const refLayer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		const refLayerId = refLayer.getProperties()[this.attrIndexService.refLayerIdKey];
		const cateCode = refLayer.getProperties()[this.attrIndexService.refLayerCodeKey];
		if (!refLayerId) {
			return;
		}
		if ((!this.isBdryWizardOn && reso > this.mapLayerService.refLayerResolution[cateCode]) || (this.isBdryWizardOn && reso > this.mapLayerService.refCenterlineResoAtBdryEdit)) {
			return;
		}
		const ext = this.mapService.map.olMap.getView().calculateExtent();

		const isRefDataWithinExt = this.mainDataService.wholeRefData.extent && containsExtent(this.mainDataService.wholeRefData.extent, ext);
		if (refLayerId === this.mainDataService.wholeRefData.layerId && isRefDataWithinExt && this.mainDataService.wholeRefData.feats) {
			// Filter features in extent
			let filtered = this.mapService.filterFeaturesInExtent(this.mainDataService.wholeRefData.feats, ext);
			const source = refLayer.getSource();
			// Add features to vector layer
			source.clear();
			source.addFeatures(filtered);
		} else {
			const info = this.editService.layerInfo[cateCode];
			const sourceTable = info.sourceTable;
			const layerIdCol = info.layerIdCol;
			let attrList = this.layerService.getRefLayerAttrList(cateCode, this.modelKey);

			const idCol = `${info.prefix}_${this.attrIndexService.globalIdColStandard}`;
			if (!attrList) {
				attrList = idCol;
			} else {
				attrList += ',' + idCol;
			}
			// Add fishbone col
			if (cateCode === this.attrIndexService.cateCodeAddress) {
				attrList = this.addrFishboneCol + ',' + attrList
			}
			//
			const results = await this.getFeaturesInMapView(layerIdCol, refLayerId, [], sourceTable, attrList, null, null, idCol, cateCode);
			const features = results.features;
	
			this.mainDataService.wholeRefData = {
				feats: features,
				layerId: refLayerId,
				extent: ext,
				// labelCalc: results.labelCalc
			};

			refLayer.getSource().clear();
			refLayer.getSource().addFeatures(features);
		}

				// if (cateCode === this.attrIndexService.cateCodeAddress) {
				// const labelCols = attrList.split(',').map(c => c.trim());
				// labelCols.shift(); // remove _id col
				// 	features.forEach(f => {
				// 		const props = f.getProperties();
				// 		let label = '';
				// 		labelCols.forEach(c => {
				// 			if (props[c]) {
				// 				label += props[c] + ' ';
				// 			}
				// 		});
				// 		label = label.slice(0, label.length - 1);
				// 		props[this.attrIndexService.refLayerLabelCol] = label;
				// 		f.setProperties(props);
				// 	})
				// } else if (cateCode === this.attrIndexService.cateCodeCenterline) {
				// 	features.forEach(f => {
				// 		const props = f.getProperties();
				// 		const label = '';





				// 		props[this.attrIndexService.refLayerLabelCol] = label;
				// 		f.setProperties(props);
				// 	})
				// }

	}
	private async drawBgBdryLayer() {
		const bdryLayer = this.isEdgePoint ? this.mapService.map.addedLayers[this.mapLayerService.countyBoundaryLayerName] : this.mapService.map.addedLayers[this.mapLayerService.bgOptionalBdryLayerName];
		const layerInfo: any[] = bdryLayer.getProperties()[this.attrIndexService.bdryLayerInfoKey] || [];
		// const layerIds = [1881];
		const cateCode = bdryLayer.getProperties()[this.attrIndexService.bdryLayerCodeKey];
		const layerIds = layerInfo.filter(l => l.state.num > 1.52).map(l => l.id);
		if (bdryLayer.getVisible() && layerInfo.length) {
			const ext = this.mapService.map.olMap.getView().calculateExtent();
			const isBdryDataWithinExt = this.mainDataService.wholeBgBdryData.extent && containsExtent(this.mainDataService.wholeBgBdryData.extent, ext);
			if (JSON.stringify(layerIds) === JSON.stringify(this.mainDataService.wholeBgBdryData.layerIds) && isBdryDataWithinExt && this.mainDataService.wholeBgBdryData.topoFeats) {
				const source = bdryLayer.getSource();
				// Add features to vector layer
				source.clear();
				source.addFeatures(this.mainDataService.wholeBgBdryData.topoFeats);
			} else {
				const info = this.editService.layerInfo[cateCode];
				const sourceTable = info.sourceTable;
				const layerIdCol = info.layerIdCol;
				const attrList = this.layerService.getRefLayerAttrList(cateCode, this.modelKey);
				//
				const results = await this.getFeaturesInMapView(layerIdCol, layerIds, [], sourceTable, attrList, null, null, this.editService.getPrimKeyCol(info.prefix));
				const features = results.features;
				//
				const geojsonFormat = new GeoJSON();
				const geojson = geojsonFormat.writeFeaturesObject(features);
				const topoFeatures = this.topoService.convertGeojsonToTopoFeatures(geojson);
				this.mainDataService.wholeBgBdryData = {
					extent: ext,
					topoFeats: topoFeatures,
					layerIds: layerIds
				}
				bdryLayer.getSource().clear();
				bdryLayer.getSource().addFeatures(topoFeatures);
			}
		}
	}

	// Reset reference / bdry / county layers
	private resetBgRefLayers() {
		if (!this.selectedLayer) {
			return; // TODO
		}
		const refOlLayer: VectorLayer<any> = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		// Set reflayers visible
		if (!refOlLayer.getVisible()) {
			refOlLayer.setVisible(true);
		}
		//
		let refLayerCode;
		switch (this.selectedLayer.category.code) {
			case this.attrIndexService.cateCodeFishbone:
				// TODO
				break;
			case this.attrIndexService.cateCodeAddress:
				refLayerCode = this.attrIndexService.cateCodeCenterline;
				break;
			case this.attrIndexService.cateCodeCenterline:
				refLayerCode = this.attrIndexService.cateCodeAddress;
				break;
			case this.attrIndexService.cateCodeMatchPoint:
				refLayerCode = this.attrIndexService.cateCodeCenterline;
				// COUNTY layer
				const countyLayer = this.mapService.map.addedLayers[this.mapLayerService.countyBoundaryLayerName];
				if (!countyLayer.getVisible()) {
					countyLayer.setVisible(true);
				} 
				break;
			default:
				if (this.selectedLayer.category.geomType === 'AREA') {
					refLayerCode = this.attrIndexService.cateCodeCenterline;
				}
		}
		this.mapLayerService.setBgRefLayerMaxReso(this.mapService.map, refLayerCode, this.isBdryWizardOn);
		// Update ref layer props
		let layerId;
		const refLayer = this.layerService.layerListBS.getValue().layers.find(l => l.category.code === refLayerCode);
		if (refLayer) {
			if (refLayer.id || refLayer.id === 0) {
				layerId = refLayer.id;
			}
		}
		const props = {};
		props[this.attrIndexService.refLayerCodeKey] = refLayerCode;
		props[this.attrIndexService.refLayerIdKey] = layerId;
		refOlLayer.setProperties(props);
		this.activityService.bgRefLayerChange.next();
	}
	private resetBgBdryLayer(prevLayer: AppLayer | FishboneLayer) {
		if (!this.selectedLayer) {
			return;
		}
		const bdryOlLayer: VectorLayer<any> = this.mapService.map.addedLayers[this.mapLayerService.bgOptionalBdryLayerName];
		const countyOlLayer: VectorLayer<any> = this.mapService.map.addedLayers[this.mapLayerService.countyBoundaryLayerName];
		// Remove previously cate code
		const cateCode = bdryOlLayer.getProperties()[this.attrIndexService.bdryLayerCodeKey];
		if (cateCode === this.selectedLayer.category.code) {
			const prop = {};
			prop[this.attrIndexService.bdryLayerCodeKey] = null;
			prop[this.attrIndexService.bdryLayerInfoKey] = null;
			bdryOlLayer.setProperties(prop);
		}
		// Turn off bdry layer & Turn on county layer for match point
		if (this.selectedLayer.category.code === this.attrIndexService.cateCodeMatchPoint) {
			bdryOlLayer.setVisible(false);
			countyOlLayer.setVisible(true);
			if (!countyOlLayer.getProperties()[this.attrIndexService.bdryLayerInfoKey]) {
				const countyInfo = this.layerService.bdryLayerList.find(l => l.cateCode === this.attrIndexService.cateCodeCounty);
				if (countyInfo && countyInfo.layers) {
					const prop = {};
					prop[this.attrIndexService.bdryLayerCodeKey] = this.attrIndexService.cateCodeCounty;
					prop[this.attrIndexService.bdryLayerInfoKey] = countyInfo.layers;
					countyOlLayer.setProperties(prop);
				}
			}
		} else {
			countyOlLayer.setVisible(false);
			if (prevLayer && prevLayer.isFishbone !== true && prevLayer.category.code === this.attrIndexService.cateCodeMatchPoint) {
				bdryOlLayer.setVisible(true);
			}
		}
	}

// #endregion

// #region Data - fishbone
	async getDataByAttr_fishbone(paging?: PagingParam, options?: {gfo?; keepPrevData?: boolean; keepPrevColumns?: boolean; keepSorts?: boolean}, latestStamp?: string) {
		options = options || {};
		const randomId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, randomId);
		try {
			if (!options.keepPrevData) {
				// Clear table data
				this.clearTableData(options);
				// Clear map data
				if (this.mapService.map) {
					this.cMapService.clearMap(this.mapService.map, [
						this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName]
					]);
				}
			}
			if (!options.keepSorts) {
				// Clear sorting
				this.clearTableSortColumns();
			}
			// Get gfo
			const gfo = options.gfo || null; // TODO
			const qaCodes: string[] = [];
			this.mainDataService.fishboneFilterInfo.getValue().selectedLayerFilterOptions.forEach((o) => {
				if (o.isSelected) {
					qaCodes.push(o.value);
				}
			});
			const rsp = await this.qcService.getQcInterLayerReportByAttr(this.selectedCustomerId, this.layerService.fishboneLayer.layerType, qaCodes, gfo, paging, this.tableInfo.sortColumns);

			if (latestStamp && latestStamp !== this.latestGetDataStamp) {
				this.commonService.setLoadingSpinner(false, randomId);
				return;
			}

			//
			await this.setTable_interlayers(rsp.data, {
				keepPrevColumns: options.keepPrevColumns
			});
			// Set paging
			if (paging && paging.rowCount === 1) {
				this.tableInfo.totalCounts = rsp.totalCount;
				this.dataTable.reset(1, this.tableInfo.totalCounts);
			}
		} catch (err) {
			console.log(err);
			this.dataTable.reset(1, 0);
		}
		this.commonService.setLoadingSpinner(false, randomId);
	}
	private async getDataByMap_fishbone(options?: GetDataOptions, latestStamp?: string) {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const reso = this.mapReso;
			const withinReso = reso <= this.fishboneMaxReso;
			const isDraw = withinReso && this.fishboneState[this.modelKey] && this.fishboneState[this.modelKey].id === 1;
			if (isDraw) {
				const fishbones = await this.getFishbonesWithinMap(true, true);

				if (latestStamp && latestStamp !== this.latestGetDataStamp) {
					this.commonService.setLoadingSpinner(false, spinnerId);
					return;
				}
				// switch (this.viewKey) {
				// 	case 'attr':
				// 		this.clearLayer(this.fishboneBbLayerName);
				// 		this.drawFishboneRoads(this.mapService.map.addedLayers[this.fishboneBbLayerName]);
				// 		// Spikes
				// 		this.mapService.map.addedLayers[this.fishboneBbLayerName].getSource().addFeatures(fishbones.spikesFeatures);
				// 		break;
				// 	case 'map':
	
						// Fishbone roads are drawn inside the draw function
						this.clearLayer(this.mapLayerService.fishboneLayerName);
						this.fishboneService.drawFishboneRoads(this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName], fishbones.roads);
						this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName].getSource().addFeatures(fishbones.addressFeatures);
						this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName].getSource().addFeatures(fishbones.spikesFeatures);
						await this.setTable_interlayers(fishbones.rsp.data, {
							keepPrevColumns: true
						});
	
				// }
			}
				// else if (this.isDrawFishboneBg === true) { // If FishboneBg was drawn, clear it
				// 	this.clearLayer(this.fishboneBbLayerName);
				// 	if (this.viewKey === 'map') {
				// 		this.clearLayer(this.fishboneLayerName_map);
				// 	}
				// }
				// this.isDrawFishboneBg = isDraw;
		} catch (err) {
			console.log(err);
			this.toastr.error(err.message);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	private async setTable_interlayers(data, options?: { keepPrevColumns?: boolean}) {
		if (!data || !data.length) {
			this.clearTableData(options);
			return;
		}
		options = options || {};
		const columns = this.tableService.setColumnsFromRows(data);
		this.setRows(data);
		this.setColumns(columns);
		if (!options.keepPrevColumns) {
			this.updateFilterColumns();
			this.updateBatchColumns();
		}
	}
	// Select layer / record
		// private async onSelectLayer_interlayers() {
		// 	if (!this.selectedLayer) {
		// 		return;
		// 	}
		// 	const options = await this.mainDataService.getFilterOptions_fishbone(this.fishboneLayer.layerType);
		// 	const fishboneFilterInfo = this.mainDataService.fishboneFilterInfo.getValue();
		// 	fishboneFilterInfo.selectedLayerFilterOptions = options;
		// 	fishboneFilterInfo.source = null;
		// 	this.mainDataService.fishboneFilterInfo.next(fishboneFilterInfo);

		// 	await this.getData({
		// 		rowCount: 1
		// 	});
		// }
	private onSelectFromTable_fishbone = async (e) => {
		// Check for edited data
		if (this.editAddrList.find(r => r[this.isEditedCol]) || this.editCenterlineList.find(r => r[this.isEditedCol])) {
			const res = await this.editService.warnOnLeave();
			if (!res) {
				const prevRow = this.rows.find(r => this.getRecordId(r) === this.getRecordId(this.editAddrList[0]));
				this.selectedRows = prevRow ? [prevRow] : [];
				return;
			}
		}
		this.clearLayer(this.mapLayerService.fishboneLayerName);
		const randomId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, randomId);
		try {
			const row = e.selected[0];
			if (row) {
				const addrUuid = row[this.addrUuidCol];
				// Address coord
				let addrWkt = row[this.addrGeomColName_manual];
				if (!addrWkt) {
					let addrLayerId, addrRecId;
					addrLayerId = row[this.fishboneAddrLayerIdCol];
					addrRecId = row[this.addrUuidCol];
					if (addrLayerId && addrRecId) {
						const addrRecordRsp = await this.layerService.getLayerGeometry(addrLayerId, addrRecId);
						if (addrRecordRsp && addrRecordRsp.data && addrRecordRsp.data[0]) {
							const addrRecord = addrRecordRsp.data[0];
							addrWkt = addrRecord[this.addrGeomCol];
							row[this.addrGeomColName_manual] = addrWkt;
						}
					}
				}
				// Address geocode coord
				const addrGeocodeWkt = row[this.attrIndexService.interLayerWktCol];
				//
				let roads: FishboneRoads = {};
				// Road geom
				const rcLayerId = row[this.fishboneRcLayerIdCol];
				const rcUuids = row[this.rcUuidCol2];
				if (rcLayerId && rcUuids && rcUuids.length) {
					roads = await this.fishboneService.calcFishboneRoads({
						layerId: rcLayerId,
						uuids: rcUuids
					});
				}
				// Draw
				this.fishboneService.drawFishboneRoads(this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName], roads); // Don't override this.fishboneService.fishboneRoads here
					// let roadsAttr: FishboneRoadsAttr[] = [];
					// if (roads && rcUuids) {
					// 	rcUuids.forEach(recId => {
					// 		roadsAttr.push(roads[recId].attrs);
					// 	});
					// }
				const fishboneId = this.getRecordId(row);
				const feats = this.fishboneService.createAddressAndSpikeFeatures({
					addrWkt: addrWkt,
					addrGeocodeWkt: addrGeocodeWkt,
					addrUuid: addrUuid,
					fishboneId: fishboneId,
					attrs: row
					// attrs: {
					// 	addNum: row[this.addrNumCol],
					// 	fullSt: row[this.fullStCol],
					// 	placeName: row[this.placeNameCol],
					// 	// roads: roadsAttr,
					// 	fishboneQaCodes: row[this.qaNotesColName] ? row[this.qaNotesColName] : {}
					// }
				});
				if (feats.addressFeature) {
					this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName].getSource().addFeature(feats.addressFeature);
				}
				if (feats.spikeFeatures) {
					this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName].getSource().addFeatures(feats.spikeFeatures);
					this.mapService.map.zoomToLayer(this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName], {
						minReso: this.cMapService.zoomToLayerMinReso
					});
				}
			}
			// Select card
			await this.updateSelectedCard_fishbone(row);

			await this.drawBgSurroundings_fishbone();
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, randomId);
	}

// #endregion

// #region Filters & Tables
	// Table
	private updateMyLayerTableConfig() {
		// const isQcFilter = this.mainDataService.qcFilterInfo.getValue().isQcFilter;
		this.tableInfo = {
			// columnMode: (this.qcFilterInfo.isQcFilter && this.qcFilterInfo.formatKey === 'layer') ? 'force' : 'standard',
			// isPaging: !this.qcFilterInfo.isQcFilter || this.qcFilterInfo.formatKey === 'feature',
			isPaging: !this.isMapFilterOn,
			sortType: 'multi',
			tableSorts: [],
			onActivate: this.onTableActivate,
			onPaging: this.isMapFilterOn ? null : this.onPaging,
			// onSelect: this.onSelectFromTable,
			onSort: this.onSortQcFeatureData, // isQcFilter ? this.onSortQcFeatureData : null,
			onScroll: this.onScrollTable,
			onContextmenu: this.onTableContextmenu,
			rowClass: this.setRowClass
		}
	}
	private updateFishboneTableConfig() {
		this.tableInfo = {
			isPaging: true,
			sortType: 'multi',
			tableSorts: [],
			onSort: this.i_onSortData,
			onScroll: () => {},
			onPaging: this.i_onPaging,
			onSelect: this.onSelectFromTable_fishbone,
			onContextmenu: this.onTableContextmenu
		};
	}
	// Set row class for collaborative layers
	private rowClass_collaborative = (r) => {
		if (r[this.discrepancyAgencyIdColName] !== this.appinfoService.customerProfile.discrepancyAgencyId) {
			return 'disable-row';
		}
		return '';
	}
	private rowClass_current = (r) => {
		if (this.getRecordId(r) === this.currentCardId) {
			return 'current-row';
		}
		return '';
	}
	private setRowClass = (r) => {
		return this.rowClass_current(r);
	}
	private setRowClassCollaborative = (r) => {
		let classes = '';
		classes += this.rowClass_current(r) + ' ';
		classes += this.rowClass_collaborative(r);
	}
	private onTableActivate = (e) => {
		if (e.type === 'click') {
			if (this.tableClickTimeout) { // Double click
				// Clear timeout
				clearTimeout(this.tableClickTimeout);
				this.tableClickTimeout = null;
				// select
				this.onSelectFromTable({
					selected: this.selectedRows
				}, true); // Zoom to record on double click
			} else { // First Click (might be single / double )
				// If single click after timeout
				this.tableClickTimeout = setTimeout(() => {
					this.onSelectFromTable({
						selected: this.selectedRows
					});
					clearTimeout(this.tableClickTimeout);
					this.tableClickTimeout = null;
				}, 500);
			}
		}
	}
	private onTableContextmenu = async (e) => {
		if (e.type === 'body') {
			const event = e.event;
			// Get the column that user right clicked on
			const cellTag = 'DATATABLE-BODY-CELL';
			const rowTag = 'DATATABLE-BODY-ROW';
				// ??? Not working
					// const path = e.event.path;
					// const cellElem = path.find(x => x.tagName === cellTag);
					// const rowElem = path.find(x => x.tagName === rowTag);
			const rowElem = e.event.currentTarget.querySelector(rowTag);
			let count = 0;
			const findParentCellElem = (elem) => {
				if (count > 20) {
					return;
				}
				count++;
				if (elem.tagName === cellTag) {
					return elem;
				} else {
					return findParentCellElem(elem.parentElement);
				}
			}
			const cellElem = findParentCellElem(e.event.target);
			const nodelist = rowElem.querySelectorAll(cellTag);
			const cellArray = Array.from(nodelist);
			const columnIndex = cellArray.indexOf(cellElem);
			//
			const item: TableContextmenuItem = {
				row: e.content,
				column: this.columns[columnIndex]
			};
			this.contextmenuService.show.next({
				event: event,
				contextMenu: this.tableContextmenu,
				item: item
			});
			event.preventDefault();
			event.stopPropagation();
		}
	}
	contextmenuExceptionEnable = (i: TableContextmenuItem) => {
		if (!i) {
			return;
		}
		// const isQcFilter = this.mainDataService.qcFilterInfo.getValue().isQcFilter;
		// if (this.current.contentKey === 'myLayers' && isQcFilter) {
			// TODO: check exception by specific layer and error code
			const notes: QaNotes = i.row[this.qaNotesColName];
			const colQaNotes = notes ? notes[i.column.prop] : null;
			const colExceptions = i.row[this.exceptionColName] ? i.row[this.exceptionColName][i.column.prop] : null;
			if (colQaNotes && colQaNotes.length && (!colExceptions || colQaNotes.find(c => !colExceptions[c.cd]))) {
				const rules = this.mainDataService.qcFilterInfo.getValue().filterOptions;
				if (!!colQaNotes.find(c => !!rules.find(r => r.value === c.cd && r.exceptionAllowed))) {
					return true;
				}
			}
		// }
	}
	async addException(i: TableContextmenuItem) {
		const layer = this.selectedLayer;
		if (!i.row) {
			this.toastr.info('Please select a record');
			return;
		}
		const data: AddExceptionInputData = {
			column: i.column,
			qaNotes: i.row[this.qaNotesColName],
			record: i.row
		};
		const rsp: AddExceptionOutputData = await this.modalService.openModalWindow(AddExceptionModalComponent, {
			data: data,
			width: '600px',
			height: '350px'
		});
		if (rsp) {
			const exceptions = rsp.exceptions;
			const uuid = this.getRecordId(rsp.record);
			const promises = exceptions.map(e => this.exceptionService.addException(layer.id, uuid, e.colName, e.gqrCode, e.reason));
			await Promise.all(promises).then(async () => {
				this.toastr.success('Successfully added.');
				this.activityService.updateExceptionsSubject.next();
				await this.getExceptionsForRec(i.row, true);
					// // Select exception tab
					// const idx = this.tabs.findIndex(t => t.key === 'exception');
					// if (idx > -1 && !this.tabs[idx].hidden) {
					// 	this.verticalTabsComp.selectTab(idx);
					// }
			})
			.catch(err => {
				this.toastr.error(err.message);
			});
		}
	}
	copyNguid(row) {
		const nguid = row[this.nguidColName];
		navigator['clipboard'].writeText(nguid);
	}
	copyGlobalId(row) {
		const uuid = row[this.uuidColName];
		navigator['clipboard'].writeText(uuid);
	}
	async onDeleteException() {
		this.commonService.setLoadingSpinner(true);
		try {
			await this.getExceptionsForRec(this.mainDataService.getDataAttrs(this.currentCardId), true);
			if (this.dataTable) {
				this.dataTable.resize()
			}
		} catch (err) {
			this.toastr.error(err.message);
		}
		this.commonService.setLoadingSpinner(false);
	}
	// Get exceptions for selected record
	private async getExceptionsForRec(rec, isForce?: boolean) {
		const layer = this.selectedLayer;
		if (!rec) {
			// this.exceptions = [];
			return;
		}
		const recId = this.getRecordId(rec);
		// Find the table row
		const uuids = [recId];
		const row = this.rows.find(r => this.getRecordId(r) === uuids[0]);
		if (!row) {
			console.log('cannot find row with id: ' + uuids[0]);
			return;
		}
		if (!isForce && row[this.exceptionColName]) {
			return;
		}
		try {
			const exceptions = await this.exceptionService.getExceptions(layer.id, uuids);
			exceptions.forEach(exc => {
				// const rec = this.cardSelectedRecord; //this.rows.find(r => this.getRecordId(r) === exc.recordUuid);
				exc.value = rec[exc.colName];
			});
			// this.exceptions = exceptions;

			// Remove prev exceptions from row
			const recordExceptions: RecordExceptions = {};
			row[this.exceptionColName] = recordExceptions;
			this.mainDataService.setDataAttrs(recId, this.exceptionColName, recordExceptions);
			// Add exceptions to row
			exceptions.forEach(e => {
				if (!recordExceptions[e.colName]) {
					recordExceptions[e.colName] = {};
				}
				recordExceptions[e.colName][e.gqrCode] = e;
			});
		} catch (err) {
			console.log(err);
		}
	}
	private async getExceptionsForRows(rows: any[]) {
		const layer = this.selectedLayer;
		const uuids = [];
		rows.forEach(r => {
			uuids.push(this.getRecordId(r));
			// Remove prev exceptions from row
			r[this.exceptionColName] = {};
		});
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const exceptions = await this.exceptionService.getExceptions(layer.id, uuids);
			exceptions.forEach(exc => {
				const rec = rows.find(r => this.getRecordId(r) === exc.recordUuid);
				exc.value = rec[exc.colName];
				// Add exceptions to row
				// if (!rec[this.exceptionColName][exc.colName]) {
					rec[this.exceptionColName][exc.colName] = {};
				// }
				rec[this.exceptionColName][exc.colName][exc.gqrCode] = exc;
			});
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	// Clear current exceptions
	private clearExceptions() {
		this.recordExceptions = null;
		// this.exceptions = [];
		this.rows.forEach(r => {
			r[this.exceptionColName] = null;
			// this.mainDataService.dataIndex[this.getRecordId(r)].attrs[this.exceptionColName] = null;
		})
	}
	// Not using common-table's clearTableData function since there're multiple table sharing columns/rows here
	private clearTableData(options?: {keepPrevColumns?: boolean; }) {
		options = options || {};
		this.setColumns([]);
		this.setRows([]);
		// this.exceptions = [];
		this.selectedRows = [];
		if (!options.keepPrevColumns) {
			this.updateFilterColumns();
			this.updateBatchColumns();
		}
	}

	private getAttrFiltersGfo() {
		return this.gfoService.getGfo(
			this.gfoService.filterLogics.and,
			this.attrFilters.filter(f => f && f.filter).map(f => f.filter),
			null,
			null
		);
	}
	// Update filter columns
	private updateFilterColumns() {
		let attrFilterColumns = [];
		if (this.columns) {
			attrFilterColumns = this.columns.filter((c) => {
				if (!this.appinfoService.columnMap[c.prop]) {
					return false;
				}
				if (c.prop === this.uuidColName || c.prop === this.nguidColName) {
					return true;
				}
				if (this.schemaKey !== 'local') {
					return c.isDisplay !== false && c.info.isMapped; // Only display mapped columns for NENA/state schema
				} else {
					return c.isDisplay !== false;
				}
			});
		}
		this.attrFilterService.attrFilterColumns.next(attrFilterColumns);
	}
	private updateBatchColumns() {
		if (this.columns) {
			const removedColNames = [this.uuidColName, this.attrIndexService.addrFishboneCol];
			this.editBatchColumns = this.columns.filter(c => c.type && removedColNames.indexOf(c.prop) === -1).map(c => {
				return {
					prop: c.prop,
					name: c.name,
					type: this.appinfoService.findGeneralCol(c.type),
					standardName: c.info.standardColName,
					// domain: c.info.domain,
					hideFromEditing: c.info.hideFromEditing,
					isUppercase: c.info.isUppercase
				}
			});
			// TODO: remove columns like objectid, globalid, qa_notes, etc.
		}
	}
	private filterColumnsByModel() {
		const cols = this.schemas.cols[this.schemaKey] || [];
		if (this.schemaKey === 'local' || !this.hasModelMenu || this.modelKey === '') {
			return cols;
		} else {
			return cols.filter(c => c.info.models && c.info.models.indexOf(this.modelKey) > -1);
		}
	}
	//
	onSchemaDataChange() {
		if (!this.selectedLayer) { return; }
		this.setColumns(this.filterColumnsByModel());
			// // If QC
			// const isQcFilter = this.mainDataService.qcFilterInfo.getValue().isQcFilter;
		// if (this.current.contentKey === 'myLayers' && isQcFilter) {
			// highlight the error cells on original data table
			this.processQcColumns(this.columns);
		// }
		//
		this.updateFilterColumns();
		this.updateBatchColumns();
		this.updateColumnsAttr(this.columns);
		if (this.selectedRows.length) {
			const updatedSelRow = this.rows[this.selectedRows[0].$$index]; // TODO
			this.selectedRows = [updatedSelRow];
		}
	}
	
	getCellTooltip(row, column, force?: boolean) {
		if (this.isTooltipHelpOn && !force) {
			return '';
		}
		const qaNotes: QaNotes = row[this.qaNotesColName];
		let tooltip = this.mainDataService.getTooltipFromQaNotes(qaNotes, column.prop);
		// if (qaNotes && qaNotes[column.prop]) {
		// 	qaNotes[column.prop].forEach((i, idx) => {
		// 		if (i.msg) {
		// 			tooltip += i.msg + (idx === qaNotes[column.prop].length - 1 ? '' : '\n');
		// 		}
		// 	});
		// }
		if (!tooltip) {
			tooltip = row[column.prop];
		}
		return tooltip;
	}
	// Only update lastTooltips if the mouse is hovering over the cell more than 1 second
	onMouseoverErrorCell(row, column: TableColumn) {
		this.mouseoverCellTimeout = setTimeout(() => {
			// const tooltip = this.getCellTooltip(row, column, true);
			const qaNotes: QaNotes = row[this.qaNotesColName];
			const codes = [];
			if (qaNotes && qaNotes[column.prop]) {
				qaNotes[column.prop].forEach(i => {
					codes.push(i.cd);
				});
			}
			this.tooltipHelpService.lastTooltipsBS.next({
				codes: codes
			});
		}, this.tooltipHelpService.delayTime);
	}
	onMouseoutErrorCell() {
		if (this.mouseoverCellTimeout) {
			clearTimeout(this.mouseoverCellTimeout);
		}
	}
// #endregion

// #region Select Layer / record / customer
	// TODO
	async onChangeCustomer() {
		// Check editable
		this.editModeDisabled = !!this.editService.checkEditModeDisabled();
		// Update layerList no matter under which content // So that when switch to interlayers, the correct layerList will be ready for use
		await this.updateLayerList();
		await this.updateFishboneState();
	}
	private async onSelectLayer(keepFilters?: boolean) {
		// Check edited data
		const isContinue = await this.preventUnsavedEdits();
		if (!isContinue) {
			this.selectedLayer = this.prevSelectedLayer;
			this.activityService.selectedLayerBS.next({
				layer: this.selectedLayer,
				source: 'onSelectLayer'
			});
			return;
		}
		// this.clearDataCards();
		this.clearMapData();
		this.attrFilterService.clearAttrFilters(true);
		this.topoCheck = null;

		// Update prev layer
		const prevTemp = this.prevSelectedLayer;
		this.prevSelectedLayer = this.selectedLayer;
			// // Fishbone
			// if (this.selectedLayer && this.selectedLayer.isFishbone) {
			// 	this.isFishboneOn = true;
			// 	if (this.modelKey === '') {
			// 		this.mainDataService.modelBS.next('N');
			// 	}
			// 	this.mainDataService.modelOptionBS.next({
			// 		hasAllFields: false
			// 	});
			// } else if (prevTemp && prevTemp.isFishbone) { // turn off fishbone
			// 	this.isFishboneOn = false;
			// 	this.mainDataService.modelOptionBS.next({
			// 		hasAllFields: true
			// 	});

			// 	// TODO
			// 	this.mapService.removeFishboneSelectInteraction();
			// }
		
		// Get schema // Update layer columns 
		if (this.selectedLayer && this.selectedLayer.category) {
			if (!this.selectedLayer.category.standardCols) {
				this.selectedLayer.category.standardCols = await this.fieldMappingService.getStandardSchema(this.selectedLayer.category.id);
			}
			this.updateColsPrefix(this.selectedLayer.category.colPrefix);
		}
		// Update table class
		if (this.selectedLayer && this.selectedLayer.category.isCollaborative) {
			this.tableInfo.rowClass = this.setRowClassCollaborative;
		} else {
			this.tableInfo.rowClass = this.setRowClass;
		}
		// reset layerStyle // This is to clear any fishbone style
		const resetStyle = (olLayer) => {
			const storedStyle = olLayer.getProperties()[this.attrIndexService.layerStyleKey];
			if (storedStyle && storedStyle !== olLayer.getStyle()) {
				olLayer.setStyle(storedStyle);
			}
		}
		const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		const surroundingLayer = this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
		const refLayer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		resetStyle(dataLayer);
		resetStyle(surroundingLayer);
		resetStyle(refLayer);

		// Set reference layer
		this.resetBgRefLayers();
		// Set bdry layer
		this.resetBgBdryLayer(prevTemp);
		// surrounding layer
		if (this.selectedLayer) {
			this.mapLayerService.setBgSurroundingsLayerMaxReso(this.mapService.map, this.selectedLayer.category.code);
		}
		
		// Update model

		if (this.selectedLayer && (this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress || this.selectedLayer.category.code === this.attrIndexService.cateCodeCenterline)) {
			this.hasModelMenu = true;
		} else {
			this.hasModelMenu = false;
		}

		this.isEdgePoint = false;
		if (this.selectedLayer) {
			// Check isMatchPoint
			if (this.selectedLayer.category.code === this.attrIndexService.cateCodeMatchPoint) {
				this.isEdgePoint = true;
				// Get county boundary
				try {
					//
					const countyLayer = this.mapService.map.addedLayers[this.mapLayerService.countyBoundaryLayerName];
					const info = this.layerService.layerListBS.getValue().layers.find(l => l.category.code === this.attrIndexService.cateCodeCounty);
					if (info.id && !countyLayer.getSource().getFeatures().length) {
						const rsp = await this.layerService.getLayerContents(info.id);




						// TODO




						// const discAgencyId = this.appinfoService.customerProfile.discrepancyAgencyId_edgePoint;
	
					}
					// // Note: !!!this is only for MatchPoint bdry use. For other NENA layer use Discrepancy Agency!!!
					// const data = await this.layerService.getCustomerBoundaryGeom();
					// this.mapService.addBoundaryFeature(data, this.mapService.map);
					// this.mapService.map.zoomToLayer(this.mapService.map.addedLayers[this.mapLayerService.countyBoundarySelfLayerName]);
				} catch (err) {
					console.log(err);
				}
			} 
			// else if (this.selectedLayer.category.code === this.attrIndexService.cateCodeProvBdry) {
			// 	// Zoom to discrepancy agency
			// 	if (this.selectedLayer.category.code === this.attrIndexService.cateCodeProvBdry) {
			// 		const discAgencyId = this.appinfoService.customerProfile.discrepancyAgencyId;
			// 		const gfo = this.gfoService.getGfo(
			// 			this.gfoService.filterLogics.and,
			// 			[this.gfoService.getFilter(this.discrepancyAgencyIdColName, this.appinfoService.filterOperators.eq.name, discAgencyId)])
			// 		const rsp = await this.layerService.getLayerContents(this.selectedLayer.id, gfo);
			// 		if (rsp.data[0]) {
			// 			const geomRsp = await this.layerService.getLayerGeometry(this.selectedLayer.id, this.getRecordId(rsp.data[0]));
			// 			const wkt = geomRsp.data[0][this.geomColName];
			// 			const feat = this.cMapService.createFeatureByWkt(wkt);
			// 			const featExtent = feat.getGeometry().getExtent();
			// 			this.mapService.map.olMap.getView().fit(featExtent, {
			// 				padding: [20, 20, 20, 20]
			// 			});
			// 		}
			// 	}
			// }
		}

			// if (!this.isFishboneOn) {
			// 	await this.onSelectLayer_(keepFilters);
			// } else {
			// 	await this.onSelectFishboneLayer();
			// }
		await this.onSelectLayer_(keepFilters);

		if (!this.selectedLayer) {
			this.clearTableData();
			this.setTablePaging(0);
		}
	}
		// showAdditionalError() {
		// 	if (this.current.additionalErrorTempl) {
		// 		const data: ModalAdditionalErrorData = {
		// 			title: this.selectedLayer.name,
		// 			template: this.current.additionalErrorTempl
		// 		}
		// 		this.modalService.openModalWindow(ModalAdditionalErrorComponent, {
		// 			height: '80%',
		// 			width: '800px',
		// 			data: data
		// 		});
		// 	}
		// }

		// clickAttrFilter() {
		// 	this.attrFilterService.openAttrFilter(FeatAttributeFiltersPopupComponent);
		// }

	// Add/Remove selection to map from somewhere else
	private async selectRecordsOnMap(ids: (string | number)[], layer?, skipUpdateDetail?: boolean) {
		let select;
		let editLayer;
		if (this.isTopologyOn) {
			layer = layer || this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName];
			select = this.mapService.topoSelectInteraction;
		} else {
			layer = layer || this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
			select = this.mapService.dataSelectInteraction;
		}
		editLayer = this.mapService.map.addedLayers[this.mapLayerService.dataModifyLayerName];
		select.getFeatures().clear();
		const selectedFeats = [];
		const detailPromises = [];
		ids.forEach((id) => {
			let feat = layer.getSource().getFeatureById(id);
			if (!feat) {
				// Check if the record is on modify layer
				if (this.isMapEditing) {
					feat = editLayer.getSource().getFeatureById(id);
				}
			}
			if (feat) {
				select.getFeatures().push(feat);
				selectedFeats.push(feat);
				const attrs = this.mainDataService.getDataAttrs(id);
				if (!skipUpdateDetail && attrs && attrs[this.isIdOnlyKey]) {
					detailPromises.push(this.updateFeatureDetail(feat.getId()));
				}
			} else {
				console.log('No feature found with id: ' + id);
			}
		});
		// Update feature details
		if (!skipUpdateDetail) {
			await Promise.all(detailPromises);
		}
		return selectedFeats;
	}
	// Select fishbone Address OR Centerline
	private selectFishboneFeatureOnMap(addrId?: string, centerlineIds?: string[], keepPrevSelected?: boolean) {
		const layer = this.mapService.map.addedLayers[this.mapLayerService.fishboneLayerName];
		if (!keepPrevSelected) {
			this.mapService.fishboneSelectInteraction.getFeatures().clear();
		}
		if (addrId) {
			const feat = layer.getSource().getFeatureById(addrId);
			if (feat) {
				this.mapService.fishboneSelectInteraction.getFeatures().push(feat);
			} else {
				console.log('No address feat found with id: ' + addrId);
			}
		}
		if (centerlineIds && centerlineIds.length) {
			centerlineIds.forEach(id => {
				const feat = layer.getSource().getFeatureById(id);
				if (feat) {
					this.mapService.fishboneSelectInteraction.getFeatures().push(feat);
				} else {
					console.log('No centerline feat found with id: ' + addrId);
				}
			});
		}
	}
	private selectRecordOnTable_(id, fishboneIdType?: FishboneCardType, skipAddToTable?: boolean) {
		let rowIdx = -1;
		const selected = [];
		if (id || id === 0) {
				// if (!this.isFishboneOn) {
				// 	rowIdx = this.rows.findIndex(r => this.getRecordId(r) === id);
				// } else {
				// 	if (fishboneIdType === 'centerline') {
				// 		rowIdx = this.rows.findIndex(r => r[this.rcUuidCol2] && r[this.rcUuidCol2].indexOf(id) > -1);
				// 	} else if (fishboneIdType === 'addr') {
				// 		rowIdx = this.rows.findIndex(r => r[this.addrUuidCol] === id);
				// 	} else {
				// 		rowIdx = this.rows.findIndex(r => this.getRecordId(r) === id);
				// 	}
				// }
			rowIdx = this.rows.findIndex(r => this.getRecordId(r) === id);
			if (rowIdx === -1 && this.isMapFilterOn) { // If map filter is on, the selected row might be in other pages
				const rowsAllIdx = this.rowsAll.findIndex(r => this.getRecordId(r) === id);
				if (rowsAllIdx > -1) {
					const row = this.rowsAll[rowsAllIdx];
					this.setRows([row].concat(this.rows));
					rowIdx = 0;
					// Keep the row in rowsAll at the same position as in rows
					this.rowsAll.splice(rowsAllIdx, 1);
					this.rowsAll.unshift(row);
					// const pageNum = this.getPageNumByRowIdx(rowsAllIdx);
					// this.dataTable.reset(pageNum, this.dataTable.totalNum);
					// const rows = this.getRowsByPageNum(pageNum);
					// this.setRows(rows);
					// rowIdx = this.rows.findIndex(r => this.getRecordId(r) === id);
				}
			}
		}
		if (rowIdx > -1) {
			selected.push(this.rows[rowIdx]);
			this.dataTable.scrollRowIntoView(rowIdx, this.rows.length);
		}
		this.selectedRows = selected;
	}
	// Add/Remove selection to table
	private selectRecordOnTable(id, keepPrevSelection?: boolean, skipScrollToView?: boolean) {
		let rowIdx = -1;
		let selected = keepPrevSelection ? this.selectedRows : [];
		if (id || id === 0) {
			rowIdx = this.rows.findIndex(r => this.getRecordId(r) === id);
			// if (rowIdx === -1 && this.isMapFilterOn) { // If map filter is on, the selected row might be in other pages
				const rowsAllIdx = this.rowsAll.findIndex(r => this.getRecordId(r) === id);
				if (rowsAllIdx > -1) {
					let row;
					if (rowIdx === -1) {
						row = this.rowsAll[rowsAllIdx];
						this.setRows([row].concat(this.rows));
					} else {
						row = this.rows[rowIdx];
						this.rows.splice(rowIdx, 1);
						this.setRows([row].concat(this.rows));
					}
					rowIdx = 0;
					// Keep the row in rowsAll at the same position as in rows
					this.rowsAll.splice(rowsAllIdx, 1);
					this.rowsAll.unshift(row);
					// const pageNum = this.getPageNumByRowIdx(rowsAllIdx);
					// this.dataTable.reset(pageNum, this.dataTable.totalNum);
					// const rows = this.getRowsByPageNum(pageNum);
					// this.setRows(rows);
					// rowIdx = this.rows.findIndex(r => this.getRecordId(r) === id);
				}
			// }
		}
		if (rowIdx > -1) {
			// selected.push(this.rows[rowIdx]);
			if (!skipScrollToView) {
				this.dataTable.scrollRowIntoView(rowIdx, this.rows.length);
			}
			if (selected.indexOf(this.rows[rowIdx]) === -1) {
				selected.push(this.rows[rowIdx]);
			}
		}
		this.selectedRows = selected;
	}
	private selectRecordsOnTable(ids: any[], keepPrevSelection?: boolean) {
		if (!keepPrevSelection) {
			this.selectedRows = [];
		}
		ids.forEach(id => {
			this.selectRecordOnTable(id, true, true);
		});
		// Scroll last id to view
		if (ids.length) {
			const rowIdx = this.rows.findIndex(r => this.getRecordId(r) === ids[ids.length - 1]);
			if (rowIdx > -1) {
				this.dataTable.scrollRowIntoView(rowIdx, this.rows.length);
			}
		}
	}
	private clearSelection() {
		this.selectRecordOnTable(null);
		this.selectRecordsOnMap([]);
	}
// #endregion

// #region Tabs / Card
	private initTabs() {
		const filterOptionTab: FeatureTab<TabKey> = {
			key: 'filterOptions',
			label: 'Filter',
			// label: 'glyphicons glyphicons-cogwheel',
			// isLabelIcon: true,
			template: this.tabQcFilterTemp
		};
		const dataTab: FeatureTab<TabKey> = {
			key: 'data',
			label: 'Data',
			template: this.tabDataTemp
		};
		const resoTab: FeatureTab<TabKey> = {
			key: 'resoCenter',
			label: 'RC',
			template: this.tabResoCenterTemp,
			hidden: true
		};
		const domainRcTab: FeatureTab<TabKey> = {
			key: 'resoCenter_domain',
			label: 'Domain RC',
			template: this.tabResoCenterDomainTemp,
			hidden: true
		};
		const topoTab: FeatureTab<TabKey> = {
			key: 'topoCheck',
			label: 'RC',
			template: this.tabTopoCheckTemp,
			hidden: true
		};
		const exceptionTab: FeatureTab<TabKey> = {
			key: 'exception',
			label: 'Exception',
			template: this.tabExceptionTemp
		};
		const batchTab: FeatureTab<TabKey> = {
			key: 'batch',
			label: 'Batch',
			template: this.tabBatchTemp
		};
		const a3iTab: FeatureTab<TabKey> = {
			key: 'a3i',
			label: 'A3I',
			template: this.tabA3iTemp
		};
		const schemaTab: FeatureTab<TabKey> = {
			key: 'schema',
			label: 'Info',
			// label: 'glyphicons glyphicons-info-sign',
			// isLabelIcon: true,
			template: this.tabSchemaErrorTemp
		}
		const bookmarkRefTab: FeatureTab<TabKey> = {
			key: 'bookmarkRef',
			label: 'Reference Doc',
			template: this.tabRefDocumentTemp
		};
		if (this.contentKey === 'live') {
			this.tabs = [filterOptionTab, dataTab, resoTab, domainRcTab, topoTab, exceptionTab, batchTab, a3iTab, schemaTab, bookmarkRefTab];
		} else if (this.contentKey === 'published') {
			this.tabs = [filterOptionTab, dataTab, resoTab, a3iTab, schemaTab, bookmarkRefTab];
		} else if (this.contentKey === 'report') {
			const dataAddrTab: FeatureTab<TabKey> = {
				key: 'data-addr',
				label: 'Address',
				template: this.tabDataAddrTemp,
				hidden: true
			};
			const dataCenterlineTab: FeatureTab<TabKey> = {
				key: 'data-centerline',
				label: 'CenterLine',
				template: this.tabDataCenterlineTemp,
				hidden: true
			};
			this.tabs = [filterOptionTab, dataAddrTab, dataCenterlineTab, resoTab, exceptionTab, a3iTab, bookmarkRefTab];
		}
	}
	private updateTabsVisibility() {
		const layer = this.selectedLayer;
		let hidden;
		this.tabs.forEach(t => {
			switch (t.key) {
				case 'data-addr':
				case 'data-centerline':
				case 'filterOptions':
					// TODO
					break;
				case 'topoCheck':
					t.hidden = layer.state.name !== 'TOPOLOGY';
					break;
				case 'data':
					t.hidden = layer.state.name !== 'CONTENT' && layer.state.name !== 'DOMAIN'; // || !this.currentCardId;
					break;				
				case 'resoCenter':
					if (layer.state.name !== 'CONTENT' || !this.currentCardId) {
						hidden = true;
					} else {
						const qaResolverFeeds = this.resoCenterService.resoFeedBS.getValue().feeds;
						if (!qaResolverFeeds || !qaResolverFeeds.length) {
							hidden = true;
						}
					}
					t.hidden = hidden;
					break;
				case 'resoCenter_domain':
					t.hidden = layer.state.name !== 'DOMAIN' && (layer.state.name !== 'CONTENT' || !this.resoCenterDomainService.resoFeedDomainBS.getValue().feeds);
					break;
				case 'a3i':
					t.hidden = layer.category.code !== this.attrIndexService.cateCodeAddress && layer.category.code !== this.attrIndexService.cateCodeCenterline || layer.state.name !== 'CONTENT' || !this.userService.getA3iApiKey();
					break;
				case 'exception':
				case 'batch':
					t.hidden = layer.state.name !== 'CONTENT' && layer.state.name !== 'DOMAIN';
					break;
				case 'schema':
					break;
			}
		});
		if (this.selectedTab && this.selectedTab.hidden) {
			this.verticalTabsComp.selectTab(this.tabs.findIndex(t => !t.hidden));
		}
	}
	private toggleTabVisibForTopoEdit(topoOn: boolean) {
		this.tabs.forEach(t => {
			if (!t.key.startsWith('data')) {
				t.tempHidden = topoOn;
			}
		});
	}
	getIdCol(fishboneCardType?: FishboneCardType) {
		return this.uuidColName;
			// if (!this.isFishboneOn) {
			// 	return this.uuidColName;
			// } else {
			// 	if (fishboneCardType === 'addr') {
			// 		return this.addrUuidCol;
			// 	} else if (fishboneCardType === 'centerline') {
			// 		return this.rcUuidCol;
			// 	}
			// }
	}
	// Get id of a row / card
	// NOTE: CAN NOT be used to get id of Origin card for fishbones (because the isFishboneAddr/isFishboneRoad has not been set yet)
	getRecordId = (rec) => {
		if (!rec) {
			return;
		}
		return rec[this.uuidColName];
			// if (!this.isFishboneOn) {
			// 	return rec[this.uuidColName];
			// } else {
			// 	return this.fishboneService.getFishboneId(rec);
			// }
	}
	private updateCurrentCard(recId, updateTab?: boolean) {
		if (updateTab) {
			this.selectDataTab();
		}
		const prevId = this.currentCardId;
		if (recId) {
			// const editedRec = this.editRecordList.find(r => this.getRecordId(r) === this.getRecordId(row));
			// if (editedRec) {
			// 	this.cardSelectedRecord = editedRec;
			// } else {
			// 	this.cardSelectedRecord = row;
			// 	// Store original data
			// 	if (!row[this.originDataKey]) {
			// 		row[this.originDataKey] = JSON.parse(JSON.stringify(row));
			// 	}
			// }
			this.currentCardId = recId;
			this.updateCurrentCardExtraInfo(recId);

		} else {
			this.currentCardId = null;
		}
		this.mapLayerService.currentCardId = this.currentCardId;

		if (this.currentCardId !== prevId) {
			// Refresh feature style so that CURRENT feature style will be applied
				let feature: Feature | 1 = this.currentCardId ? null : 1;
				let prevFeature: Feature | 1 = prevId ? null : 1;
				const checkingLayerNames = [this.mapLayerService.dataModifyLayerName,];
				if (this.isTopologyOn) {
					checkingLayerNames.unshift(this.mapLayerService.topojsonLayerName)
				} else {
					checkingLayerNames.unshift(this.mapLayerService.dataLayerName)
				}
				for (let i = 0; i < checkingLayerNames.length; i++) {
					const layer = this.mapService.map.addedLayers[checkingLayerNames[i]];
					if (!feature) {
						feature = layer.getSource().getFeatureById(this.currentCardId);
					}
					if (!prevFeature) {
						prevFeature = layer.getSource().getFeatureById(prevId);
					}
					if (feature && prevFeature) {
						break;
					}
				}
				if (!feature) {
					feature = this.mapService.dataSelectInteraction.getFeatures().getArray().find(f => f.getId() === this.currentCardId);
				}
				if (!prevFeature) {
					prevFeature = this.mapService.dataSelectInteraction.getFeatures().getArray().find(f => f.getId() === prevId);
				}
				if (feature && feature !== 1) {
					feature.changed();
				}
				if (prevFeature && prevFeature !== 1) {
					prevFeature.changed();
				}
				// this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].changed();

			//
			this.manuallyScrollOnTable();
			// Scroll row to view
			const rowIdx = this.rows.findIndex(r => this.getRecordId(r) === this.currentCardId);
			if (rowIdx > -1) {
				this.dataTable.scrollRowIntoView(rowIdx, this.rows.length);
			}
			
			const attrs = this.mainDataService.getDataAttrs(this.currentCardId);
			if (attrs) {
				this.recordExceptions = attrs[this.exceptionColName];
			}
		}
		this.activityService.currentCardBS.next({
			id: this.currentCardId,
			source: 'main'
		})
	}
	// Update info from table row (like qc error/warning info, exception info) for the selected card
	private updateCurrentCardExtraInfo(recId) {
		const attrs = this.mainDataService.getDataAttrs(recId);
		if (!attrs) {
			return;
		}
		const classNameByColProp = {};
		const qcFilterOptions = this.mainDataService.qcFilterInfo.getValue().filterOptions;
		this.columns.forEach((col) => {
			const notes: QaNotes = attrs[this.qaNotesColName];
			const colNotes = notes ? notes[col.prop] : null;
			if (colNotes && qcFilterOptions.length) {
				const qcCellClass = this.qcService.getQcCellClassName(colNotes, attrs[this.exceptionColName], col.prop, qcFilterOptions);
				classNameByColProp[col.prop] = qcCellClass;
			}
		});
		this.mainDataService.setDataAttrs(recId, this.attrIndexService.cardQcClassColName, classNameByColProp);
		// this.cardSelectedRecord[this.exceptionColName] = tableRow[this.exceptionColName];
		// const classNameByColProp = {};
		// const qcFilterOptions = this.mainDataService.qcFilterInfo.getValue().filterOptions;
		// this.columns.forEach((col) => {
		// 	const notes: QaNotes = tableRow[this.qaNotesColName];
		// 	const colNotes = notes ? notes[col.prop] : null;
		// 	if (colNotes && qcFilterOptions.length) {
		// 		const qcCellClass = this.qcService.getQcCellClassName(colNotes, tableRow[this.exceptionColName], col.prop, qcFilterOptions);
		// 		classNameByColProp[col.prop] = qcCellClass;
		// 	}
		// });
		// this.cardSelectedRecord[this.attrIndexService.cardQcClassColName] = classNameByColProp;
	}
	private async updateSelectedCard_fishbone(row) {
		// Update Tab
		const addrTab = this.tabs.find(t => t.key === 'data-addr');
		const centerlineTab = this.tabs.find(t => t.key === 'data-centerline');
		addrTab.hidden = !this.editAddrList.length && !row;
		centerlineTab.hidden = !this.editCenterlineList.length && !row;
		//
		this.selectDataTab();
		// Update card
		let addrCard;
		const addrCards = [];
		const centerlineCards = [];
		const transformFromStdSchemaToEditColumns = (dataArray: any[], stdSchema: LayerCategoryStandardSchema[], addToArry: EditCardColumn[], model: ModelMenuItemKey) => {
			const tableCols = this.tableService.setColumnsFromRows(dataArray);
			const columnsByName: {[colName: string]: TableColumn} = tableCols.reduce((acc, col) => {
				// Take out column prop's prefix
				const prop = col.prop.substring(4);
				acc[prop.toUpperCase()] = col;
				return acc;
			}, {});
			stdSchema.filter(i => i.isFishboneCol && i.models.indexOf(model) > -1).forEach(i => {
				let col = columnsByName[i.colName.toUpperCase()];
				if (col) {
					addToArry.push({
						prop: col.prop,
						name: i.alias,
						info: {}
					});
				}
			});
		}
		let addrRecId;
		if (row) {
		// Address
			const addrLayerId = row[this.fishboneAddrLayerIdCol];
			addrRecId = row[this.addrUuidCol];
			// Select address card
			if (addrLayerId && addrRecId) {
				// Get details info of address & roads
				const addrIdGfo = this.gfoService.getGfo(
					this.gfoService.filterLogics.and,
					[this.gfoService.getFilter(this.addrUuidCol, this.appinfoService.filterOperators.eq.name, addrRecId)]
				);
				const addrDetail = await this.layerService.getLayerContents(addrLayerId, addrIdGfo);
				addrCard = addrDetail.data[0];
				addrCards.push(addrCard);
				// transform for both model
				Object.keys(this.fishboneColsByModel).forEach((model: ModelMenuItemKey) => {
					if (!this.fishboneColsByModel[model].addrCols.length) {
						transformFromStdSchemaToEditColumns([addrCard], this.fishboneSchema.addrStdSchema, this.fishboneColsByModel[model].addrCols, model);
					}
				});
			}
		// Centerline
			const rcLayerId = row[this.fishboneRcLayerIdCol];
			const rcUuids = row[this.rcUuidCol2] || [];
			//
			const requestUuids = [];
			rcUuids.forEach(id => {
				if (this.fishboneService.fishboneRoads[id]) {
					centerlineCards.push(this.fishboneService.fishboneRoads[id].attrs);
				} else {
					requestUuids.push(id);
				}
			});
			if (rcLayerId && requestUuids.length) {
				const filter = this.gfoService.getFilter(this.rcUuidCol, this.appinfoService.filterOperators.in.name, requestUuids);
				const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
				// Get details info of centerline
				const centerlineDetailRsp = await this.layerService.getLayerContents(rcLayerId, gfo);
				centerlineDetailRsp.data.forEach(centerlineDetail => {
					centerlineCards.push(centerlineDetail);
				});
				// rcUuids.forEach(rcUuid => {
				// 	// Get details info of centerline
				// 	const centerlineIdGfo = this.gfoService.getGfo(
				// 		this.gfoService.filterLogics.and,
				// 		[this.gfoService.getFilter(this.rcUuidCol, this.appinfoService.filterOperators.eq.name, rcUuid)]
				// 	);
				// 	const centerlineDetailPromise = this.layerService.getLayerContents(rcLayerId, this.selectedCustomerId, centerlineIdGfo);
				// 	promises.push(centerlineDetailPromise);
				// });
				// await Promise.all(promises).then(rspList => {
				// 	rspList.forEach(centerlineDetail => {
				// 		const centerlineCard = centerlineDetail.data[0];
				// 		centerlineCards.push(centerlineCard);
				// 	});
				// }).catch(err => {
				// 	console.log(err);
				// 	this.toastr.error(err.message);
				// });
				//
			}
			// transform for both model
			Object.keys(this.fishboneColsByModel).forEach((model: ModelMenuItemKey) => {
				if (!this.fishboneColsByModel[model].centerlineCols.length) {
					transformFromStdSchemaToEditColumns(centerlineCards, this.fishboneSchema.centerlineStdSchema, this.fishboneColsByModel[model].centerlineCols, model);
				}
			});

		// Mark as fishbone address card
			if (addrCard) {
				addrCard[this.attrIndexService.isFishboneAddrKey] = true;
				addrCard[this.fishboneCenterlineIdsColName] = rcUuids;
			}
		// Mark as fishbone centerline card
			if (centerlineCards.length) {
				centerlineCards.forEach(c => {
					c[this.attrIndexService.isFishboneRoadKey] = true;
					c[this.fishboneAddrIdColName] = addrRecId;
				});
			}
		}
		this.editAddrList = addrCards;
		this.editCenterlineList = centerlineCards;
		this.originAddrList = JSON.parse(JSON.stringify(addrCards));
		this.originCenterlineList = JSON.parse(JSON.stringify(centerlineCards));
		//
		// setTimeout(() => {
		this.cardSelectedAddr = addrCard;
		if (this.cardSelectedCenterline) {
			this.cardSelectedCenterline = centerlineCards.find(c => this.getRecordId(c) === this.getRecordId(this.cardSelectedCenterline));
		}
		if (!this.cardSelectedCenterline) {
			this.cardSelectedCenterline = centerlineCards[0];
		}
		// });
	}
	private selectDataTab () {
		if (!this.selectedTab || !this.selectedTab.key.startsWith('data')) {
			const idx = this.tabs.findIndex(t => t.key.startsWith('data'));
			if (idx > -1 && !this.tabs[idx].hidden) {
				this.verticalTabsComp.selectTab(idx);
			}
		}
		// If data tab is hidden, select the first tab that's not hidden
		if (this.selectedTab.hidden) {
			this.verticalTabsComp.selectTab(this.tabs.findIndex(t => !t.hidden));
		}
	}
	// Reset
	private resetDataCards() {
		// const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		// const wktFormat = new WKT();
		const editedIds = this.activityService.editRecordListBS.getValue().ids;
		editedIds.forEach(id => {
			this.mainDataService.clearDataChangeInIndex(id);
			// const origin = this.mainDataService.getDataOriginAttrs(id);
			// if (!origin) { // if it's new card, discard it
			// 	return;
			// }
			// const attrs = this.mainDataService.getDataAttrs(id);
			// Object.keys(attrs).forEach(key => {
			// 	if (origin[key] && typeof origin[key] === 'object') {
			// 		attrs[key] = JSON.parse(JSON.stringify(origin[key]));
			// 	} else {
			// 		attrs[key] = origin[key];
			// 	}
			// });
		});
		this.mapService.resetFeaturesGeom(editedIds);
		this.clearDataCards();
	}
	private clearDataCards() {
		// this.editRecordList.splice(0, this.editRecordList.length);
		// this.editRecordList = [];
		this.activityService.editRecordListBS.next({
			ids: [],
			source: 'main'
		});
		// hiddenList.splice(0, hiddenList.length);
		this.activityService.editRecordListHiddenBS.next({
			ids: []
		});
		// NOTE: exceptions should be updated BEFORE updateCurrentCard
		this.clearExceptions();
		// this.cardSelectedRecord = null; // set in updateCurrentCard
		this.updateCurrentCard(null);
	}
	private clearChanges() {
		if (!this.selectedTab) {
			return;
		}
		if (this.isMapEditing) {
			this.stopMapEditing();
		}
		switch (this.selectedTab.key) {
			case 'data':
				this.resetDataCards();
				break;
			case 'resoCenter':
				this.resoInspectorComp.discard();
				break;
			case 'resoCenter_domain':
				this.resoDomainInspectorComp.discard();
				break;
		}
	}
	private clearFishboneCards() {
		this.editAddrList = [];
		this.editCenterlineList = [];
		this.cardSelectedAddr = null;
		this.cardSelectedCenterline = null;
		this.updateSelectedCard_fishbone(null);
	}
	
	// onEditCard(event: EditDataEmitter) {
	// 	let feature;
	// 	this.mapInfo.selectionLayerNames.find(n => {
	// 		const layer = this.mapService.map.addedLayers[n];
	// 		feature = layer.getSource().getFeatureById(event.recId);
	// 		return feature;
	// 	});
	// 	if (feature) {
	// 		const props = feature.getProperties();
	// 		// Change feature's isEdited property
	// 		if (event.isInitEdit) {
	// 			props[this.attrKey][this.isEditedCol] = true;
	// 		}
	// 		if (event.changedCol) {
	// 			props[this.attrKey][event.changedCol] = event.card[event.changedCol];
	// 		}
	// 		feature.setProperties(props);
	// 		// feature.changed();
	// 	}
	// }
	onSelectRecordFromCard(e: SelectRecordEmitter) {
		// TODO: aaaaa
		// this.activityService.selectedRecord.next({
		// 	id: e.id,
		// 	source: 'card'
		// });
	}
	async onSelectAddrFromCard(e: SelectRecordEmitter) {
		const addressId = e.id;
		this.cardSelectedAddr = addressId ? this.editAddrList.find(c => addressId === this.getRecordId(c)) : null;
		// Select on Table if not selected
		if (this.selectedRows[0] && this.selectedRows[0][this.addrUuidCol] !== addressId) {
			this.selectRecordOnTable_(addressId, 'addr');
		}
		// Select the address on map
		const lineId = this.getRecordId(this.cardSelectedCenterline);
		this.selectFishboneFeatureOnMap(addressId, [lineId]);
	}
	async onSelectCenterlineFromCard(e: SelectRecordEmitter) {
		const lineId = e.id;
		this.cardSelectedCenterline = lineId ? this.editCenterlineList.find(c => lineId === this.getRecordId(c)) : null;
		// Select on Table if not selected
		if (this.selectedRows[0] && this.selectedRows[0][this.rcUuidCol2] && this.selectedRows[0][this.rcUuidCol2].indexOf(lineId) === -1) {
			this.selectRecordOnTable_(lineId, 'centerline');
		}
		// Select the centerline on map
		const addressId = this.getRecordId(this.cardSelectedAddr);
		this.selectFishboneFeatureOnMap(addressId, [lineId]);
	}

		// // Add card to editCardList // This can be used when card tab isn't current (i.e editCardRef not exist)
		// private addRecToCard(rec, originRec) {
		// 	if (!rec[this.isEditedCol]) {
		// 		rec[this.isEditedCol] = true;
		// 		// Store the original data
		// 		rec[this.originDataKey] = originRec;
		// 		const selectedLayer = this.selectedLayer;
		// 		// For provBdry, check discrepancyId
		// 		if (selectedLayer.category.code === this.attrIndexService.cateCodeProvBdry && rec[this.discrepancyAgencyIdColName] !== this.appinfoService.customerProfile.discrepancyAgencyId) {
		// 			const hiddenList = this.activityService.editRecordListHiddenBS.getValue();
		// 			hiddenList.list.push(rec);
		// 			this.activityService.editRecordListHiddenBS.next({
		// 				list: hiddenList.list
		// 			})
		// 		} else {
		// 			this.editRecordList.push(rec);
		// 			this.activityService.editRecordListBS.next({
		// 				list: this.editRecordList,
		// 				source: 'main'
		// 			});
		// 		}
		// 		// this.editService.originRecordList.push(originRec);
		// 	}
		// }

		// // Add NEW record to card & table (no geom added)
		// private addNewCard() {
		// 	const rec = {};
		// 	rec[this.attrIndexService.isNewDataKey] = true;
		// 	rec[this.getIdCol()] = uuidv1();
		// 	rec[this.isEditedCol] = true;

		// 	this.editRecordList.push(rec);
		// 	this.activityService.editRecordListBS.next({
		// 		list: this.editRecordList,
		// 		source: 'main'
		// 	});
		// 	this.rows.push(rec);
		// 	return rec;
		// }
// #endregion

	async updateRc() {
		const layer = this.selectedLayer;
		if (layer.state.num === 2 && this.currentCardId) {
			// const resoTab = this.tabs.find(t => t.key === 'resoCenter');
			const qaResolverFeeds = this.mainDataService.getDataAttrs(this.currentCardId)[this.attrIndexService.isNewDataKey] ? [] : await this.resoCenterService.getQaResolverFeeds(layer.id, this.currentCardId);
			this.resoCenterService.resoFeedBS.next({
				record: this.mainDataService.getDataAttrs(this.currentCardId),
				recordId: this.currentCardId,
				feeds: qaResolverFeeds
			});
		}
		this.updateTabsVisibility(); // Update after qaResolverFeeds is updated
	}

		// insertPoint() {
		// 	const rec = {};
		// 	// Add coord
		// 	const extent = this.mapService.map.olMap.getView().calculateExtent();
		// 	const coord = getCenter(extent);
		// 	// rec[this.coordCol] = coord;
		// 	const geom = new Point(coord);
		// 	const wktFormat = new WKT();
		// 	const wktString = wktFormat.writeGeometry(geom);
		// 	rec[this.geomColName_manual] = wktString;
		// 	// Add attributes
		// 	rec[this.attrIndexService.isNewDataKey] = true; // new point
		// 	rec[this.isEditedCol] = true;
		// 	rec[this.demarcationService.dmIdColumn] = uuidv1(); // set id
		// 	rec[this.demarcationService.dmResolvedColumn] = true; // set it as resolved point
		// 	rec[this.attrIndexService.epAgencyColumn] = this.userService.getCustomerIdByType().toString(); // set agency
		// 	// TODO: detect if it involve two agencies
			
		// 	// Add feature on table
		// 	const newRows = this.rows.map(r => r);
		// 	newRows.push(rec);
		// 	this.setRows(newRows);
		// 	// Add feature on map
		// 	const feat = new Feature({
		// 		geometry : geom
		// 	});
		// 	const props = {};
		// 	props[this.attrKey] = rec;
		// 	feat.setProperties(props);
		// 	feat.setId(rec[this.demarcationService.dmIdColumn]);
		// 	const source = this.mapService.map.addedLayers[this.demarcationService.dmLayerName].getSource();
		// 	source.addFeature(feat);
		// 	// Add feature to editList
		// 	this.editRecordList.push(rec);
		// 	//
		// 	setTimeout(() => {
		// 		this.editCardRef.changeSelectedRecord(rec, true);
		// 	})
		// }

	// Add a new record to table, card and map
	addRecord() {
		if (this.isAddingFeature) {
			this.finishAddFeature();
			return;
		}
		let geomType: GeometryType;
		switch (this.selectedLayer.category.geomType) {
			case 'POINT':
				geomType = 'Point';
				break;
			case 'LINE':
				geomType = 'LineString';
				break;
			case 'AREA':
				geomType = 'Polygon';
				break;
		} 
		if (geomType) {
			this.startAddNewFeature(geomType);
		}
	}

	test() {
	}

	private getSourceTableName() {
		const selectedLayer = this.selectedLayer;
		return selectedLayer.category.tableName;
	}

	private checkHasChangedData() {
		let hasChange = false;
		if (this.selectedTab) {
			switch (this.selectedTab.key) {
				case 'data':
					const editedIds = this.activityService.editRecordListBS.getValue().ids;
					if (editedIds.length) {
						hasChange = true;
					}
					break;
				case 'resoCenter':
					if (this.resoInspectorComp.hasDataChange) {
						hasChange = true;
					}
					break;
				case 'resoCenter_domain':
					if (this.resoDomainInspectorComp.hasChanged) {
						hasChange = true;
					}
					break;
			}
		}
		return hasChange;
	}
	private async preventUnsavedEdits() {
		let isContinue: boolean = true;
		const hasChange = this.checkHasChangedData();
		if (hasChange) {
			const response = await this.editService.warnOnLeave();
			if (!response) {
				isContinue = false;
			} else {
				await this.onUserRespondToLeaving(response);
			}

		}
		// if (this.selectedTab) {
		// 	switch (this.selectedTab.key) {
		// 		case 'data':
		// 			const editedIds = this.activityService.editRecordListBS.getValue().ids;
		// 			if (editedIds.length) {
		// 				isContinue = await this.editService.warnOnLeave();
		// 			}
		// 			break;
		// 		case 'resoCenter':
		// 			if (this.resoInspectorComp.hasDataChange) {
		// 				isContinue = await this.editService.warnOnLeave();
		// 			}
		// 			break;
		// 		case 'resoCenter_domain':
		// 			if (this.resoDomainInspectorComp.hasChanged) {
		// 				isContinue = await this.editService.warnOnLeave();
		// 			}
		// 			break;
		// 	}
		// }
		return isContinue;
	}
	async onUserRespondToLeaving(response: LeaveWarningResponse) {
		if (response === 'commit') {
			if (this.selectedTab) {
				switch (this.selectedTab.key) {
					case 'data':
						const editedIds = this.activityService.editRecordListBS.getValue().ids;
						if (editedIds.length) {
							await this.commit();
						}
						break;
					case 'resoCenter':
						if (this.resoInspectorComp.hasDataChange) {
							await this.resoInspectorComp.commit();
						}
						break;
					case 'resoCenter_domain':
						if (this.resoDomainInspectorComp.hasChanged) {
							await this.resoDomainInspectorComp.commit();
						}
						break;
				}
			}
		} else if (response === 'discard') {
			switch (this.selectedTab.key) {
				case 'data':
					this.clearChanges();
					break;
				case 'resoCenter':
					if (this.resoInspectorComp.hasDataChange) {
						this.resoInspectorComp.discard();
					}
					break;
				case 'resoCenter_domain':
					if (this.resoDomainInspectorComp.hasChanged) {
						this.resoDomainInspectorComp.discard();
					}
					break;
			}
		}
	}
	async cancel() {
		// const editedIds = this.activityService.editRecordListBS.getValue().ids;
		// if (editedIds.length) {
		// 	const isContinue = await this.preventUnsavedEdits();
		// 	if (!isContinue) {
		// 		return;
		// 	}
		// }

		const hasChange = this.checkHasChangedData();
		if (hasChange) {
			let response: LeaveWarningResponse = 'discard';
			const confirmDiscard = await this.editService.warnOnDiscard();
			if (!confirmDiscard) {
				response = false;
				return;
			} else {
				await this.onUserRespondToLeaving(response);
			}
		}

		this.mapService.clearModifyLayer();
		if (this.isMapEditing) {
			this.stopMapEditing();
		}
		this.clearSelection();
			// const originList = this.editService.originRecordList;
			// if (originList) {
			// 	const wktFormat = new WKT();
			// 	switch (this.current.contentKey) {
			// 		case 'myLayers':
			// 		case 'collaborative':
			// 			originList.forEach(o => {
			// 				const id = this.getRecordId(o);
			// 				const idx = this.rows.findIndex(r => this.getRecordId(r) === id);
			// 				if (idx > -1) {
			// 					this.rows[idx] = o;
			// 				}
			// 				const feat = this.mapService.map.addedLayers[this.dataLayerName].getSource().getFeatureById(id);
			// 				if (feat) {
			// 					const props = {};
			// 					props[this.attrKey] = o
			// 					feat.setProperties(props);
			// 					const wktStr = o[this.geomColName_manual];
			// 					if (wktStr) {
			// 						const geom = wktFormat.readGeometry(wktStr);
			// 						feat.setGeometry(geom);
			// 					}
			// 				}
			// 			});
			// 			this.rows = this.rows.map(r => r);
			// 			break;
			// 		// case 'interlayers':
			// 			// TODO


						
			// 	}
			// }
		// this.clearDataCards();

		await this.getData({
			pageNumber: 1,
			rowCount: 1
		}, {
			keepPrevColumns: true,
			keepSelectedData: true
		});
	}
	private async handleEditedRecordList(list: any[], originList: any[]) {
		if (!list.length) {
			return;
		}
		let fishboneType: FishboneCardType;
		let cateId: number;
	// Get sourceTableName
		let sourceTableName: string;
		// TODO: FFFFFFFFFFFFF
		// if (this.selectedLayer.isFishbone !== true) {
			sourceTableName = this.getSourceTableName();
			cateId = this.selectedLayer.category.id;
		const layerId = this.selectedLayer.id;
		const layerIdCol = this.selectedLayer.category.colPrefix + '_' + this.attrIndexService.layerIdColumn;
		// } else {
		// 	if (list[0][this.attrIndexService.isFishboneAddrKey]) {
		// 		fishboneType = 'addr';
		// 		const addrLayer = this.appinfoService.layerTypeList.find(t => t.code === this.attrIndexService.cateCodeAddress);
		// 		sourceTableName = addrLayer.tableName;
		// 		cateId = addrLayer.id;
		// 	} else if (list[0][this.attrIndexService.isFishboneRoadKey]) {
		// 		fishboneType = 'centerline';
		// 		const centerlineLayer = this.appinfoService.layerTypeList.find(t => t.code === this.attrIndexService.cateCodeCenterline);
		// 		sourceTableName = centerlineLayer.tableName;
		// 		cateId = centerlineLayer.id;
		// 	}
		// }
		if (!sourceTableName) {
			console.log('Can not find source table')
			return;
		}
	//
		const idCol = this.getIdCol(fishboneType);

		let changedCols: string[] = [];
		let newRecordsChangedCols: string[] = [];
			//
		let deleteGto: Gto, newRecordsGto: Gto, updateGtos: Gto[];
		let gtos: Gto[] = [];
		const deleteIds = [];
		const newRecords = [];
		const updateRecords = [];
		const updateRecordsOrigin = [];
		list.forEach(r => {
			if (r[this.toDeleteCol]) {
				deleteIds.push(this.getRecordId(r));
			} else if (r[this.attrIndexService.isNewDataKey]) {
				newRecords.push(r);
			} else {
				updateRecords.push(r);
				const origin = originList.find(o => o && o[idCol] === this.getRecordId(r));
				// const origin = originList.find(o => this.getRecordId(o) === this.getRecordId(r));
				updateRecordsOrigin.push(origin);
			}
		});
		const prefix = this.tableService.getTablePrefixByRow(list[0]);
		let dynamicQcKeyvals;
		if (deleteIds.length) {
			deleteGto = this.editService.getDeletePointsGto(sourceTableName, prefix, idCol, null, deleteIds);
			gtos.push(deleteGto);
		}
		// Jsonb
		let jsonbInfo: JsonbInfo;
		// if (this.current.contentKey === 'myLayers') {
			jsonbInfo = {};
			const nstd = prefix + '_' + this.editService.attrNstdColumn;
			const state = prefix + '_' + this.editService.attrStateColumn;
			jsonbInfo[nstd] = this.schemas.cols.local.filter(c => c.info.isJsonbCol).map(c => c.prop);
			jsonbInfo[state] = this.schemas.cols.state.filter(c => c.info.isJsonbCol).map(c => c.prop);
		// } else {



		// 	// TODO
		// }
		//
		let cols: string[] = this.editService.getUpdateColsInSourceTable(sourceTableName, prefix);
		let primKeyCol: string;
		primKeyCol = this.editService.getPrimKeyCol(prefix);

		if (newRecords.length) {
			// let attrCols: string[];
			// attrCols = this.schemas.cols.standard.filter(c => c.info.standardColName).map(c => c.prop);

			// Remove globalId col for new record
			const globalIdCol = `${prefix}_${this.attrIndexService.globalIdColLower}`;
			const globalIdColIdx = cols.findIndex(c => c === globalIdCol);
			cols.splice(globalIdColIdx, 1);
			//
			newRecords.forEach(r => {
				r[layerIdCol] = layerId;
			})
			const newRecordsGtoInfo = this.editService.getInsertNewGto(newRecords, cols, sourceTableName, prefix, this.geomColName_manual, jsonbInfo);
			newRecordsGto = newRecordsGtoInfo.gto;
			newRecordsChangedCols = newRecordsGtoInfo.changedCols;
			// gtos.push(newRecordsGto);
		}
		if (updateRecords.length) {
			dynamicQcKeyvals = updateRecords.map(r => this.getRecordId(r));
			// cols = this.schemas.cols.standard.filter(c => c.info.isStdSchema).map(c => c.prop);
			//
			const isArchiveMode = this.archiveModeService.archiveModeBS.getValue().isArchive;
			const updateGtosInfo = isArchiveMode ? 
				this.editService.getUpdateGtosByRecordsArchive(cols, updateRecords, updateRecordsOrigin, sourceTableName, prefix, primKeyCol, this.geomColName_manual, jsonbInfo) : 
				this.editService.getUpdateGtosByRecords(cols, updateRecords, updateRecordsOrigin, sourceTableName, prefix, primKeyCol, this.geomColName_manual, jsonbInfo);
			// const updateGtosInfo = this.editService.getUpdateGtosByRecords(cols, updateRecords, updateRecordsOrigin, sourceTableName, prefix, primKeyCol, this.geomColName_manual, jsonbInfo);
			updateGtos = updateGtosInfo.gtos;
			changedCols = updateGtosInfo.changedCols;
			gtos = gtos.concat(updateGtos);
		}

		// changedCols = changedCols.map(c => {
		// 	const std = this.schemas.cols.standard.find(s => s.prop === c);
		// 	if (std) {
		// 		return std.info.standardColName;
		// 	} else if (c === this.geomColName) { // Manually add geom col since it's removed from standard cols at beginning
		// 		return this.attrIndexService.geomCol; // TODO
		// 	}
		// });

		changedCols = changedCols.filter(c => c);
		return {
			gtos: gtos,
			changedCols: changedCols,
			newRecordsGto: newRecordsGto,
			newRecordsChangedCols: newRecordsChangedCols,
			dynamicQcKeyvals: dynamicQcKeyvals || []
		};
	}
	async commit() {
		this.commonService.setLoadingSpinner(true);
		try {
			await this.commit_myLayers_collaborative();
		} catch (err) {
			console.log(err);
		}
		if (this.isMapEditing) {
			this.stopMapEditing();
		}

		this.commonService.setLoadingSpinner(false);
	}
	// private async commit_fishbone() {
	// 	if (!this.editAddrList.length && !this.editCenterlineList.length) {
	// 		return;
	// 	}
	// 	let gtos: Gto[] = [];
	// 	let editFilters: QcEditFilter[] = [];
	// 	// Address
	// 	const editedAddrList = this.editAddrList.filter(c => c[this.isEditedCol]);
	// 	if (editedAddrList.length) {
	// 		const addrData = await this.handleEditedRecordList(editedAddrList, this.originAddrList);
	// 		gtos = gtos.concat(addrData.gtos);
	// 		const addrEditFilter: QcEditFilter = {
	// 			gly_id: this.rows[0][this.fishboneAddrLayerIdCol],
	// 			cols: addrData.changedCols,
	// 			keyvals: addrData.dynamicQcKeyvals
	// 		}
	// 		editFilters.push(addrEditFilter);
	// 	}
	// 	// Centerline
	// 	const editedCenterlineList = this.editCenterlineList.filter(c => c[this.isEditedCol]);
	// 	if (editedCenterlineList.length) {
	// 		const centerlineData = await this.handleEditedRecordList(this.editCenterlineList, this.originCenterlineList);
	// 		gtos = gtos.concat(centerlineData.gtos);
	// 		const centerlineEditFilter: QcEditFilter = {
	// 			gly_id: this.rows[0][this.fishboneRcLayerIdCol],
	// 			cols: centerlineData.changedCols,
	// 			keyvals: centerlineData.dynamicQcKeyvals
	// 		}
	// 		editFilters.push(centerlineEditFilter);
	// 	}
	// 	if (gtos.length) {
	// 		console.log(gtos)
	// 		await this.gtoService.processGto(gtos);
	// 		this.clearFishboneCards();
	// 		this.toastr.success('Successfully updated.');

	// 		await this.qcService.qcLayersDynamic(editFilters); // TODO: check transition in misc
	// 	}
	// }
	private async commit_myLayers_collaborative() {
		const layerCate = this.selectedLayer.category.code;
		let editedIdList = this.activityService.editRecordListBS.getValue().ids.concat(this.activityService.editRecordListHiddenBS.getValue().ids);
		const editList = editedIdList.map(id => this.mainDataService.getDataAttrs(id))
		const originList = editedIdList.map(id => this.mainDataService.getDataOriginAttrs(id));
		const data = await this.handleEditedRecordList(editList, originList);
		const gtos = data.gtos;
		const newRecordsGto = data.newRecordsGto;
		if (gtos.length || newRecordsGto) {
			console.log(gtos);
			let gtoRsp, newGtoRsp;
			try {
				if (gtos.length) {
					gtoRsp = await this.gtoService.processGto(gtos, this.uuidColName);
				}
				if (newRecordsGto) {
					newGtoRsp = await this.gtoService.processGto([newRecordsGto], this.uuidColName);
				}
			} catch (err) {
				this.toastr.error('Update failed.');
				console.log(err);
				return;
			}
			// Notify agency
			try {
				if (this.selectedLayer.category.code === this.attrIndexService.cateCodeMatchPoint) {
					const affectedAgencyIds = [];
					editList.forEach(i => {
						const agencyList = i[this.attrIndexService.epAgencyColumn].split(',');
						agencyList.forEach(a => {
							if (a != this.userService.getCustomerIdByType() && affectedAgencyIds.indexOf(a) === -1) {
								affectedAgencyIds.push(a);
							}
						})
					});
					if (affectedAgencyIds.length > 0) {
						const promises = affectedAgencyIds.map(id => this.userService.getCustomerInfo(id, false, false));
						await Promise.all(promises).then(rsp => {
							const affectedNames = rsp.map(i => i.nameShort);
							this.toastr.success('The following agency(s) has been notified of this updates: ' + affectedNames.join(','));
						});
					}
				}
			} catch (err) {
				console.log(err);
			}

			// Dynamic Qc
			try {
				let isDynamicQc: boolean, isDynamicQcNew: boolean;
				let editFilters: QcEditFilter[], editFiltersNew: QcEditFilter[];
				const layerId = this.selectedLayer.id;
				let newIds = newGtoRsp ? newGtoRsp.globalIds : [];
				if (!this.selectedLayer.category.isCollaborative) {
					let rsp;
					let changedCols = data.changedCols.concat(data.newRecordsChangedCols);
					changedCols = changedCols.filter((c, idx) => changedCols.indexOf(c) === idx);
					if (layerCate !== this.attrIndexService.cateCodeAddress || !newIds.length) {
						if (changedCols.length) {
							let dynamicQcKeyvals = data.dynamicQcKeyvals;
							if (newIds.length) {
								dynamicQcKeyvals = dynamicQcKeyvals.concat(newIds);
							}
							editFilters = [{
								gly_id: layerId,
								cols: changedCols,
								keyvals: dynamicQcKeyvals
							}];
							isDynamicQc = true;
						}
					} else {
						if (data.changedCols.length) {
							const dynamicQcKeyvals = data.dynamicQcKeyvals;
							editFilters = [{
								gly_id: layerId,
								cols: data.changedCols,
								keyvals: dynamicQcKeyvals
							}];
							isDynamicQc = true;
							// rsp = await this.qcService.qcLayersDynamic(editFilters);
						}
						// newly added records
						const dynamicQcKeyvals = newIds;
						const newRecordsChangedCols = data.newRecordsChangedCols.filter(c => {
							// const standard = this.selectedLayer.category.standardCols.find(s => this.selectedLayer.category.colPrefix + '_' + s.colName.toLowerCase() === c);
							const col = this.columns.find(col => col.prop === c);
							if (col && col.info.isFishbone) {
								return false;
							} else {
								return true;
							}
						});
						editFiltersNew = [{
							gly_id: layerId,
							cols: newRecordsChangedCols,
							keyvals: dynamicQcKeyvals
						}];

						// if (gtoRsp.newIds && gtoRsp.newIds.length) {
						// 	const editFilter: QcEditFilter = {
						// 		gly_id: layerId,
						// 		keyvals: gtoRsp.newIds
						// 	};
						// 	await this.qcService.qcLayerDomain(layerId, editFilter);
						// 	await this.qcService.qcLayerContent(layerId, editFilter);
						// }
					}

					if (isDynamicQc || isDynamicQcNew) {
						this.toastr.success('Changes saved successfully', null, {
							timeOut: 800
						});
						this.toastr.info('Start Qc/Fishbone analysis...')
					} else {
						this.toastr.success('Successfully updated', null, {
							timeOut: 800
						});
					}
					if (isDynamicQc) {
						rsp = await this.qcService.qcLayersDynamic(editFilters);
					}
					if (isDynamicQcNew) {
						rsp = await this.qcService.qcLayersDynamic(editFiltersNew);
					}

					if (isDynamicQc || isDynamicQcNew) {
						this.toastr.success('Qc/Fishbone analysis completed', null, {
							timeOut: 800
						});
					}
					if (rsp && rsp.misc  && rsp.misc.transition > 0) {
						this.qcService.qcLayers([this.selectedLayer.id]);
					}
	
				}
			} catch (err) {
				console.log(err);
			}

			// Get data and zoom to prev selected 
			const paging: PagingParam = this.dataTable.tablePaging ? {
				pageNumber: this.dataTable.tablePaging.pageNum,
				pageSize: this.pageSize
			} : null;
			// this.clearDataCards();
			this.clearChanges();
			// Clear stored data
			this.clearStoredData();
			this.clearBgSurroundingData();
			// update layer state
			this.toastr.info('Refreshing...')
			await this.updateLayerList(true);
			await this.getData(paging);
			//
			// const current = this.cardSelectedRecord;
			// if (current && this.getRecordId(current)) {
			// 	const id = this.getRecordId(current);
			// 	// this.activityService.selectedRecord.next({
			// 	// 	id: id
			// 	// })
			// 	this.activityService.selectedRecordsBS.next({
			// 		ids: [id]
			// 	})
			// }
			if (this.currentCardId) {
				// TODO
				this.activityService.selectedRecordsBS.next({
					ids: [this.currentCardId]
				})
			}
		}
	}

// #region Map
	private updateMyLayerMapConfig() {
		this.mapInfo = {
			selectionLayerNames: [this.mapLayerService.dataLayerName]
		};
	}
	private updateFishboneMapConfig() {
		this.mapInfo = {
			selectionLayerNames: [this.mapLayerService.fishboneLayerName]
		};
	}
	// private updateCollaborativeMapConfig() {
	// 	this.mapInfo = {
	// 		selectionLayerNames: [this.mapLayerService.dataLayerName]
	// 		// selectionLayerNames: [this.demarcationService.dmLayerName]
	// 	};
	// }

	// On select a feature from map. // Note: this is used when mapEditing is off
	private onSelectFromMap = async (e) => {
		let selected: Feature[] = e.selected;

		// if (this.isTopologyOn) {
		// 	selected.forEach(feat => {
		// 		const featId = feat.getId();
		// 		if (featId) {
		// 			// Find feat on data layer
		// 			selected = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].getSource().getFeatureById(featId);
		// 		}
		// 	})
		// }
		if (this.isMapEditing && !this.isPickingFeatureInEditing) {
			if (!this.isTopoEditing) {
				if (e.deselected.length) {
					// Move deselected features from modify layer to data layer
					this.mapService.moveFeaturesBackFromModifyLayer(e.deselected);
				}
				// Push selected feature from data layer to modify layer
				this.mapService.moveFeaturesToModifyLayer(selected, null, this.activityService.networkTopoMode.getValue().isOn);
			}
		}

		const detailPromises = [];
		selected.forEach(feat => {
			const id = feat.getId();
			const attrs = this.mainDataService.getDataAttrs(id);
			if (!attrs || attrs[this.isIdOnlyKey]) {
				const promise = this.updateFeatureDetail(id);
				detailPromises.push(promise);
			}
		})
		await Promise.all(detailPromises);

		const ids = e.target.getFeatures().getArray().map(f => f.getId());
		this.activityService.selectedRecordsBS.next({
			ids: ids,
			source: 'map'
		});
		const stacked = selected.find(f => f.getProperties()[this.attrIndexService.sameLocationKey]);
		if (stacked) {
			const featsAtSamePoint = [];
			this.mapService.map.olMap.forEachFeatureAtPixel(e.mapBrowserEvent.pixel, (feat) => {
				if (feat.getProperties()[this.attrIndexService.sameLocationKey] === stacked.getProperties()[this.attrIndexService.sameLocationKey]) {
					featsAtSamePoint.push(feat);
				}
			}, this.mapService.map.addedLayers[this.mapLayerService.dataLayerName]);
			// const selectedIds = this.mapService.dataSelectInteraction.getFeatures().getArray().map(f => f.getId());
			console.log('stackAddressesSelectBS', featsAtSamePoint)
			this.activityService.stackAddressesSelectBS.next({
				isOpen: true,
				list: featsAtSamePoint.map(feat => {
					return {
						id: feat.getId(),
						label: 'Floor: ' + feat.getProperties()[this.attrIndexService.addrFloorCol] + ', Unit: ' + feat.getProperties()[this.attrIndexService.addrUnitCol],
						isChecked: true // selectedIds.indexOf(feat.getId()) > -1
					}
				}),
				position: e.mapBrowserEvent.pixel
			})
		}
		// this.activityService.selectedRecord.next({
		// 	id: featId,
		// 	source: 'map'
		// });
	}
	private onDragBoxSelect = async (e) => {
		if (!this.mapSelectCondition()) {
			return;
		}
		const boxExtent = this.mapService.dragBox.getGeometry().getExtent();
		const dataLayerSource = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].getSource();
		const boxFeatures = dataLayerSource.getFeaturesInExtent(boxExtent);
		this.activityService.selectedRecordsBS.next({
			ids: boxFeatures.map(f => f.getId())
		});
	}
	selectFromMapCondition = (e: MapBrowserEvent<any>) => {
		if (e.type === 'singleclick') {
			return this.mapSelectCondition();
		}
	}
	private mapSelectCondition() {
		if (this.isTopologyOn || this.isAddingFeature || this.isAddingLabel || this.isAddingInteractiveFB || this.isMergeLine || this.mapService.isPickingFeat || this.mapService.drawInteraction || this.isBdryWizardOn) {
			return false;
		} else {
			return true;
		}
	}
	selectFromMapToggleCondition = (e: MapBrowserEvent<any>) => {
		if (this.tableSelectionType !== 'multi') {
			return false;
		} else {
			return condition.platformModifierKeyOnly(e);
		}
	}
	private onSelectFromMap_Fishbone = async (e) => {
		let selected = e.selected[0];
		const featId = selected ? selected.getId() : null;
		let fishboneIdType: FishboneCardType;
		if (selected) {
			if (selected.getProperties()[this.attrIndexService.isFishboneAddrKey]) {
				fishboneIdType = 'addr';
			} else if (selected.getProperties()[this.attrIndexService.isFishboneRoadKey]) {
				fishboneIdType = 'centerline';
			}
		}
		this.selectRecordOnTable_(featId, fishboneIdType);


		// TODO
		await this.updateSelectedCard_fishbone(this.selectedRows[0]);



		if (fishboneIdType === 'addr') {
			// Check if matching centerine is selected
			if (this.cardSelectedCenterline) {
				this.selectFishboneFeatureOnMap(null, [this.getRecordId(this.cardSelectedCenterline)], true);
			}
		} else if (fishboneIdType === 'centerline') {
			// Check if matching addr is selected
			if (this.cardSelectedAddr) {
				this.selectFishboneFeatureOnMap(this.getRecordId(this.cardSelectedAddr), null, true);
			}
		}
	}

	private sampleFeatures(feats: Feature[]) {
		return feats.map(i => i).sort(() => 0.5 - Math.random()).slice(0, this.sampleNum);
	}
	private setMapMoveProcessing(isProcessing?: boolean) {
		if (this.isProcessingMapMoving !== isProcessing) {
			this.isProcessingMapMoving = isProcessing;
			this.activityService.mapMoveProcessingBS.next({
				isProcessing: isProcessing
			});
		}
	}
	private dataLayerStyle = (feat, reso) => {
		const layer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		const styles = this.mapLayerService.getDataLayerStyle(feat, reso, layer, this.modelKey);
		if (this.isFishboneOn && this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
			// const selected = this.activityService.selectedRecordsBS.getValue();
			if (this.mapReso < this.mapLayerService.fishboneReso) { // || (selected && selected.ids && selected.ids.indexOf(feat.getId()) > -1)
				const fbSpikeStyle = this.mapLayerService.getFishboneSpikeStyle(feat, reso, this.modelKey);
				if (fbSpikeStyle) {
					styles.push(fbSpikeStyle);
				}
			}
		}
		// if (feat.getId() === this.currentCardId) {
		// 	const currentRecordStyle = this.mapLayerService.getCurrentDataStyle();
		// 	currentRecordStyle.setZIndex(0);
		// 	styles.push(currentRecordStyle);
		// }
		return styles;
	}
	private bgRefLayerStyle = (feat, reso) => {
		const styles = this.mapLayerService.getDataBgLayerStyle(feat, reso, this.modelKey);
		const layer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		const geomType = feat.getGeometry().getType();
		if (geomType === 'Point') {
			// Draw label for point
			if (this.mapLayerService.checkDrawAddrLabel(reso, layer)) {
				styles.push(this.mapLayerService.getAddressLabelStyle(feat.getProperties()));
			}
			// Draw fishbone
			if (this.isFishboneOn && this.mapReso < this.mapLayerService.fishboneReso) {
				const fbSpikeStyle = this.mapLayerService.getFishboneSpikeStyle(feat, reso, this.modelKey);
				if (fbSpikeStyle) {
					styles.push(fbSpikeStyle);
				}
			}
		}
		return styles;
	}
	private bgSurroundingLayerStyle = (feat, reso) => {
		const styles = this.mapLayerService.getDataBgLayerStyle(feat, reso);
		// Draw label for point
		const layer = this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
		if (this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
			// Draw label for address
			if (this.mapLayerService.checkDrawAddrLabel(reso, layer)) {
				styles.push(this.mapLayerService.getAddressLabelStyle(feat.getProperties()));
			}
			// Draw fishbone
			if (this.isFishboneOn && this.mapReso < this.mapLayerService.fishboneReso) {
				const fbSpikeStyle = this.mapLayerService.getFishboneSpikeStyle(feat, reso, this.modelKey);
				if (fbSpikeStyle) {
					styles.push(fbSpikeStyle);
				}
			}
		}
		return styles;
	}

	private addMapFunctions() {
		// Add data layer style here
		const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		dataLayer.setStyle(this.dataLayerStyle);
		const surroundingLayer = this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
		surroundingLayer.setStyle(this.bgSurroundingLayerStyle);
		const refLayer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		refLayer.setStyle(this.bgRefLayerStyle);
		//
		this.mapService.addDataSelectInteraction(this.onSelectFromMap, this.selectFromMapCondition, this.selectFromMapToggleCondition, (feat, reso) => {
			const drawingStyles = this.dataLayerStyle(feat, reso);
			// Manually add fb spikes for selected data that fall out of drawing resolution
			if (this.isFishboneOn && this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
				if (this.mapReso >= this.mapLayerService.fishboneReso) { 
					const fbSpikeStyle = this.mapLayerService.getFishboneSpikeStyle(feat, reso, this.modelKey);
					if (fbSpikeStyle) {
						drawingStyles.push(fbSpikeStyle);
					}
				}
			}
			return this.mapLayerService.getDataSelectionStyle(feat, reso, drawingStyles);
			// if (this.isFishboneOn) {
			// 	return this.mapLayerService.getFishboneAddressLayerStyle(feat, reso, this.modelKey);
			// } else {
			// 	return this.mapLayerService.getDataSelectionStyle(feat, reso, dataLayer, this.modelKey);
			// }
		});
		this.mapService.addDragBoxSelection(this.mapService.map, this.onDragBoxSelect);
	}
	private addMapListeners() {
		this.mapService.map.olMap.on('movestart', () => {
			if (this.mapMoveTimeout) {
				clearTimeout(this.mapMoveTimeout);
			}
		});
		this.mapService.map.olMap.on('moveend', (e) => {
			this.setMapMoveProcessing(true);
			if (this.mapMoveTimeout) {
				clearTimeout(this.mapMoveTimeout);
			}
			this.mapService.mapMoveendSubject.next();

			// Update zoomLevel
			const ext = this.mapService.map.olMap.getView().calculateExtent();
			const isZoomIn = this.mapExtent && containsExtent(this.mapExtent, ext);
			this.mapExtent = ext;
			this.mapReso = this.mapService.map.olMap.getView().getResolution();
			//
			const reso = this.mapReso; // this.mapService.map.olMap.getView().getResolution();
			this.isMapWithinDetailReso = reso <= this.detailReso;
			// Store current view
			this.mapSharedService.mapViewReso = reso;
			this.mapSharedService.mapViewCenter = this.mapService.map.olMap.getView().getCenter();
			//
			this.mapMoveTimeout = setTimeout(async () => {
				if (this.isTopoEditing) {
					await this.onMapMoveend_topoEditing();
				} else {
					await this.onMapMoveend(isZoomIn);
				}
				this.setMapMoveProcessing(false);
			}, this.mapService.moveWaitTime);
		});

		this.mapService.map.olMap.on('pointermove', (e) => {
			if (this.isAddingLabel || this.isAddingInteractiveFB || this.isSplitLine || this.mapService.isPickingFeat) {
				return;
			}
			if (this.isMapEditing) {
				return;
			}
			// this.pointermoveTimeout = setTimeout(() => {
			this.onMapPointermove(e);
			// }, 600);
		});
	}
	private onMapPointermove(e: MapBrowserEvent<any>) {
		// For bdry layer
		const bdryLayer = this.mapService.map.addedLayers[this.mapLayerService.bgOptionalBdryLayerName];
		const surroundingLayer = this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
		// Check if mouse over feature
		let hitSurrounding;
		let hitBdry;
		let content = ''
		let cursor = this.mapService.map.olMap.getViewport().style.cursor;
		const hit = e.map.forEachFeatureAtPixel(e.pixel, (f, layer) => {
			if (layer === bdryLayer) {
				// Set tooltip
				const props = f.getProperties();
				content = props[this.attrIndexService.bdryCountyNameCol] || props[this.attrIndexService.bdryStateNameCol] || props[this.attrIndexService.bdryDisplayNameCol] || props[this.attrIndexService.bdryUnincNameCol] || props[this.attrIndexService.bdryIncNameCol] || 'N/A';
				content = bdryLayer.getProperties()[this.attrIndexService.bdryLayerCodeKey] + ': ' + content;
				hitBdry = true;
			} else if (layer === surroundingLayer) {
				const props = f.getProperties()[this.attrKey];
				content = this.editService.getDmBackgroundTooltipContent(props);
				hitSurrounding = true;
			} else {
				return false;
			}
			return true;
		});
		// Bdry info don't need timeout
		if (!hitBdry) {
			if (this.pointermoveTimeout) {
				clearTimeout(this.pointermoveTimeout);
				this.pointermoveTimeout = null;
			}
		}
		// Change cursor shape if mouse over feature
		if (hitSurrounding) {
			// e.map.getViewport().style.cursor = 'pointer';
			this.mapSharedService.changeCursor(e.map, 'pointer')
		} else {
			// e.map.getViewport().style.cursor = '';
			this.mapSharedService.changeCursor(e.map, cursor)
		}
		// if (this.pointermoveTimeout) {
		// 	clearTimeout(this.pointermoveTimeout);
		// }
			if (hitBdry) {
				const bdryInfoElem = this.document.getElementById('mapBdryInfo');
				if (!bdryInfoElem) {
					return;
				}
				bdryInfoElem.innerHTML = content;
				// tooltipElem.style.display = '';
				// tooltipElem.innerHTML = content;
				// // Position
				// tooltipElem.style.top = this.document.documentElement.clientHeight - 45 + 'px';
				// tooltipElem.style.left = '165px';
			} else {
				// Add tooltip
				const tooltipElem = this.bgTooltipElem.nativeElement;
				if (!tooltipElem) {
					return;
				}
				if (hit) {
					this.pointermoveTimeout = setTimeout(() => {
						tooltipElem.style.display = '';
						tooltipElem.innerHTML = content;
						// Position
						this.cMapService.setTooltipPosition(tooltipElem, e.map.getTarget(), e.pixel, 3);	
						this.pointermoveTimeout = null;
					}, 800)
				} else {
					tooltipElem.style.display = 'none';
				}
			}
	}
	private async onMapMoveend(isZoomIn: boolean) {
		if (!this.selectedLayer) {
			return;
		}
		if (this.pauseGettingData) {
			this.pauseGettingData = false;
			return;
		}
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const ext = this.mapService.map.olMap.getView().calculateExtent();
			const reso = this.mapReso;
			const z = this.mapService.map.olMap.getView().getZoom(); // TODO
			// Data layer
			const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
			if (this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
				await this.updateAddrLabelCalc(this.mainDataService.dataLabelCalc, dataLayer, ext, reso, z, this.selectedLayer.id);
				const surroundingLayer = this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
				await this.updateAddrLabelCalc(this.mainDataService.dataLabelCalc, surroundingLayer, ext, reso, z, this.selectedLayer.id);
			}
			const refLayer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
			if (refLayer.getProperties()[this.attrIndexService.refLayerCodeKey] === this.attrIndexService.cateCodeAddress) {
				const refLayerId = refLayer.getProperties()[this.attrIndexService.refLayerIdKey];
				await this.updateAddrLabelCalc(this.mainDataService.refDataLabelCalc, refLayer, ext, reso, z, refLayerId);
			}

			if (this.isMapEditing) {
				this.commonService.setLoadingSpinner(false, spinnerId);
				return; // TODO
			}
			// Get data
			if (this.isMapFilterOn) {
				// const isDataWithinExt = this.mainDataService.wholeData.extent && containsExtent(this.mainDataService.wholeData.extent, ext);
				const isDataWithinExt = this.mainDataService.retrievedData.extent && containsExtent(this.mainDataService.retrievedData.extent, ext);

				if (isDataWithinExt) { //  && this.mainDataService.wholeData.feats
					let filtered = [];
					let rowsAll: any[] = [];
					if (isZoomIn) {
						filtered = this.mapService.filterFeaturesInExtent(dataLayer.getSource().getFeatures(), ext);
						rowsAll = filtered.map(f => this.mainDataService.getDataAttrs(f.getId()));
					} else {
						const wktFormat = new WKT();
						this.mainDataService.retrievedData.ids.forEach(id => {
							const attrs = this.mainDataService.getDataAttrs(id);
							const wkt = attrs[this.geomColName_manual];
							if (wkt) {
								const geom = wktFormat.readGeometry(wkt);
								if (geom.intersectsExtent(ext)) {
									const feat = new Feature({
										geometry: geom
									});
									feat.setId(id);
									this.addFishboneInfoToFeature(feat, attrs[this.addrFishboneCol]);
									filtered.push(feat);
									rowsAll.push(attrs);
								}
							}
						})
					}
					// Update batchFilterCount // This has to go before check isDisplaySample
					this.activityService.batchFilterCount.next({
						count: filtered.length
					});
					//
					const source = dataLayer.getSource();
					// This should be done before clearing source
					// Add back the edited features if needed
					const prevEditedFeatures = [];
					// Remove duplicated from the previous edited records (instead of removing from prev edited features since you need keep the edited feature )
					const editedIdList = this.activityService.editRecordListBS.getValue().ids;
					editedIdList.forEach(id => {
						const uuid = id;
						const editedFeat = source.getFeatureById(uuid);
						if (editedFeat) {
							prevEditedFeatures.push(editedFeat);
							let featIdx = filtered.findIndex(f => f.getId() === uuid);
							if (featIdx > -1) {
								filtered.splice(featIdx, 1);
							}
							let rowIdx = rowsAll.findIndex(r => this.getRecordId(r) === uuid);
							if (rowIdx > -1) {
								rowsAll.splice(rowIdx, 1);
							}
						}
					});
					// Add features to vector layer
					source.clear();
					if (filtered.length > this.displaySampleLimit) {
						this.isDisplaySample = true;
						const sampled = this.sampleFeatures(filtered);
						filtered = sampled;
					} else {
						this.isDisplaySample = false;
					}
					this.updateIsSample();

					source.addFeatures(filtered);
					source.addFeatures(prevEditedFeatures);
					rowsAll = editedIdList.map(id => this.mainDataService.getDataAttrs(id)).concat(rowsAll);
					this.rowsAll = rowsAll;
					this.setTablePaging(this.rowsAll.length);
					const rows = this.getRowsByPageNum(1);
					this.setRows(rows);
					this.tableService.updateColumnsSmartDisplay(this.rows, this.columns);



					// Filter features in extent
					// let filtered = this.mapService.filterFeaturesInExtent(this.mainDataService.wholeData.feats, ext);

					// // Update batchFilterCount // This has to go before check isDisplaySample
					// this.activityService.batchFilterCount.next({
					// 	count: filtered.length
					// });
					// //
					// let rowsAll = this.mainDataService.wholeData.rows.filter(r => filtered.find(f => f.getId() === this.getRecordId(r)));
					// const source = dataLayer.getSource();
					// // This should be done before clearing source
					// // Add back edited features if needed
					// const prevEditedFeatures = [];
					// // Remove duplicated from the previous edited records (instead of removing from prev edited features since you need keep the edited feature )
					// this.editRecordList.forEach(i => {
					// 	const uuid = this.getRecordId(i);
					// 	const editedFeat = source.getFeatureById(uuid);
					// 	if (editedFeat) {
					// 		prevEditedFeatures.push(editedFeat);
					// 		let featIdx = filtered.findIndex(f => f.getId() === uuid);
					// 		if (featIdx > -1) {
					// 			filtered.splice(featIdx, 1);
					// 		}
					// 	}
					// });
					// // Add features to vector layer
					// source.clear();
					// if (filtered.length > this.displaySampleLimit) {
					// 	this.isDisplaySample = true;
					// 	const sampled = this.sampleFeatures(filtered);
					// 	filtered = sampled;
					// } else {
					// 	this.isDisplaySample = false;
					// }
					// this.updateIsSample();

					// source.addFeatures(filtered);
					// source.addFeatures(prevEditedFeatures);
					// rowsAll = this.editRecordList.concat(rowsAll);
					// this.rowsAll = rowsAll;
					// this.setTablePaging(this.rowsAll.length);
					// const rows = this.getRowsByPageNum(1);
					// this.setRows(rows);
					// this.tableService.updateColumnsSmartDisplay(this.rows, this.columns);
				} else {
					await this.getData(null, {
						keepEditedData: true,
						keepPrevColumns: true,
						keepSelectedData: true
					});
				}
			} else {
				await this.drawBgSurroundings(reso);
			}
			// Bg ref layer
			await this.drawBgRefLayer(reso);
			// Bg bdry layer
			await this.drawBgBdryLayer();

			if (this.isFishboneOn) {
				this.drawAddrFishbone();
			}
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	private async onMapMoveend_topoEditing() {
		if (this.isMapEditing && this.isTopologyOn) {
			if (!this.mapService.checkZoomLevelForTopoEditing()) {
				this.mapService.removeTopoModifyInteraction(this.mapService.map);
				// Redraw topo layer to update feature style
				const source = this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource();
				const feats = source.getFeatures();
				source.clear();
				source.addFeatures(feats);
				return;
			} else {
				if (!this.mapService.topojsonModify) {
					this.mapService.addTopoModifyInteraction(this.mapService.map, this.onTopojsonModifyend);
				}
				// if (!isZoomIn) {
				// 	await this.updateTopojson();
				// }
			}
		}
	}
	private async updateFeatureDetail(id) {
		if (!id) {
			return;
		}
		const filter = this.gfoService.getFilter(this.getIdCol(), this.appinfoService.filterOperators.eq.name, id);
		const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
		// let dataLayerName;
		let data;
		const selectedLayer = this.selectedLayer;
		let rsp;
		// const qaCodes = this.mainDataService.getQaCodesFromFilterOptions();
		rsp = await this.qcService.getQcFeatureReport(selectedLayer.id, null, gfo);
		data = rsp.data;
		// dataLayerName = this.mapLayerService.dataLayerName;

		if (data && data[0]) {
			const originAttrs = this.mainDataService.getDataOriginAttrs(id);
			if (originAttrs) {
				data[this.geomColName_manual] = originAttrs[this.geomColName_manual];
			}
			this.mainDataService.addDataToStoredRecords(data, this.getIdCol());

			const attrs = this.mainDataService.getDataAttrs(id);
			this.mainDataService.setDataAttrs(id, this.isIdOnlyKey, false);

			const idx = this.rows.findIndex(r => this.getRecordId(r) === id);
			if (idx > -1) {
				this.rows.splice(idx, 1, attrs); // use splice instead of rows[idx] = data, so that the qc-error class would be rendered
			}
			// Update rowsAll
			if (this.rowsAll.length) {
				const idxRowsAll = this.rowsAll.findIndex(r => this.getRecordId(r) === id);
				if (idxRowsAll > -1) {
					this.rowsAll.splice(idxRowsAll, 1, attrs)
				}
			}
			// Update columns
			let addJsonbCols = false;
			if (this.columns.length <= 1) {
				// this.setColumnsAndRows_myLayers(this.rows)
				const output = await this.updateColumns(this.rows);
				// Set rows after columns are updated since it's using columns
				addJsonbCols = output.isGetSchema;
			}
			this.processRows([attrs], addJsonbCols);
			// // Update props stored in feature
			// const feat = this.mapService.map.addedLayers[dataLayerName].getSource().getFeatureById(id);
			// const prop = feat.getProperties();
			// Object.keys(data).forEach(k => prop[this.attrKey][k] = data[k]);
			// delete prop[this.attrKey][this.isIdOnlyKey];
		}
	}
	// Used for updating details for rows in the page
	private async updateRowsDetail(rows: any[]) {
		const ids = rows.filter(r => r[this.isIdOnlyKey]).map(r => this.getRecordId(r));
		if (!ids.length) {
			return;
		}
		const filter = this.gfoService.getFilter(this.getIdCol(), this.appinfoService.filterOperators.in.name, ids);
		const gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, [filter]);
		let dataLayerName;
		let dataArray;
		const qaCodes = this.mainDataService.getQaCodesFromFilterOptions();
		const rsp = await this.qcService.getQcFeatureReport(this.selectedLayer.id, qaCodes, gfo);
		dataArray = rsp.data;
		dataLayerName = this.mapLayerService.dataLayerName;

		// Update geom manual
		if (dataArray) {
			dataArray.forEach(i => {
				const originAttrs = this.mainDataService.getDataOriginAttrs(i[this.getIdCol()]);
				if (originAttrs) {
					i[this.geomColName_manual] = originAttrs[this.geomColName_manual];
				}
			});
		}

		this.mainDataService.addDataToStoredRecords(dataArray, this.getIdCol());
		for (const data of dataArray) {
			const id = this.getRecordId(data);

			this.mainDataService.setDataAttrs(id, this.isIdOnlyKey, false);

			const idx = rows.findIndex(r => this.getRecordId(r) === id);
			if (idx > -1) {
				Object.assign(rows[idx], data); // do not use splice or rows[idx] = data, since you want to update the object itself, so that rows and rowsAll will both be updated
				delete rows[idx][this.isIdOnlyKey];
			}
			// Update columns
			let addJsonbCols = false;
			if (this.columns.length <= 1) {
				const output = await this.updateColumns(rows);
				// Process rows after columns are updated since it's using columns
				addJsonbCols = output.isGetSchema;
			}
			this.processRows([data], addJsonbCols);
			// Update props stored in feature // This is only for polygon to draw 4-color
			if (this.selectedLayer.category.geomType === 'AREA') {
				const feat = this.mapService.map.addedLayers[dataLayerName].getSource().getFeatureById(id);
				const prop = {};
				prop[this.attrIndexService.bdryColorCol] = data[this.attrIndexService.bdryColorCol];
				feat.setProperties(prop);
				// Object.keys(data).forEach(k => prop[this.attrKey][k] = data[k]);
				// delete prop[this.attrKey][this.isIdOnlyKey];
			}
		}
	}
	private onPointOrLineModifystart = (e) => {
		const feat = e.features.getArray()[0];
		const featId = feat.getId();
		// Store coords
		if (feat.getGeometry().getType() === 'LineString') {
			this.coordsAtModifystart = feat.getGeometry().getCoordinates().map(c => c);
		}
			// // Trigger change
			// this.editCardRef.onChange(null, true);
		const attrs = this.mainDataService.getDataAttrs(featId);
		if (!attrs[this.isEditedCol]) {
			// Add card
			this.mainDataService.addRecToCard(featId, null, 'geomEdit', null, true);
		}
	}
	// After modify feature geom on map, update the stored geom property on feat & card
	private updateFeatStoredGeom (feat, isPoint?: boolean) {
		// const wktFormat = new WKT();
		// const wktString = wktFormat.writeGeometry(feat.getGeometry());
		// const prop = feat.getProperties();
		// prop[this.attrKey][this.geomColName_manual] = wktString;
		// feat.setProperties(prop);
		// //
		// const card = this.editRecordList.find(c => this.getRecordId(c) === feat.getId());
		// if (card) {
		// 	card[this.geomColName_manual] = wktString;
		// }
		// return wktString;
		
		const wktFormat = new WKT();
		const wktString = wktFormat.writeGeometry(feat.getGeometry());
		this.mainDataService.setDataAttrs(feat.getId(), this.geomColName_manual, wktString);
		// Update latlong for point data
		if (isPoint) {
			const latlong = this.mapSharedService.transformPointToLatlong(feat.getGeometry().getCoordinates());
			this.mainDataService.setDataAttrs(feat.getId(), this.attrIndexService.addrLatitudeCol, latlong[1]);
			this.mainDataService.setDataAttrs(feat.getId(), this.attrIndexService.addrLongitudeCol, latlong[0]);
		}

		//
		return wktString;
	}
	private onPointDataModifyend = async (e) => {
		const feat = e.features.getArray()[0];
		const featId = feat.getId();
		// Update stored geom
		if (!this.selectedLayer.category.isCollaborative) {
			this.updateFeatStoredGeom(feat, true);
			const sameLocKey = feat.getProperties()[this.attrIndexService.sameLocationKey];
			if (sameLocKey) {
				this.mapService.dataSelectInteraction.getFeatures().forEach(f => {
					if (f.getId() !== featId && f.getProperties()[this.attrIndexService.sameLocationKey] === sameLocKey) {
						(<Point>f.getGeometry()).setCoordinates(feat.getGeometry().getCoordinates());
						this.updateFeatStoredGeom(f, true);
					}
				})
			}
			const featsOnDataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].getSource().getFeatures();
			const featsOnModifyLayer = this.mapService.map.addedLayers[this.mapLayerService.dataModifyLayerName].getSource().getFeatures();
			this.updateSameLocationPoint(featsOnDataLayer.concat(featsOnModifyLayer));
		} else {
			// Edge point layer
			if (this.selectedLayer.category.code === this.attrIndexService.cateCodeMatchPoint) {
				const wktFormat = new WKT();
				const wktString = wktFormat.writeGeometry(feat.getGeometry());
				// this.checkCoordinateOutsideBdry(coord)
				const coords = feat.getGeometry().getCoordinates();
				const adjustedCoord = this.adjustCoordInsideBdry(coords);
				if (adjustedCoord[0] !== coords[0] || adjustedCoord[1] !== coords[1]) {
					// feat.setGeometry(new Point(adjustedCoord));
					feat.getGeometry().setCoordinates(adjustedCoord);
				}
				//
				// this.editCardRef.onChange();
				const attrs = this.mainDataService.getDataAttrs(featId);
				if (!attrs[this.isEditedCol]) {
					// Add card
					this.mainDataService.addRecToCard(featId, null, 'geomEdit', null, true);
				}
				// onGeomChange need to go after onChange because it need editedRecordList to be updated
				this.onEdgePointGeomChange(adjustedCoord, featId);
				// Update coordinate in edited record
				
				this.mainDataService.setDataAttrs(featId, this.geomColName_manual, wktString);
				this.updateSelectedCoordsFromXy(coords);
			}
		}
	}
	private onCenterlineModifyend = async (e) => {
		const feat = e.features.getArray()[0];
		const map = this.mapService.map;
		const isNetworkTopoOn = this.activityService.networkTopoMode.getValue().isOn;
		//
		const coords = feat.getGeometry().getCoordinates();
		const topo: EditLineTopo = feat.getProperties()[this.attrIndexService.lineTopoCol];
		// Update line geom and add to cards if needed
		const updateLineGeom = async (f, originalCoord, updatedCoord) => {
			const id = f.getId();
			const lineGeom = f.getGeometry();
			const coords = lineGeom.getCoordinates();
			let hasChanged = false;
			if (JSON.stringify(coords[0]) === JSON.stringify(originalCoord)) {
				coords[0] = updatedCoord;
				hasChanged = true;
			} else if (JSON.stringify(coords[coords.length - 1]) === JSON.stringify(originalCoord)) {
				coords[coords.length - 1] = updatedCoord;
				hasChanged = true;
			}
			if (hasChanged) {
				lineGeom.setCoordinates(coords);
				const attrs = this.mainDataService.getDataAttrs(id);
				if (attrs && !attrs[this.isEditedCol]) {
					// Update details if needed
					if (attrs[this.isIdOnlyKey]) {
						await this.updateFeatureDetail(id);
					}
					// Add card
					this.mainDataService.addRecToCard(id, this.attrIndexService.cateCodeCenterline, 'geomEdit', null, true);
				}
					// // Update properties
					// let attrs = f.getProperties()[this.attrKey];
					// if (!attrs[this.isEditedCol]) {
					// 	// Update details if needed
					// 	if (attrs[this.isIdOnlyKey]) {
					// 		await this.updateFeatureDetail(id);
					// 		attrs = f.getProperties()[this.attrKey];
					// 	}
					// 	// Add card
					// 	const card = JSON.parse(JSON.stringify(attrs));
					// 	this.addRecToCard(attrs, card);
					// 	attrs[this.isEditedCol] = true;
					// 	const props = {};
					// 	props[this.attrKey] = attrs;
					// 	f.setProperties(props);
					// }
				this.updateFeatStoredGeom(f);
			}
		};
		if (isNetworkTopoOn) {
			const promises = [];
			if (!this.mapSharedService.isCoordsEqual(coords[0], this.coordsAtModifystart[0])) { // start coord has changed
				if (topo.startVertex) {
					topo.startVertex.feats.forEach(f => promises.push(updateLineGeom(f, this.coordsAtModifystart[0], coords[0])));
				}
			} else if (!this.mapSharedService.isCoordsEqual(coords[coords.length - 1], this.coordsAtModifystart[this.coordsAtModifystart.length - 1])) { // end coord has changed
				if (topo.endVertex) {
					topo.endVertex.feats.forEach(f => promises.push(updateLineGeom(f, this.coordsAtModifystart[this.coordsAtModifystart.length - 1], coords[coords.length - 1])));
				}
			} else {
				//
			}
			await Promise.all(promises);
		}
		// Update stored geom
		this.updateFeatStoredGeom(feat);
		feat.changed(); // To update feature style


		// Check if the modified point falls on any other centerline
		const modifyPoint = e.mapBrowserEvent.pixel;
		let fallOnFeats = []; // The centerline that the modified end falls on
		map.olMap.forEachFeatureAtPixel(modifyPoint, (f, l) => {
			if (l === map.addedLayers[this.mapLayerService.dataLayerName] || l === map.addedLayers[this.mapLayerService.bgSurroundingsLayerName]) {
				fallOnFeats.push(f);
			}
		});
		if (!fallOnFeats.length) {
			return;
		}

		const fallOnPoint = e.mapBrowserEvent.coordinate;
		// Find features the endpoints of which are the fallOnPoint
		const endPointFeats = fallOnFeats.filter(f => {
			const lineCoords: any[] = f.getGeometry().getCoordinates();
			if (this.mapSharedService.isCoordsEqual(fallOnPoint, lineCoords[0])) {
				return true;
			} else if (this.mapSharedService.isCoordsEqual(fallOnPoint, lineCoords[lineCoords.length - 1])) {
				return true;
			}
		});
		if (endPointFeats.length) {
			// Update feature's stored topo
			this.mapService.updateCenterlineTopo(feat, true);
			return;
		}

		// User confirm snap
		const data: ConfirmModalData = {
			message: 'Do you want to break the line at snapping point?',
			yesBtnText: 'Yes',
			noBtnText: 'No'
		};
		const options = this.modalService.confirmModalOptions;
		options.data = data;
		const res = await this.modalService.openModalWindow(ConfirmModalComponent, options);
		if (!res) {
			return;
		}

		// If no features' endpoint is the fallOnPoint, it must fall on the middle of a feature.
		// Split the fall-on feat to 2 new lines - partA & partB
		const  fallOnFeat = fallOnFeats[0];
		const splits = await this.splitLineRecord(fallOnFeat, fallOnPoint)
			// let fallOnFeatAttrs = this.mainDataService.getDataAttrs(fallOnFeat.getId()); // fallOnFeat.getProperties()[this.attrKey];
			// // Update feature detail if needed
			// if (!fallOnFeatAttrs || fallOnFeatAttrs[this.isIdOnlyKey]) {
			// 	await this.updateFeatureDetail(fallOnFeat.getId());
			// 	fallOnFeatAttrs = this.mainDataService.getDataAttrs(fallOnFeat.getId());
			// }
			// const splits = this.splitMergeService.splitLineFeat(fallOnFeat, fallOnPoint);
			// 	// const pos = this.mapSharedService.findCoordPositionOnPolygon(fallOnPoint, [lineCoords]);
			// 	// const partA = lineCoords.slice(0, pos[0] + 1);
			// 	// partA.push(fallOnPoint);
			// 	// const partB = lineCoords.slice(pos[1]);
			// 	// partB.unshift(fallOnPoint);
			// 	// // Create and add a new feat using partA
			// 	// let recPartA = this.mainDataService.addNewCard(this.getIdCol());
			// 	// const partAId = this.getRecordId(recPartA);
			// 	// Object.keys(fallOnFeatAttrs).forEach(key => {
			// 	// 	if (!recPartA.hasOwnProperty(key)) {
			// 	// 		// recPartA[key] = fallOnFeatAttrs[key];
			// 	// 		this.mainDataService.setDataAttrs(partAId, key, fallOnFeatAttrs[key]);
			// 	// 	}
			// 	// })
			// 	// const featA = fallOnFeat.clone();
			// 	// featA.setId(partAId);
			// 	// featA.setGeometry(new LineString(partA));
			// 	// // Create and add a new feat using partB
			// 	// let recPartB = this.mainDataService.addNewCard(this.getIdCol());
			// 	// const partBId = this.getRecordId(recPartB);
			// 	// Object.keys(fallOnFeatAttrs).forEach(key => {
			// 	// 	if (!recPartB.hasOwnProperty(key)) {
			// 	// 		// recPartB[key] = fallOnFeatAttrs[key];
			// 	// 		this.mainDataService.setDataAttrs(partBId, key, fallOnFeatAttrs[key]);
			// 	// 	}
			// 	// });
			// 	// // Add the original id before split
			// 	// this.mainDataService.setDataAttrs(partAId, this.attrIndexService.idBeforeSplitKey, fallOnFeat.getId());
			// 	// this.mainDataService.setDataAttrs(partBId, this.attrIndexService.idBeforeSplitKey, fallOnFeat.getId());
				
			// 	// const featB = fallOnFeat.clone();
			// 	// featB.setId(partBId);
			// 	// featB.setGeometry(new LineString(partB));
			// // Remove original feat
			// const idx = this.rows.findIndex(r => this.getRecordId(r) === fallOnFeat.getId());
			// this.rows.splice(idx, 1);
			// this.setRows(this.rows.map(r => r)); // refresh rows
			// const idxRowsAll = this.rowsAll.findIndex(r => this.getRecordId(r) === fallOnFeat.getId());
			// this.rowsAll.splice(idxRowsAll, 1);
			// layer.getSource().removeFeature(fallOnFeat);
			// // Add original feat to hidden card
			// this.mainDataService.addRecToHiddenList(fallOnFeat.getId());
			// this.mainDataService.setDataAttrs(fallOnFeat.getId(), this.attrIndexService.isDeletedKey, true);
			// // const hiddenIds = this.activityService.editRecordListHiddenBS.getValue().ids;
			// // if (!hiddenIds.find(c => this.getRecordId(c) === fallOnFeat.getId())) {
			// // 	const deleteCard = {}
			// // 	deleteCard[this.attrIndexService.isDeletedKey] = true;
			// // 	deleteCard[this.getIdCol()] = fallOnFeat.getId();
			// // 	hiddenList.push(deleteCard);
			// // 	this.activityService.editRecordListHiddenBS.next({
			// // 		list: hiddenList,
			// // 		source: 'main'
			// // 	})
			// // }

			// // Add featA & featB to map
			// layer.getSource().addFeature(splits.featA);
			// layer.getSource().addFeature(splits.featB);
			// // this.mapService.updateCenterlineTopo(feat, true);
			// this.updateFeatStoredGeom(splits.featA);
			// this.updateFeatStoredGeom(splits.featB);

		this.mapService.updateCenterlineTopo(feat, true);

		this.splitMergeService.splitLineBS.next({
			id: fallOnFeat.getId(),
			splitPoint: fallOnPoint,
			splitPartsId: [splits.featA.getId(), splits.featB.getId()]
		});
		// this.floatPopupService.openFloatPopup();
		this.floatPopupService.openPopup(LineSplitComponent)

	}
	//
	async onMapContextmenu(e: MouseEvent) {
		if (this.editModeDisabled) { // || this.viewKey !== 'map'
			return;
		}
		// const priorityId = this.cardSelectedRecord ? this.getRecordId(this.cardSelectedRecord) : null;
		const priorityId = this.currentCardId;
		// const layers = this.mapInfo.selectionLayerNames.map(n => this.mapService.map.addedLayers[n]);
		const layers = [this.mapService.map.addedLayers[this.mapLayerService.dataLayerName], this.mapService.map.addedLayers[this.mapLayerService.dataModifyLayerName]];
		// Add topo layer
		if (this.isTopologyOn) {
			layers.push(this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName]);
		}
		const result = this.mapService.onMapContextmenu(e, this.mapContextmenu, this.mapService.map.olMap, layers, priorityId);
		this.rightClickVertex = result.vertex;
		this.rightClickCoord = result.coords;
		const selectedFeat = result.feature;
		if (selectedFeat && this.mapSelectCondition()) {
			if (selectedFeat.getId() !== priorityId) {
					// if (this.selectedLayer.isFishbone !== true && !this.selectedLayer.category.isCollaborative) {
					// 	// Update exceptions before selectedcard
					// 	await this.getExceptionsForRec();
					// }
				this.selectRecordOnTable(selectedFeat.getId());
				await this.selectRecordsOnMap([selectedFeat.getId()]);
				if (this.isSsapRclLinkModeOn) {
					await this.drawSsapRclLinkByCurrent();
				}
				this.updateCurrentCard(selectedFeat.getId());
			}
		}
		this.rightClickFeature = selectedFeat;
	}

	private async splitLineRecord(fallOnFeat: Feature<LineString>, fallOnPoint, layer?) {
		layer = layer || this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		let fallOnFeatAttrs = this.mainDataService.getDataAttrs(fallOnFeat.getId()); // fallOnFeat.getProperties()[this.attrKey];
		// Update feature detail if needed
		if (!fallOnFeatAttrs || fallOnFeatAttrs[this.isIdOnlyKey]) {
			await this.updateFeatureDetail(fallOnFeat.getId());
			fallOnFeatAttrs = this.mainDataService.getDataAttrs(fallOnFeat.getId());
		}
		const splits = this.splitMergeService.splitLineFeat(fallOnFeat, fallOnPoint);
		// Remove original feat
		const idx = this.rows.findIndex(r => this.getRecordId(r) === fallOnFeat.getId());
		this.rows.splice(idx, 1);
		this.setRows(this.rows.map(r => r)); // refresh rows
		const idxRowsAll = this.rowsAll.findIndex(r => this.getRecordId(r) === fallOnFeat.getId());
		this.rowsAll.splice(idxRowsAll, 1);
		layer.getSource().removeFeature(fallOnFeat);
		// Add original feat to hidden card
		this.mainDataService.addRecToHiddenList(fallOnFeat.getId());
		this.mainDataService.setDataAttrs(fallOnFeat.getId(), this.attrIndexService.isDeletedKey, true);
		// Add featA & featB to map
		layer.getSource().addFeature(splits.featA);
		layer.getSource().addFeature(splits.featB);
		// this.mapService.updateCenterlineTopo(feat, true);
		this.updateFeatStoredGeom(splits.featA);
		this.updateFeatStoredGeom(splits.featB);
		return {
			featA: splits.featA,
			featB: splits.featB
		}
	}

	// For collaborative layers, check if a feature's agency is the current agency
	private isSelfAgency(row) {
		switch (this.selectedLayer.category.code) {
			case this.attrIndexService.cateCodeMatchPoint:
				const cusIds = row[this.attrIndexService.epAgencyColumn] ? row[this.attrIndexService.epAgencyColumn].split(',') : [];  // TODO
				if (!cusIds.find(c => c == this.selectedCustomerId)) {
					return false;
				}
				break;
			default:
				const discAgencyId = row ? row[this.discrepancyAgencyIdColName] : null;
				if (!discAgencyId || discAgencyId !== this.appinfoService.customerProfile.discrepancyAgencyId) {
					return false;
				}
		}
		return true;
	}
	// feat is needed for point/line editing
	private async startMapEditing(selectedId?, skipGetTopo?: boolean) {
		this.isMapEditing = true;
		const selectedLayer = this.selectedLayer;

		const onSelectPointOrLine = (feat) => {
			if (!feat) {
				return;
			}
			this.isPickingFeatureInEditing = false;
				// // Set datalayer style
				// const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
				// dataLayer.setStyle(this.mapLayerService.getIrrelevantDataLayerStyleOnEditing);
			//
			const layerGeomType = selectedLayer.category.geomType;
			if (layerGeomType === 'POINT') { // POINT
				// Add selected data to modify layer
				this.mapService.moveFeaturesToModifyLayer([feat]);
				this.mapService.addDataModify(this.onPointOrLineModifystart, this.onPointDataModifyend);
			} else if (layerGeomType === 'LINE') { // Centerline only
				// Add selected data to modify layer
				this.mapService.moveFeaturesToModifyLayer([feat], null, this.activityService.networkTopoMode.getValue().isOn);
				this.mapService.addDataModify(this.onPointOrLineModifystart, this.onCenterlineModifyend);
			}
			// else { // AREA
			// 	if (selectedLayer.state.num === 1.52) { // TOPOLOGY state
			// 		// TODO
			// 	} else {
			// 		let mapExtent;
			// 		// // if (this.enableDiscrepancyAgencyRule && selectedLayer.category.isCollaborative) {
			// 			mapExtent = feat.getGeometry().getExtent();

			// 		// 	// // right click feature should be the feature that owned by agency
			// 		// 	// mapExtent = this.rightClickFeature.getGeometry().getExtent();
			// 		// // } else {
			// 		// // 	mapExtent = this.mapService.map.olMap.getView().calculateExtent();
			// 		// // }
			// 		// // Check Topo error
			// 		// const topo = await this.getTopojson(mapExtent, true);
			// 		// await this.checkTopoErrorIntra(topo.geojson, true);
					
			// 		// // Turn on/off topoErrorEditing mode & update topoErrorEditing layer
			// 		// if (this.topoCheck.overlap.length || this.topoCheck.gap.length || this.topoCheck.crevice.length) {
			// 		// 	this.turnOnTopoErrorEditing(this.topoCheck)
			// 		// } else {
			// 		// 	await this.turnOffTopoErrorEditing();
			// 		// }
	
			// 		// // If no topo error, start feature editing
			// 		// if (!this.isTopoErrorEditing) {
			// 			await this.getTopojson(mapExtent);
			// 			this.isTopologyOn = true;
			// 			this.enableTopoFeaturesEditing();
			// 		// }
			// 	}	
			// }
		}
		const onSelectPolygon = async (feat?) => {
			if (selectedLayer.state.num === 1.52) { // TOPOLOGY state
				// TODO
			} else {
				let mapExtent: number[];
				if (feat) {
					mapExtent = feat.getGeometry().getExtent();
				} else {
					// Get the full extent that contains all features in current view
					const ext = this.mapService.map.olMap.getView().calculateExtent();
					const olLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
					const featsWithinExt = olLayer.getSource().getFeaturesInExtent(ext);
					mapExtent = this.mapService.map.getFeaturesExtent(featsWithinExt);
				}
				if (!skipGetTopo) {
					await this.getTopojson(mapExtent);
				}
				this.isTopologyOn = true;
				this.enableTopoFeaturesEditing();
			}	
		}
		let selectedFeat;
		if (selectedId) {
			const olLayer = this.selectedLayer.category.geomType === 'AREA' ? this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName] : this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
			selectedFeat = olLayer.getSource().getFeatureById(selectedId);
		}
		if (!selectedFeat) {
			const selectedFeats = this.mapService.dataSelectInteraction.getFeatures().getArray();
			selectedFeat = selectedFeats[selectedFeats.length - 1];
		}
		if (selectedLayer.category.geomType === 'AREA') {
			await onSelectPolygon(selectedFeat);
		} else {
			if (selectedFeat) {
				await onSelectPointOrLine(selectedFeat);
			} else {
				this.isPickingFeatureInEditing = true;
				this.mapSharedService.changeCursor(this.mapService.map.olMap, this.attrIndexService.cursorArrow);
	
				this.onMapSelect_editing = (e) => {
					// this.mapService.map.olMap.getViewport().style.cursor = ''; 
					this.mapSharedService.changeCursor(this.mapService.map.olMap, '');// TODO
					const feat = e.selected[0];
					onSelectPointOrLine(feat);
				};
				this.mapService.dataSelectInteraction.on('select', this.onMapSelect_editing);
		
			}
		}

		this.mapService.mapEditing.next({
			isOn: true,
			source: 'main'
		})
	}
	private async stopMapEditing() {
		this.isMapEditing = false;
		if (this.onMapSelect_editing) {
			this.mapService.dataSelectInteraction.un('select', this.onMapSelect_editing);
		}
		//
			// if (this.isTopoErrorEditing) {
			// 	await this.turnOffTopoErrorEditing();
			// }
		this.mapService.removeDataModify();
		if (this.mapService.topojsonModify) {
			this.removeTopoFeaturesEditing();
			this.isTopologyOn = false;
		} else {
			// Restore datalayer style
			const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
			dataLayer.setStyle(this.dataLayerStyle);
			//
			const modifyLayer = this.mapService.map.addedLayers[this.mapLayerService.dataModifyLayerName];
			const feats = modifyLayer.getSource().getFeatures();
			feats.forEach(f => {
				f.setStyle(this.dataLayerStyle);
			});
			//
			this.mapService.moveFeaturesBackFromModifyLayer();
		}

		this.mapService.mapEditing.next({
			isOn: false,
			source: 'main'
		})
	}
	onContextmenuAttachToEdge(e) {
		const feat = e.item;
		let featClone = feat.clone(); // Store the feat before attaching

		let coordA: number[], coordB: number[];
		let attachToFeat, attachToFeatsA: any[] = [];
		const targetLayer = this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName];
		// const tempLayer = this.mapService.map.addedLayers[this.mapLayerService.addPolygonTempLayerName];
		// let line, lineAgainst, clickCenter;
		const restore = (msg: string) => {
			this.toastr.warning(msg);
			feat.setGeometry(featClone.clone().getGeometry());
			attachToFeatsA = [];
			coordA = null;
			coordB = null;
		}
		const onModifyEnd = e => {
			const feats = e.features.getArray();
			if (feats.indexOf(feat) === -1) {
				return;
			}
			const clickCoord = e.mapBrowserEvent.coordinate;
			const pixel = e.mapBrowserEvent.pixel;
			this.mapService.map.olMap.forEachFeatureAtPixel(pixel, (f, l) => {
				if (l !== targetLayer || attachToFeat || f === feat) {
					return;
				}
				if (!coordA) {
					// Collect all features whose edge is under this coord
					if (this.mapSharedService.isPointOnPolygonEdge(clickCoord, f.getGeometry())) {
						attachToFeatsA.push(f);
					}
				} else {
					if (attachToFeatsA.indexOf(f) === -1) {
						return;
					} else {
						if (this.mapSharedService.isPointOnPolygonEdge(clickCoord, f.getGeometry())) {
							attachToFeat = f;
						}
					}
				}

			})
			if (!coordA && !attachToFeatsA.length) {
				restore('Please move the point onto the polygon edge that need to attach to.');
			} else if (coordA && !attachToFeat) {
				restore('Please attach to one polygon.'); // TODO
			} else {
				if (!coordA) {
					coordA = clickCoord;
				} else if (!coordB) {
					coordB = clickCoord;
				}
				if (coordA && coordB) {
					const geom = attachToFeat.getGeometry();
					const calc = this.mapSharedService.getCoordinatesOnGeomBetweenPoints(coordA, coordB, geom);
					if (calc && calc.coords && calc.coordsAgainst) {
						// line = new Feature({
						// 	geometry: new LineString(calc.coords)
						// });
						// lineAgainst = new Feature({
						// 	geometry: new LineString(calc.coordsAgainst)
						// });

						const calcNewFeat = this.mapSharedService.getCoordinatesOnGeomBetweenPoints(coordA, coordB, feat.getGeometry());
						const partA = calcNewFeat.coords;
						const partB = calcNewFeat.coordsAgainst;
						// Use line/lineAgainst to replace either partA or B, then concat with the other to form the new polygon geom
						const middlePoint = [(coordA[0] + coordB[0]) / 2, (coordA[1] + coordB[1]) / 2]; // middlePoint of the straight line between coordA and coordB
						const closestPointA = new LineString(partA).getClosestPoint(middlePoint);
						const closestPointB = new LineString(partB).getClosestPoint(middlePoint);
						const partToKeep = Math.pow((closestPointA[0] - middlePoint[0]), 2) + Math.pow((closestPointA[1] - middlePoint[1]), 2) > Math.pow((closestPointB[0] - middlePoint[0]), 2) + Math.pow((closestPointB[1] - middlePoint[1]), 2) ? partA : partB;
	
						// Decide to use coords or coordsAgainst by checking the new polygon would overlap with the attachToPolygon or not
						const formPolygonGeom = (attachCoords) => {
							let newCoords;
							if (this.mapSharedService.isCoordsEqual(partToKeep[0], attachCoords[0])) {
								partToKeep.reverse().splice(0, 1);
							} else {
								partToKeep.splice(0, 1);
							}
							newCoords = attachCoords.concat(partToKeep);
							return new Polygon([newCoords]);
						};
						let newPolygonGeom;
						const parser = this.jstsService.getJstsParser();
						const attachToFeatJstsGeom = parser.read(geom);
						const coordsPolygonGeom = formPolygonGeom(calc.coords);
						const coordsAgainstPolygonGeom = formPolygonGeom(calc.coordsAgainst);
						let attachJstsGeom;
						try {
							attachJstsGeom = parser.read(coordsPolygonGeom);
							newPolygonGeom = coordsPolygonGeom;
						} catch (err) {
							attachJstsGeom = parser.read(coordsAgainstPolygonGeom);
							newPolygonGeom = formPolygonGeom(calc.coordsAgainst);
						}
						// if (!attachJstsGeom.intersects(attachToFeatJstsGeom)) {
						// 	newPolygonGeom = coordsPolygonGeom;
						// } else {
						// 	newPolygonGeom = formPolygonGeom(calc.coordsAgainst);
						// }
						feat.getGeometry().setCoordinates(newPolygonGeom.getCoordinates());
						
						this.mapService.topojsonModify.un('modifyend', onModifyEnd);

					}
				}
			}
		}
		this.mapService.topojsonModify.on('modifyend', onModifyEnd);


		
			// const onMapPointermove = e => {
		// 	if (line && lineAgainst && !clickCenter) {
		// 		const coord = e.coordinate;
		// 		const coordOnFeat = attachToFeat.getGeometry().getClosestPoint(coord);
		// 		const source = tempLayer.getSource();
		// 		source.clear();
		// 		if (this.mapService.findCoordPositionOnPolygon(coordOnFeat, [line.getGeometry().getCoordinates()])) {
		// 			source.addFeature(line);
		// 		} else {
		// 			source.addFeature(lineAgainst);
		// 		}
		// 	}
		// }
		// this.mapService.map.olMap.on('pointermove', onMapPointermove);
		// // Select which side of polygon to attachTo
		// const onMapClick = e => {
		// 	if (!line) {
		// 		return;
		// 	}
		// 	if (!clickCenter) {
		// 		clickCenter = e.coordinate;
		// 		const attachCoords = tempLayer.getSource().getFeatures()[0].getGeometry().getCoordinates();
		// 		const calc = this.mapService.getCoordinatesOnGeomBetweenPoints(coordA, coordB, feat.getGeometry());
		// 		const partA = calc.coords;
		// 		const partB = calc.coordsAgainst;
		// 		// Use attachCoords to replace either partA or B, then concat with the other to form the new polygon geom
		// 		const middlePoint = [(coordA[0] + coordB[0]) / 2, (coordA[1] + coordB[1]) / 2]; // middlePoint of the straight line between coordA and coordB
		// 		const closestPointA = new LineString(partA).getClosestPoint(middlePoint);
		// 		const closestPointB = new LineString(partB).getClosestPoint(middlePoint);
		// 		const partToKeep = Math.pow((closestPointA[0] - middlePoint[0]), 2) + Math.pow((closestPointA[1] - middlePoint[1]), 2) > Math.pow((closestPointB[0] - middlePoint[0]), 2) + Math.pow((closestPointB[1] - middlePoint[1]), 2) ? partA : partB;

		// 		let newCoords;
		// 		if (this.mapService.isCoordsEqual(partToKeep[0], attachCoords[0])) {
		// 			partToKeep.reverse().splice(0, 1);
		// 		} else {
		// 			partToKeep.splice(0, 1);
		// 		}
		// 		newCoords = attachCoords.concat(partToKeep);
		// 		feat.getGeometry().setCoordinates([newCoords]);
		// 		tempLayer.getSource().clear();
				

		// 		this.mapService.map.olMap.un('pointermove', onMapPointermove);
		// 		this.mapService.map.olMap.un('click', onMapClick);
		// 		this.mapService.topojsonModify.un('modifyend', onModifyEnd);
		// 	}
		// }
		// this.mapService.map.olMap.on('click', onMapClick);
	}
	onContextmenuDeleteVertex(e) {
		if (this.rightClickFeature && this.rightClickVertex) {
			const geom = this.rightClickFeature.getGeometry();
			switch (geom.getType()) {
				case 'Point':
					return;
				case 'MultiPoint':
				case 'LineString':
					const lineGeom = (<MultiPoint | LineString>geom);
					const coords = lineGeom.getCoordinates();
					if (coords.length > 2) {
						const idx = coords.findIndex(c => this.mapSharedService.isCoordsEqual(this.rightClickVertex, c));
						coords.splice(idx, 1);
						lineGeom.setCoordinates(coords);
					} else {
						// TODO
					}
					break;
				case 'MultiLineString':
				case 'Polygon':
					const polygonGeom = (<MultiLineString | Polygon>geom);
					const coordsArr = polygonGeom.getCoordinates();
					coordsArr.find(coords => {
						const idx = coords.findIndex(c => this.mapSharedService.isCoordsEqual(this.rightClickVertex, c));
						if (idx > -1) {
							if (coords.length > 3) {
								coords.splice(idx, 1);
							} else {
								
								// TODO

							}
							return true;
						}
					});
					polygonGeom.setCoordinates(coordsArr);
					break;
				case 'MultiPolygon':
					const multiPolygonGeom = (<MultiPolygon>geom);
					const coordsArrArr = multiPolygonGeom.getCoordinates();
					coordsArrArr.find(coordsArr => {
						return coordsArr.find(coords => {
							const idx = coords.findIndex(c => this.mapSharedService.isCoordsEqual(this.rightClickVertex, c));
							if (idx > -1) {
								if (coords.length > 3) {
									coords.splice(idx, 1);
								} else {
									
									// TODO
	
								}
								return true;
							}
						});
					})
					multiPolygonGeom.setCoordinates(coordsArrArr);
					break;
			}
		}
	}
	onContextmenuAddVertex(e) {
		const clickCoord = this.rightClickCoord;
		if (clickCoord) {
			let feat;
			const selectedFeatures = this.mapService.dataSelectInteraction.getFeatures().getArray();
			if (selectedFeatures.indexOf(this.rightClickFeature) > -1) {
				feat = this.rightClickFeature;
			} else if (selectedFeatures.length === 1) {
				feat = selectedFeatures[0];
			} else if (selectedFeatures.length > 1) {
				// Find closest feat
				let dist2 = null;
				selectedFeatures.forEach(f => {
					const coordOnFeat = f.getGeometry().getClosestPoint(clickCoord);
					const currDist2 = Math.pow(clickCoord[0] - coordOnFeat[0], 2) + Math.pow(clickCoord[1] - coordOnFeat[1], 2);
					if (dist2 === null || currDist2 < dist2) {
						feat = f;
						dist2 = currDist2;
					}
				})
			}
			if (feat) {
				const geomType: GeometryType = feat.getGeometry().getType();
				let lineCoords: number[][];
				let neighborIdxes: number[];
				let coordsOnGeom = feat.getGeometry().getClosestPoint(clickCoord);
				switch (geomType) {
					case 'Point':
						break;
					case 'MultiPoint':
					case 'LineString':
						lineCoords = feat.getGeometry().getCoordinates();
						neighborIdxes = this.mapSharedService.findCoordPositionOnLine(coordsOnGeom, lineCoords);
						lineCoords.splice(neighborIdxes[1], 0, coordsOnGeom);
						feat.getGeometry().setCoordinates(lineCoords);
						break;
					case 'MultiLineString':
					case 'Polygon':



						// TODO



						const list = feat.getGeometry().getCoordinates();
						const result = this.mapSharedService.findCoordPositionOnPolygon(coordsOnGeom, list);
						neighborIdxes = result.indexes;
						const lineCoordsIdx = result.lineCoordsIdx;
						lineCoords = list[lineCoordsIdx];
						lineCoords.splice(neighborIdxes[1], 0, coordsOnGeom);
						feat.getGeometry().setCoordinates(list);
						break;
					case 'MultiPolygon':
						// TODO
						break;
				}
			}
		}
	}
	onContextmenuPolygonEdit() {
		this.editFeatureService.polygonEditSubject.next({
			activate: true
		});
	}
	checkDeleteVertexEnabled = () => {
		return this.rightClickVertex; // Do not put this in ngIf in contextmenu, since the value change wouldn't be reflected immediately
	}
	checkAttachEnabled = (feat) => {
		if (feat) {
			const attrs = this.mainDataService.getDataAttrs(feat.getId());
			return attrs && attrs[this.attrIndexService.isNewDataKey];	
			// const props = feat.getProperties();
			// return props[this.attrKey] && props[this.attrKey][this.attrIndexService.isNewDataKey];	
		}
	}
	private addPolygonAtPixel(pixel: number[]) {
		const layer = this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName];
		const r = 20;
		const pixelXminYmin = [pixel[0] - r, pixel[1] - r];
		const pixelXminYmax = [pixel[0] - r, pixel[1] + r];
		const pixelXmaxYmax = [pixel[0] + r, pixel[1] + r];
		const pixelXmaxYmin = [pixel[0] + r, pixel[1] - r];
		const xminYmin = this.mapService.map.olMap.getCoordinateFromPixel(pixelXminYmin);
		const xminYmax = this.mapService.map.olMap.getCoordinateFromPixel(pixelXminYmax);
		const xmaxYmax = this.mapService.map.olMap.getCoordinateFromPixel(pixelXmaxYmax);
		const xmaxYmin = this.mapService.map.olMap.getCoordinateFromPixel(pixelXmaxYmin);
		const newPolygon = new Feature({
			geometry: new Polygon([[xminYmin, xminYmax, xmaxYmax, xmaxYmin, xminYmin]])
		});
		layer.getSource().addFeature(newPolygon);
		return newPolygon;
	}
	private addPointAtPixel(pixel: number[]) {
		const layer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		const coord = this.mapService.map.olMap.getCoordinateFromPixel([pixel[0], pixel[1]]);
		const newPoint = new Feature({
			geometry: new Point(coord)
		});
		layer.getSource().addFeature(newPoint);
		return newPoint;
	}
	private addLineAtPixel(pixel: number[]) {
		const layer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		const r = 20;
		const lineStart = this.mapService.map.olMap.getCoordinateFromPixel([pixel[0] - r, pixel[1]]);
		const lineEnd = this.mapService.map.olMap.getCoordinateFromPixel([pixel[0] + r, pixel[1]]);
		const newLine = new Feature({
			geometry: new LineString([lineStart, lineEnd])
		});
		layer.getSource().addFeature(newLine);
		return newLine;
	}
	private async startAddNewFeature(geomType: GeometryType) {
		if (geomType === 'Polygon') {
			if (!this.isTopologyOn) {
				await this.startMapEditing();
			}
			if (!this.isTopoEditing) {
				this.toastr.info('Please fix topology errors before editing.');
			}
		} else {
			if (!this.isMapEditing) {
				await this.startMapEditing();
			}
		}
		this.mapSharedService.changeCursor(this.mapService.map.olMap, 'crosshair');
		this.isAddingFeature = true;
		let centerPixel;
		const onMapClick = e => {
			if (geomType === 'Polygon' && !this.isTopoEditing) {
				this.finishAddFeature()
				return;
			}
			if (!centerPixel) {
				centerPixel = e.pixel;
				let feat: Feature;
				switch (geomType) {
					case 'Point':
						feat = this.addPointAtPixel(centerPixel);
						if (this.isMapEditing) {
							this.mapService.moveFeaturesToModifyLayer([feat])
						}
						break;
					case 'LineString':
						feat = this.addLineAtPixel(centerPixel);
						if (this.isMapEditing) {
							this.mapService.moveFeaturesToModifyLayer([feat], null, this.activityService.networkTopoMode.getValue().isOn)
						}
						break;
					case 'Polygon':
						feat = this.addPolygonAtPixel(centerPixel);
						break;
				}
				const rec = this.mainDataService.addNewCard(this.getIdCol());
				const recId = this.getRecordId(rec);
				// set geom
				const wktFormat = new WKT();
				const wktStr = wktFormat.writeGeometry(feat.getGeometry());
				this.mainDataService.setDataAttrs(recId, this.geomColName_manual, wktStr);
				feat.setId(recId);
			} 
			this.finishAddFeature()
			return;
		}
		this.onMapClick_addNewFeat = onMapClick;
		this.mapService.map.olMap.on('click', onMapClick);
	}
	private finishAddFeature() {
		this.isAddingFeature = false;
		this.mapSharedService.changeCursor(this.mapService.map.olMap, '');
		if (this.onMapClick_addNewFeat) {
			this.mapService.map.olMap.un('click', this.onMapClick_addNewFeat);
		}
	}	
		// startAddPolygon_() {
		// 	this.isAddingPolygon = true;
		// 	let clickA, clickB, clickCenter;
		// 	let feat;
		// 	let line, lineAgainst; // line is the coords on polygon between two clicks, lineAgainst is the coords on polygon from another direction between two clicks
		// 	const targetLayer = this.isTopologyOn ? this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName] : this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		// 	const tempLayer = this.mapService.map.addedLayers[this.mapLayerService.addPolygonTempLayerName];
		// 	const onMapClick = e => {
		// 		if (line) {
		// 			return;
		// 		}
		// 		// Select Attach-To feature
		// 		if (!feat) {
		// 			this.mapService.map.olMap.forEachFeatureAtPixel(e.pixel, (f, layer) => {
		// 				if (layer === targetLayer) {
		// 					feat = f;
		// 				}
		// 			});
		// 			if (!feat) {
		// 				this.toastr.warning('Please select an area to attach the new feature to.');
		// 			}
		// 			return;
		// 		}
		// 		// Calc coordinates between 2 clicks
		// 		const clickCoord = e.coordinate;
		// 		if (!clickA) {
		// 			clickA = clickCoord;
		// 		} else if (!clickB) {
		// 			clickB = clickCoord;
		// 		} else if (!clickCenter) {
		// 			clickCenter = clickCoord;
		// 		}
		// 		if (feat && clickA && clickB && !line) {
		// 			const geom = feat.getGeometry();
		// 			const calc = this.mapService.getCoordinatesOnGeomBetweenPoints(clickA, clickB, geom);
		// 			if (calc && calc.coords && calc.coordsAgainst) {
		// 				line = new Feature({
		// 					geometry: new LineString(calc.coords)
		// 				});
		// 				lineAgainst = new Feature({
		// 					geometry: new LineString(calc.coordsAgainst)
		// 				});
		// 			}
		// 		}
		// 		// Decide which side of polygon to attach to
		// 		if (clickCenter) {
		// 			// const newFeat = new Feature({
		// 			// 	geometry: new Polygon([line])
		// 			// });
		// 			// const source = targetLayer.getSource();
		// 			// source.addFeature(newFeat);
		// 		}
		// 	}
		// 	const onMapPointermove = e => {
		// 		if (line && lineAgainst && !clickCenter) {
		// 			const coord = e.coordinate;
		// 			const coordOnFeat = feat.getGeometry().getClosestPoint(coord);
		// 			const source = tempLayer.getSource();
		// 			source.clear();
		// 			if (this.mapService.findCoordPositionOnPolygon(coordOnFeat, [line.getGeometry().getCoordinates()])) {
		// 				source.addFeature(line);
		// 			} else {
		// 				source.addFeature(lineAgainst);
		// 			}
		// 		}
		// 	}
		// 	this.mapService.map.olMap.on('click', onMapClick);
		// 	this.mapService.map.olMap.on('pointermove', onMapPointermove);
		// 	this.onMapPointermove_addPolygon = onMapPointermove;
		// 	this.onMapClick_addPolygon = onMapClick;
		// }
		// finishAddPolygon() {
		// 	this.isAddingPolygon = false;
		// 	this.mapService.map.olMap.un('click', this.onMapClick_addPolygon);
		// 	this.mapService.map.olMap.un('pointermove', this.onMapPointermove_addPolygon);
		// }
	private async getAddressMinDist(labelCalc: LabelCalc, ext: number[], z: number, layerId) {
		if (!labelCalc.ext || labelCalc.layerId !== layerId || 
			!labelCalc.pt1 || !containsExtent(labelCalc.ext, ext) || !containsXY(ext, labelCalc.pt1[0], labelCalc.pt1[1]) || !containsXY(ext, labelCalc.pt2[0], labelCalc.pt2[1])) {
			labelCalc.ext = ext;
			labelCalc.layerId = layerId;
			labelCalc.minDist = null;
			labelCalc.pt1 = null;
			labelCalc.pt2 = null;
		}
		z = Math.floor(z);
		if (!labelCalc.minDist) {
			const rsp = await this.layerService.getAddressTileMinDist(layerId, ext, z);
			labelCalc.minDist = rsp.dist;
			labelCalc.pt1 = rsp.pt1;
			labelCalc.pt2 = rsp.pt2;
		}
		return labelCalc.minDist;
	}
	private async updateAddrLabelCalc(addrLabelCalc: LabelCalc, olLayer, ext, reso, z, layerId) {
		const props = {};
		props[this.attrIndexService.drawAddrLabelKey] = null;
		if (layerId) {
			const minDist = await this.getAddressMinDist(addrLabelCalc, ext, z, layerId);
			console.log('Min dist', minDist);
			const minDrawingDist = reso * 20;
			if (minDist > 1000 || minDist > minDrawingDist) {
				props[this.attrIndexService.drawAddrLabelKey] = true;
			}
		}
		if (props[this.attrIndexService.drawAddrLabelKey] !== olLayer.getProperties()[this.attrIndexService.drawAddrLabelKey]) {
			olLayer.setProperties(props);
			olLayer.changed();
		}
	}

	// Select data on map/table after retrieving data
	private async selectAfterRetrieveData() {
		const selected = this.activityService.selectedRecordsBS.getValue();
		const selectedIds = selected ? selected.ids : [];
		if (selectedIds.length) {
			this.selectRecordsOnTable(selectedIds);
			const selectedFeats = await this.selectRecordsOnMap(selectedIds);
			// Trigger selectedRecordsBS in all cases so that selectionList in dataCards would be updated
			// if (selectedIds.length > this.selectedRows.length || selectedIds.length > selectedFeats.length) {
				const idsInView = selectedIds.filter(id => this.selectedRows.find(r => this.getRecordId(r) === id) && selectedFeats.find(f => f.getId() === id));
				this.activityService.selectedRecordsBS.next({
					ids: idsInView
				})
			// }
		}
			// const selectedId = this.cardSelectedRecord ? this.getRecordId(this.cardSelectedRecord) : null;
			// if (selectedId || selectedId === 0) {
			// 	if (this.isMapFilterOn) {
			// 		this.selectRecordOnTable(selectedId);
			// 		await this.selectRecordsOnMap([selectedId]);
			// 	} else {
			// 		// TODO
					
			// 		// const selectedFeats = await this.selectRecordsOnMap([selectedId]);
			// 		// // If map filter isn't on, it's possible that the selected data might not be in table
			// 		// this.selectRecordOnTable(selectedId);
			// 		// if (this.selectedRows.length === 0) {
						
			// 		// }
			// 	}
			// } 
	}

	private onTopojsonModifyend = async (e) => {
		try {
			// const wktFormat = new WKT();
			const feats = e.features.getArray();
			const featIds = feats.map(f => f.getId());
			await this.addTopoFeaturesToCards(featIds, true);
			// const currSelectedId = this.cardSelectedRecord ? this.getRecordId(this.cardSelectedRecord): '';
			// feats.forEach(async f => {
			// 	const props = f.getProperties();
			// 	// Update as edited
			// 	props[this.isTopoEditedKey] = true;
			// 	//
			// 	f.setProperties(props);
			// 	// Find feat on dataLayer
			// 	const id = f.getId();
			// 	const featOnDataLayer = this.mapService.map.addedLayers[this.dataLayerName].getSource().getFeatureById(id);
			// 	featOnDataLayer.setGeometry(f.getGeometry());
			// 	let propsOnData = featOnDataLayer.getProperties();
			// 	// Update stored geom
			// 	const wktString = wktFormat.writeGeometry(f.getGeometry());
			// 	propsOnData[this.attrKey][this.geomColName_manual] = wktString;
			// 	// Add card
			// 	let card;
			// 	if (!propsOnData[this.attrKey][this.isEditedCol]) {
			// 		// Update details if needed
			// 		if (propsOnData[this.attrKey][this.isIdOnlyKey]) {
			// 			await this.updateFeatureDetail(id);
			// 			propsOnData = featOnDataLayer.getProperties();
			// 		}
			// 		// Add card
			// 		card = JSON.parse(JSON.stringify(propsOnData[this.attrKey]));
			// 		this.editCardRef.addCardToList(propsOnData[this.attrKey], card);
			// 		propsOnData[this.attrKey][this.isEditedCol] = true;
			// 		// Update selected card to same object
			// 		if (id === currSelectedId) {
			// 			setTimeout(() => this.cardSelectedRecord = card);
			// 		}				
			// 	} else {
			// 		card = this.editRecordList.find(c => this.getRecordId(c) === f.getId());
			// 	}
			// 	card[this.geomColName_manual] = wktString;
			// 	//
			// 	featOnDataLayer.setProperties(propsOnData);
			// 	//
			// 	// const id = f.getId();
			// 	// const featOnDataLayer = this.mapService.map.addedLayers[this.dataLayerName].getSource().getFeatureById(id);
			// 	// featOnDataLayer.setGeometry(f.getGeometry());
			// });
		} catch (err) {
			console.log(err);
		}
	}

	private enableTopoFeaturesEditing() {
		this.isTopoEditing = true;
		// Disable other tabs that's not Data
		this.selectDataTab();
		this.toggleTabVisibForTopoEdit(true);
		// Hide attribute filters
		this.hideAttrFilters = true;
		// Hide data layer
		this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].setVisible(false);

		// this.mapService.addTopoSelectInteraction(this.onSelectFromMap);

		if (this.mapService.checkZoomLevelForTopoEditing()) {
			// Add topo modify interaction
			this.mapService.addTopoModifyInteraction(this.mapService.map, this.onTopojsonModifyend);
		} else {
			// Disable topo editing if zoom out of range
			this.mapService.removeTopoModifyInteraction(this.mapService.map);
		}
		// Update feature style
		this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].changed()
	}
	private removeTopoFeaturesEditing() {
		this.isTopoEditing = false;
		// Remove disable from tabs
		this.toggleTabVisibForTopoEdit(false);
		// Show attribute filters
		this.hideAttrFilters = false;
			// // Update data layer
			// const feats = this.mapService.map.addedLayers[this.topojsonLayerName].getSource().getFeatures();
			// feats.forEach(f => {
			// 	const hasChanged = f.getProperties()[this.isTopoEditedKey];
			// 	if (hasChanged) {
			// 		const id = f.getId();
			// 		const featOnDataLayer = this.mapService.map.addedLayers[this.dataLayerName].getSource().getFeatureById(id);
			// 		featOnDataLayer.setGeometry(f.getGeometry());
			// 		const props = featOnDataLayer.getProperties();
			// 		// Add card
			// 		if (!props[this.attrKey][this.isEditedCol]) {
			// 			this.editCardRef.addCardToList(props[this.attrKey], JSON.parse(JSON.stringify(props[this.attrKey])));
			// 			props[this.attrKey][this.isEditedCol] = true;
			// 			featOnDataLayer.setProperties(props);
			// 		}
			// 	}
			// });
		// Show data layer
		this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].setVisible(true);
		// Update features on data layer
		
		this.mapService.removeTopoSelectInteraction();
		// Remove topo modify
		this.mapService.removeTopoModifyInteraction(this.mapService.map);
		// Clear topo layer
		this.clearLayer(this.mapLayerService.topojsonLayerName);
	}

	private async checkTopoErrorIntra(geojson, isOrigin?: boolean) {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			// Topolygized area
			const topoCheck: TopoCheckOutputExt = await this.topoService.getTopologizedzedAreas(geojson, true);
			if (this.enableDiscrepancyAgencyRule && this.selectedLayer.category.isCollaborative) {
				const featsOwnedByCustomer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].getSource().getFeatures().filter(f => {
					const prop = f.getProperties()[this.attrKey];
					return prop[this.discrepancyAgencyIdColName] === this.appinfoService.customerProfile.discrepancyAgencyId;
				});
					// DO NOT filter out aear that doesn't belong to the agency Because all areas are needed to merge to the new topolized polygons
						// const ids = featsOwnedByCustomer.map(f => f.getId());
						// if (ids.length) {
						// 	const filterDiscrAgencyErrors = (topoErrors: TopoCheckAreaIndex[], topoCheckArea: TopoCheckArea[]) => {
						// 		if (topoErrors) {
						// 			const filtered: TopoCheckAreaIndex[] = [];
						// 			topoErrors.forEach(topo => {
						// 				if (topo.ori_gids.find(id => ids.indexOf(id) > -1)) {
						// 					filtered.push(topo);
						// 				} else {
						// 					// Remove from area
						// 					topoCheckArea.splice(topoCheckArea.findIndex(a => a.gid === topo.topo_gid), 1);
						// 				}
						// 			});
						// 			return filtered;
						// 		}
						// 	}
						// 	topoCheck.gap = filterDiscrAgencyErrors(topoCheck.gap, topoCheck.topologized_areas);
						// 	topoCheck.overlap = filterDiscrAgencyErrors(topoCheck.overlap, topoCheck.topologized_areas);
						// }
			}
			//
			topoCheck.geojson = geojson;
			if (isOrigin) {
				topoCheck.geojsonOrigin = JSON.parse(JSON.stringify(geojson));
				topoCheck.changedFeatureIds = [];
			} else {
				topoCheck.changedFeatureIds = this.topoCheck.changedFeatureIds;
			}
			this.topoCheck = topoCheck;
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	private async checkTopoErrorInter(geojson, isOrigin?: boolean) {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			// Topolygized area
			let refGeojson; // TODO
			const topoCheck: TopoCheckInterLayerOutputExt = await this.topoService.getTopologizedAreasInter(geojson, refGeojson, true);
			//
			topoCheck.geojson = geojson;
			if (isOrigin) {
				topoCheck.geojsonOrigin = JSON.parse(JSON.stringify(geojson));
				topoCheck.changedFeatureIds = [];
			} else {
				topoCheck.changedFeatureIds = this.topoCheck.changedFeatureIds;
			}
			this.topoCheckInter = topoCheck;
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	private turnOnTopoErrorEditing(topoCheck: TopoCheckOutput) {
		// this.isTopoErrorEditing = true;
		
		// this.disableTabSwitching = true;
		// // Display topo check tab
		// const topoTabIdx = this.tabs.findIndex(t => t.key === 'topoCheck');
		// if (topoTabIdx > -1) {
		// 	this.tabs[topoTabIdx].hidden = false;
		// 	this.verticalTabsComp.selectTab(topoTabIdx);
		// }

		// this.mapService.addTopoErrorSelectInteraction();

		// this.drawTopoCheckResultOnMap(topoCheck);

		// // Turn off data layer
		// const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		// dataLayer.setVisible(false);
	}
	private async turnOffTopoErrorEditing() {
		// if (this.isTopoErrorEditing) {
		// 	this.isTopoErrorEditing = false;
		// 	// Hide topo tab
		// 	this.disableTabSwitching = false;
		// 	setTimeout(() => {
		// 		const topoTabIdx = this.tabs.findIndex(t => t.key === 'topoCheck');
		// 		if (topoTabIdx > -1) {
		// 			this.tabs[topoTabIdx].hidden = true;
		// 			this.verticalTabsComp.selectTab(this.tabs.findIndex(t => t.key === 'data'));
		// 		}
		// 	});

		// 	this.mapService.removeTopoErrorSelectInteraction();

		// 	//
		// 	const topoErrorLayer = this.mapService.map.addedLayers[this.mapLayerService.topoErrorLayerName];
		// 	topoErrorLayer.getSource().clear();
		// 	// Turn on data layer
		// 	const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
		// 	dataLayer.setVisible(true);
		// 	//
		// 	this.updateTopoErrorFixToTopojsonLayer();
		// 	await this.addTopoFeaturesToCards(this.topoCheck.changedFeatureIds);
		// }
	}
	private drawTopoCheckResultOnMap(topoCheck: TopoCheckOutput) {
		const topologizedFeats = [];
		const isDrawCreviceOnly = !topoCheck.overlap.length && !topoCheck.gap.length && topoCheck.crevice.length;
		const overlapIds = [];
		const gapIds = [];
		topoCheck.overlap.forEach(d => overlapIds.push(d.topo_gid));
		topoCheck.gap.forEach(d => gapIds.push(d.topo_gid));
		//
		topoCheck.topologized_areas.forEach(d => {
			if (d.geom.type === 'Polygon') {
				const area = new Feature({
					geometry: new Polygon(d.geom.coordinates)
				});
				let isTopoError;
				let color;
				let width = 1;
				if (overlapIds.indexOf(d.gid) > -1) {
					color = colors.overlapHex;
					isTopoError = true;
				} else if (gapIds.indexOf(d.gid) > -1) {
					color = colors.gapHex;
					isTopoError = true;
				} else {
					color = colors.mapFill;
				}
				if (isDrawCreviceOnly && isTopoError) {
					return;
				}
				const props = {};
				props[this.attrIndexService.topoHexColorAttr] = color;
				props[this.attrIndexService.topoStrokeWidthAttr] = width;
				area.setProperties(props);
				area.setId(d.gid);
				topologizedFeats.push(area);
			} else {
				console.log('not handled geom: ', d);
			}
		});
		//
		if (isDrawCreviceOnly) {
			const geojsonFormat = new GeoJSON();
			topoCheck.crevice.forEach(d => {
				const creviceGeom = geojsonFormat.readGeometry(d.geomJson);
				const crev = new Feature({
					geometry: creviceGeom
				});
				const props = {}
				props[this.attrIndexService.topoHexColorAttr] = colors.creviceHex;
				props[this.attrIndexService.topoRadiusAttr] = 5;
				crev.setProperties(props);
				crev.setId(d.creviceId);
				topologizedFeats.push(crev);
			});
		}
		// Add features
		const topoErrorLayer = this.mapService.map.addedLayers[this.mapLayerService.topoErrorLayerName];
		topoErrorLayer.getSource().clear();
		topoErrorLayer.getSource().addFeatures(topologizedFeats);
	}
	private drawResolvedAreasOnMap(areas: TopoCheckArea[]) {
		const resolvedFeats = [];
		areas.forEach(d => {
			if (d.geom.type === 'Polygon') {
				const area = new Feature({
					geometry: new Polygon(d.geom.coordinates)
				});
				const props = {};
				props[this.attrIndexService.topoHexColorAttr] = colors.mapFill;
				props[this.attrIndexService.topoStrokeWidthAttr] = 1;
				area.setProperties(props);
				area.setId(d.gid);
				resolvedFeats.push(area);
			} else {
				console.log('not handled geom: ', d);
			}
		});
		// Add features
		const resolvedLayer = this.mapService.map.addedLayers[this.mapLayerService.topoResolvedLayerName];
		resolvedLayer.getSource().clear();
		resolvedLayer.getSource().addFeatures(resolvedFeats);
	}
	private async getTopojson (mapExtent: number[], skipUpdateMap?: boolean) {
		const layerId = this.selectedLayer.id;
		let data;
		const randomId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, randomId);
		try {
			data = await this.layerService.getLayerGeomBoundingBox(layerId, mapExtent, true);		
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, randomId);
		// const topologizedGeojson = {
		// 	type: 'FeatureCollection',
		// 	features: topologizedAreas.topologized ? topologizedAreas.topologized.map(d => {
		// 		return {
		// 			geometry: {
		// 				type: d.geom.type,
		// 				coordinates: d.geom.coordinates
		// 			},
		// 			id: d.gid,
		// 			source: d.source
		// 		};
		// 	}): []
		// };
		// const features = this.convertGeojsonToTopoFeatures(topologizedGeojson);


		if (!skipUpdateMap) {
			const features =  this.topoService.convertGeojsonToTopoFeatures(data);
			this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource().clear();
			this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource().addFeatures(features);
			return {
				geojson: data,
				features: features
			};
		} else {
			return {
				geojson: data
			}
		}
	}
	private async updateTopojson() {
		// const rsp = await this.getTopojson(true);
		// const layer = this.mapService.map.addedLayers[this.topojsonLayerName];
		// const existingFeatures = layer.getSource().getFeatures();
		// existingFeatures.forEach(f => {
		// 	const idx = rsp.findIndex(i => i.getId() === f.getId());
		// 	if (idx > -1) {
		// 		rsp[idx].setGeometry(f.getGeometry());
		// 		rsp[idx].setProperties(f.getProperties());
		// 	} else {
		// 		rsp.push(f);
		// 	}
		// });
		// layer.getSource().clear();
		// layer.getSource().addFeatures(rsp);
	}
	onSelectTopoErrorFromCard(e: SelectTopoErrorData) {
		const layer = this.mapService.map.addedLayers[this.mapLayerService.topoErrorLayerName];
		let feat;
		if (e.type === 'crevice') {
			const item = (<TopoCheckCrevice>e.topoItem);
			feat = layer.getSource().getFeatureById(item.creviceId);
		} else {
			const item = (<TopoCheckAreaIndex>e.topoItem);
			const area: TopoCheckArea = this.topoCheck.topologized_areas.find(d => d.gid === item.topo_gid);
			if (area && area.gid) {
				feat = layer.getSource().getFeatureById(area.gid);
			}
		}
		// Select feat on map
		this.mapService.topoErrorSelectInteraction.getFeatures().clear();
		if (feat) {
			this.mapService.topoErrorSelectInteraction.getFeatures().push(feat);
			// Zoom to feat
			const featExtent = feat.getGeometry().getExtent();
			this.mapService.map.olMap.getView().fit(featExtent, {
				padding: [20, 20, 20, 20]
			});
		}
	}
	async onClickCommitResolved(e) {
		if (this.selectedLayer.state.num === 1.52 && this.topoCheck.resolved_areas) { // TOPOLOGY state
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			// Update geometry for every records
			try {
				const layer = this.selectedLayer;
				const rsp = await this.topoService.resolveTopo(layer.id);
				const runQc = rsp.misc.transition > 0;
				if (runQc) {
					this.qcService.qcLayers([layer.id]);
				}
				// const sourceTableName = this.getSourceTableName();
				// const prefix = layer.colPrefix;
				// const primKeyCol = `${prefix}_${this.attrIndexService.primKeyCol}`;
				// // const geomCol = `${prefix}_${this.attrIndexService.geomCol}}`;
				// const manualGeomCol = this.geomColName_manual;
				// const list = [];
				// const listOrigin = [];
				// const geojsonFormat = new GeoJSON();
				// const wktFormat = new WKT();
				// this.topoCheck.resolved_areas.map(i => {
				// 	const rec = {};
				// 	rec[primKeyCol] = i.gid;
				// 	const geom = geojsonFormat.readGeometry(i.geom);
				// 	const geomWkt = wktFormat.writeGeometry(geom);
				// 	rec[manualGeomCol] = geomWkt;
				// 	list.push(rec);
				// 	const recOrigin = {};
				// 	recOrigin[primKeyCol] = i.gid;
				// 	recOrigin[manualGeomCol] = null; // Update everything
				// 	listOrigin.push(recOrigin);
				// 	return rec;
				// });
				// const cols = Object.keys(this.appinfoService.columnMap).filter(c => this.appinfoService.columnMap[c].sourceTab === sourceTableName);
				// // Remove system cols
				// const systemCol_id_idx = cols.findIndex(c => c === primKeyCol);
				// cols.splice(systemCol_id_idx, 1);
				// const updateGtos = this.editService.getUpdateGtosByRecordsArchive(cols, list, listOrigin, sourceTableName, prefix, primKeyCol, this.geomColName_manual);
				// await this.gtoService.processGto(updateGtos.gtos);
				// await this.qcService.qcLayers(layer.id);
			} catch (err) {
				console.log(err);
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		}
	}
	// TODO: To delete. The following functions should be retired once topology state is implemented
		async onResolveTopoErrors(e: TopoResolveData) {
			const resolvedTopo = this.topoService.resolveOverlapsAndGaps(this.topoCheck);
			this.topoCheck.changedFeatureIds = resolvedTopo.changedFeatureIds;
			this.topoCheck.geojson = resolvedTopo.geojson;
			await this.checkTopoErrorIntra(this.topoCheck.geojson);
			this.drawTopoCheckResultOnMap(this.topoCheck);
			if (!this.topoCheck.gap.length && !this.topoCheck.overlap.length) {
				if (!this.topoCheck.crevice.length) {
					await this.checkTopoErrorInter(this.topoCheck.geojson);
					
					// if (this.isTopoErrorEditing) {
					// 	await this.turnOffTopoErrorEditing();
					// 	this.enableTopoFeaturesEditing();
					// }
				}

			} else {

				// TODO
				if (this.topoCheck) {
					// this.mapseßrvice
				}
			}
		}
		async onConfirmCrevice(e) {
			// if (this.isTopoErrorEditing) {
			// 	await this.turnOffTopoErrorEditing();
			// 	this.enableTopoFeaturesEditing();
			// }
		}
		async onCommitTopoErrors(e) {
			// const editedGeojsons = this.topoCheck.geojson.features.filter(f => f[this.isEditedCol]);
			// const discIds = [];
			// const source = this.mapService.map.addedLayers[this.dataLayerName].getSource();
			// editedGeojsons.forEach(geoj => {
			// 	// Find discrepancy agency & send notification
			// 	const feat = source.getFeatureById(geoj.id);
			// 	if (feat) {
			// 		const attrs = feat.getProperties()[this.attrKey];
			// 		if (attrs && attrs[this.discrepancyAgencyIdColName] && attrs[this.discrepancyAgencyIdColName] !== this.appinfoService.customerProfile.discrepancyAgencyId) {
			// 			discIds.push(attrs[this.discrepancyAgencyIdColName]);
			// 		}
			// 	}
			// });
			this.updateTopoErrorFixToTopojsonLayer();
			await this.addTopoFeaturesToCards(this.topoCheck.changedFeatureIds);


			// TODO: Notify other agencies!!
			// TODO: not all attributes are obtained for other agencies here!!!!!
				// if (discIds.length) {
				// 	this.toastr.info('The following agencies have been notified of boundary change request: \n' + discIds.join(', '));
				// }

			await this.turnOffTopoErrorEditing();
			this.enableTopoFeaturesEditing();
			// const features =  this.convertGeojsonToTopoFeatures(this.topoCheck.geojson);
			// this.mapService.map.addedLayers[this.topojsonLayerName].getSource().clear();
			// this.mapService.map.addedLayers[this.topojsonLayerName].getSource().addFeatures(features);
		}
		// Update the fixing of topo errors to topojson data
		private updateTopoErrorFixToTopojsonLayer() {
			// 1. update data layer features' geometry
			if (this.topoCheck.geojson && this.topoCheck.changedFeatureIds && this.topoCheck.changedFeatureIds.length) {
				const source = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].getSource();
				const geojsonFormat = new GeoJSON();
				this.topoCheck.geojson.features.forEach(f => {
					const id = f.id;
					if (!id) { return; }
					if (this.topoCheck.changedFeatureIds.indexOf(id) === -1) {
						return;
					}
					const feat = source.getFeatureById(id);
					if (!feat) { return; }
					const olGeom = (<Polygon | MultiPolygon>geojsonFormat.readFeature(f.geometry).getGeometry());
					const originalOlGeom = feat.getGeometry();
					// if feature not changed
					if (olGeom.getType() === originalOlGeom.getType() && JSON.stringify(olGeom.getCoordinates()) === JSON.stringify(originalOlGeom.getCoordinates())) {
						return;
					}
					// feature has changed
					feat.setGeometry(olGeom);
				});
				const features =  this.topoService.convertGeojsonToTopoFeatures(this.topoCheck.geojson);
				this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource().clear();
				this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource().addFeatures(features);
			}

		}

	//
	private async addTopoFeaturesToCards(featIds: any[], isHold?: boolean) {
		if (!featIds || !featIds.length) {
			return;
		}
		const promises = [];
		const layerSource = this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource();
		// TODO
		const currSelectedId = this.currentCardId; // this.cardSelectedRecord ? this.getRecordId(this.cardSelectedRecord): '';
		const wktFormat = new WKT();
		featIds.forEach(async id => {
			const f = layerSource.getFeatureById(id);
			if (!f) {
				return;
			}
			let attrs = this.mainDataService.getDataAttrs(id);
			this.mainDataService.setDataAttrs(id, this.isTopoEditedKey, true);
				// const props = f.getProperties();
				// props[this.isTopoEditedKey] = true;
				// //
				// f.setProperties(props);
			// Find feat on dataLayer
			let featOnDataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName].getSource().getFeatureById(id);
			if (!featOnDataLayer) {
				featOnDataLayer = f.clone();
				// TODO : new feature
			}
			featOnDataLayer.setGeometry(f.getGeometry());
				// let propsOnData = featOnDataLayer.getProperties();
			// Update stored geom
			const wktString = wktFormat.writeGeometry(f.getGeometry());
			// propsOnData[this.attrKey][this.geomColName_manual] = wktString;
			// Add card
			if (!attrs[this.isEditedCol]) {
				// Update details if needed
				if (attrs[this.isIdOnlyKey]) {
					const promise =  this.updateFeatureDetail(id);
					promises.push(promise);
					await promise;
					// propsOnData = featOnDataLayer.getProperties();
				}
				// Add card
				this.mainDataService.addRecToCard(id, this.selectedLayer.category.code, null, null, isHold);
				// card = JSON.parse(JSON.stringify(propsOnData[this.attrKey]));
				// this.addRecToCard(propsOnData[this.attrKey], card);
				// propsOnData[this.attrKey][this.isEditedCol] = true;
				
				// Update selected card to same object
				if (id === currSelectedId) {
					setTimeout(() => {
						this.updateCurrentCard(id);
					});
				}				
			}
			// card[this.geomColName_manual] = wktString;
			this.mainDataService.setDataAttrs(id, this.geomColName_manual, wktString);
			//
			// featOnDataLayer.setProperties(propsOnData);
		});

		await Promise.all(promises);
	}
	private notifyAffectedAgencies() {


		// TODO

		// const attrs = feat.getProperties()[this.attrKey];
		// if (attrs && attrs[this.discrepancyAgencyIdColName] && attrs[this.discrepancyAgencyIdColName] !== this.appinfoService.customerProfile.discrepancyAgencyId) {
		// 	discIds.push(attrs[this.discrepancyAgencyIdColName]);
		// }
	}
	//
	private startAddLineLabels() {
		this.mapSharedService.changeCursor(this.mapService.map.olMap, 'crosshair');
		const layers = [];
		if (this.selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
			layers.push(this.mapService.map.addedLayers[this.mapLayerService.dataLayerName]);
			layers.push(this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName]);
		}
		const refLayer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		if (refLayer.getProperties()[this.attrIndexService.refLayerCodeKey] === this.attrIndexService.cateCodeCenterline) {
			layers.push(refLayer);
		}

		this.onMapClick_addLabel = async e => {
			const point = e.coordinate;
			const pixel = e.pixel;
			const feats = []
			const featsByLayer = {};
			this.mapService.map.olMap.forEachFeatureAtPixel(pixel, (feat, layer) => {
				if (layers.indexOf(layer) === -1) { return; }
				// if (lineFeat) { return; }
				// lineFeat = feat;
				feats.push(feat);
				const layerName = layer.getProperties().layerName;
				if (!featsByLayer[layerName]) {
					featsByLayer[layerName] = [];
				}
				featsByLayer[layerName].push(feat);
			}, {
				hitTolerance: 10
			});
			const tempLayer = new VectorLayer({
				source: new VectorSource({
					features: feats
				})
			});
			const lineFeat = tempLayer.getSource().getClosestFeatureToCoordinate(point);
			// const lineFeat = layer.getSource().getClosestFeatureToCoordinate(point);
			if (lineFeat) {
				this.hasRclLabels = true;
				// Flash feat
				this.mapLayerService.setLabelFeatFlashStyle(lineFeat);
				// setTimeout(() => {
				// 	lineFeat.
				// })
				//
				const lineId = (<string>lineFeat.getId());
				const layerName = Object.keys(featsByLayer).find(l => featsByLayer[l].indexOf(lineFeat) > -1);
				const layerId = this.layerService.layerListBS.getValue().layers.find(l => l.category.code === this.attrIndexService.cateCodeCenterline).id;
				const info = await this.mapService.getPointPositionToLine(layerId, lineId, point);
				// Get label text
				let leftText: string, rightText: string;
				let props;
				if (layerName === this.mapLayerService.dataLayerName) {
					const attrs = this.mainDataService.getDataAttrs(lineFeat.getId());
					props = attrs || {}
				} else {
					props = lineFeat.getProperties();
				}
				// let props = layerName === this.mapLayerService.dataLayerName ? lineFeat.getProperties()[this.attrIndexService.attrKey] : lineFeat.getProperties();
				props = props || {};
				const streetName = (layerName === this.mapLayerService.bgReferenceLayerName ? props[this.attrIndexService.refStreetNameColName] : props[this.attrIndexService.rdStreetNameColName]) || '';
				const fromLeft = props[this.attrIndexService.fromAddrLeftColName] || '';
				const toLeft = props[this.attrIndexService.toAddrLeftColName] || '';
				leftText = `
					<div class="label-street-name">${streetName}</div>
					<div class="label-addr-num">${fromLeft} - </div>
					<div class="label-addr-num">${toLeft}</div>
				`;
				const fromRight = props[this.attrIndexService.fromAddrRightColName] || '';
				const toRight = props[this.attrIndexService.toAddrRightColName] || '';
				rightText = `
					<div class="label-street-name" style="color:transparent;text-shadow:none;">${streetName}</div> 
					<div class="label-addr-num">${fromRight} - </div>
					<div class="label-addr-num">${toRight}</div>
				`;
				// Calculate label position
				const deltaPixel = 10; // pixel from label to line
				const pointOnLine = lineFeat.getGeometry().getClosestPoint(point);
				const pointOnLinePixel = this.mapService.map.olMap.getPixelFromCoordinate(pointOnLine);
				const pixelDist = Math.sqrt(Math.pow(pointOnLinePixel[0] - pixel[0], 2) + Math.pow(pointOnLinePixel[1] - pixel[1], 2)); // pixel distance between point and pointOnLine
				// Same side label
				const labelPixelY = (pixel[1] - pointOnLinePixel[1]) * deltaPixel / pixelDist + pointOnLinePixel[1];
				const labelPixelX = (pixel[0] - pointOnLinePixel[0]) * deltaPixel / pixelDist + pointOnLinePixel[0];
				const position = this.mapService.map.olMap.getCoordinateFromPixel([labelPixelX, labelPixelY]);
				const labelText = info.side === 'left' ? leftText : rightText;
				// The other side of label
				const labelPixelY2 = pointOnLinePixel[1] - (labelPixelY - pointOnLinePixel[1]);
				const labelPixelX2 = pointOnLinePixel[0] - (labelPixelX - pointOnLinePixel[0]);
				const position2 = this.mapService.map.olMap.getCoordinateFromPixel([labelPixelX2, labelPixelY2]);
				const labelText2 = info.side === 'left' ? rightText : leftText;

				let angleDeg = 0;
				if (info.azimuth_rad || info.azimuth_rad === 0) {
					angleDeg = info.azimuth_rad * (360 / 2 / Math.PI);
					angleDeg = angleDeg - 90;
					angleDeg = angleDeg % 360;
					if (angleDeg > 90 && angleDeg < 270) {
						angleDeg = angleDeg - 180;
					} else if (angleDeg < -90 && angleDeg > -270) {
						angleDeg = angleDeg + 180;
					}
				} 
				this.mapService.addLabelElem(lineId, info.side, labelText, position, angleDeg);
				this.mapService.addLabelElem(lineId, info.side === 'left' ? 'right' : 'left', labelText2, position2, angleDeg);
			}
			setTimeout(() => {
				// Wait for the mapSelectCondition to reject this select action before stopping labelPainter
				this.mapService.labelPainerSubject.next('stop');
			}, 500);
		}
		this.mapService.map.olMap.on('click', this.onMapClick_addLabel);
	}
	private stopAddLineLabels() {
		// this.mapService.map.olMap.getViewport().style.cursor = '';
		this.mapSharedService.changeCursor(this.mapService.map.olMap, '');
		this.mapService.map.olMap.un('click', this.onMapClick_addLabel);
	}
	private clearLineLabels() {
		this.mapService.labelOverlays.forEach(o => this.mapService.map.olMap.removeOverlay(o));
		this.mapService.labelOverlays = [];
	}
	//
	private startSplitLine() {
		// this.mapService.map.olMap.getViewport().style.cursor = 'crosshair';
		this.mapSharedService.changeCursor(this.mapService.map.olMap, 'crosshair');
		const layers = [];
		if (this.selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
			layers.push(this.mapService.map.addedLayers[this.mapLayerService.dataLayerName]);
			layers.push(this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName]);
		}
		this.onMapClick_lineSplit = async e => {
			const point = e.coordinate;
			const pixel = e.pixel;
			let lineFeat;
			let layerName;
			this.mapService.map.olMap.forEachFeatureAtPixel(pixel, (feat, layer) => {
				if (layers.indexOf(layer) === -1) { return; }
				lineFeat = feat;
				layerName = layer.getProperties().layerName;
			}, {
				hitTolerance: 5
			});
			if (lineFeat) {
				const layer = this.mapService.map.addedLayers[layerName];
				const pointOnGeom = lineFeat.getGeometry().getClosestPoint(point);
				const splits = await this.splitLineRecord(lineFeat, pointOnGeom, layer);
				this.splitMergeService.splitLineBS.next({
					id: lineFeat.getId(),
					splitPoint: point,
					splitPartsId: [splits.featA.getId(), splits.featB.getId()]
				});
				this.floatPopupService.openPopup(LineSplitComponent);
			}
			this.splitMergeService.splitToolBS.next({
				action: 'stop'
			});
		}
		this.mapService.map.olMap.on('click', this.onMapClick_lineSplit);
	}
	private stopSplitLine() {
		// this.mapService.map.olMap.getViewport().style.cursor = '';
		this.mapSharedService.changeCursor(this.mapService.map.olMap, '');
		this.mapService.map.olMap.un('click', this.onMapClick_lineSplit);
	}
	private startMergeLine() {
		const ids = this.mapService.dataSelectInteraction.getFeatures().getArray().map(i => i.getId());
		if (ids.length) {
			// this.splitMergeService.mergeLineBS.next({
			// 	ids: ids
			// });
			this.floatPopupService.openPopup(LineMergeComponent);
		}
		// this.mapService.addLineMergeSelectInteraction((e) => {

		// });
	}
	private stopMergeLine() {
		this.floatPopupService.closePopup(LineMergeComponent);
		// this.mapService.removeLineMergeSelectInteraction();
	}
	// Clear labels / interactive fishbones
	onContextmenuClear() {
		this.hasRclLabels = false;
		this.mapService.labelPainerSubject.next('clear');
		this.hasInteractiveFishbones = false;
		this.mapService.map.addedLayers[this.mapLayerService.interactiveFishboneLayerName].getSource().clear();
	}
	private startInteractiveFishbone() {
		this.isAddingInteractiveFB = true;
		this.fishboneService.interactiveFishboneSubject.next('start');
		// this.mapService.map.olMap.getViewport().style.cursor = 'crosshair';
		this.mapSharedService.changeCursor(this.mapService.map.olMap, 'crosshair');
		const layers = [];
		if (this.selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
			layers.push(this.mapService.map.addedLayers[this.mapLayerService.dataLayerName]);
			layers.push(this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName]);
		}
		const refLayer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		if (refLayer.getProperties()[this.attrIndexService.refLayerCodeKey] === this.attrIndexService.cateCodeCenterline) {
			layers.push(refLayer);
		}

		this.onMapClick_addFB = async e => {
			const point = e.coordinate;
			const pixel = e.pixel;
			const feats = []
			const featsByLayer = {};
			this.mapService.map.olMap.forEachFeatureAtPixel(pixel, (feat, layer) => {
				if (layers.indexOf(layer) === -1) { return; }
				feats.push(feat);
				const layerName = layer.getProperties().layerName;
				if (!featsByLayer[layerName]) {
					featsByLayer[layerName] = [];
				}
				featsByLayer[layerName].push(feat);
			}, {
				hitTolerance: 10
			});
			const tempLayer = new VectorLayer({
				source: new VectorSource({
					features: feats
				})
			});
			const lineFeat = tempLayer.getSource().getClosestFeatureToCoordinate(point);
			if (lineFeat) {
				this.hasInteractiveFishbones = true;
				const layerName = Object.keys(featsByLayer).find(l => featsByLayer[l].indexOf(lineFeat) > -1);
				let props;
				if (layerName === this.mapLayerService.dataLayerName) {
					const attrs = this.mainDataService.getDataAttrs(lineFeat.getId());
					props = attrs || {}
				} else {
					props = lineFeat.getProperties();
				}
				// let props = layerName === this.mapLayerService.dataLayerName ? lineFeat.getProperties()[this.attrIndexService.attrKey] : lineFeat.getProperties();
				props = props || {};
				const model = this.mainDataService.modelBS.getValue();
				const fb = await this.fishboneService.getFishboneInteractive(props[this.attrIndexService.rcIdCol], model);
				if (fb && fb.data) {
					const results = this.fishboneService.getFeaturesFromFishboneData(fb.data);
					this.mapService.map.addedLayers[this.mapLayerService.interactiveFishboneLayerName].getSource().addFeatures(results.addressFeatures);
						this.mapService.map.addedLayers[this.mapLayerService.interactiveFishboneLayerName].getSource().addFeatures(results.spikeFeatures);
				} else {
					this.toastr.info('Address points and Centerline do not match to form a fishbone.');
				}
				this.stopInteractiveFishbone();
			} else {
				this.toastr.info('Please click on a centerline to draw fishbone.');
				this.stopInteractiveFishbone();
			}
		}
		this.mapService.map.olMap.on('click', this.onMapClick_addFB);
	}
	private stopInteractiveFishbone() {
		this.isAddingInteractiveFB = false;
		// this.mapService.map.olMap.getViewport().style.cursor = '';
		this.mapSharedService.changeCursor(this.mapService.map.olMap, '');
		this.mapService.map.olMap.un('click', this.onMapClick_addFB);
		this.fishboneService.interactiveFishboneSubject.next('stop');
	}
	private ssapRclLinkCallback = async (e) => {
		const map = this.mapService.map;
		const point = e.coordinate;
		const pixel = e.pixel;
		const feats = []
		const featsByLayer = {};
		const centerlineLayers = [];
		if (this.selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
			const dataLayer = map.addedLayers[this.mapLayerService.dataLayerName];
			const surroundingLayer = map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
			centerlineLayers.push(dataLayer);
			centerlineLayers.push(surroundingLayer);
		}
		const refLayer = map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		if (refLayer.getProperties()[this.attrIndexService.refLayerCodeKey] === this.attrIndexService.cateCodeCenterline) {
			centerlineLayers.push(refLayer);
		}
		map.olMap.forEachFeatureAtPixel(pixel, (feat, layer) => {
			if (centerlineLayers.indexOf(layer) === -1) { return; }
			feats.push(feat);
			const layerName = layer.getProperties().layerName;
			if (!featsByLayer[layerName]) {
				featsByLayer[layerName] = [];
			}
			featsByLayer[layerName].push(feat);
		}, {
			hitTolerance: 10
		});
		const tempLayer = new VectorLayer({
			source: new VectorSource({
				features: feats
			})
		});
		const lineFeat = tempLayer.getSource().getClosestFeatureToCoordinate(point);
		const layerName = Object.keys(featsByLayer).find(l => featsByLayer[l].indexOf(lineFeat) > -1);
		this.drawSsapRclLinkByCenterline(lineFeat, layerName);
		// if (lineFeat) {
		// 	const dataLayer = map.addedLayers[this.mapLayerService.dataLayerName];
		// 	const surroundingLayer = map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
		// 	const refLayer = map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		// 	const addressLayers = [];
		// 	const centerlineLayers = [];
		// 	if (this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
		// 		addressLayers.push(dataLayer);
		// 		addressLayers.push(surroundingLayer);
		// 	} else if (this.selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
		// 		centerlineLayers.push(dataLayer);
		// 		centerlineLayers.push(surroundingLayer);
		// 	}
		// 	if (refLayer.getProperties()[this.attrIndexService.refLayerCodeKey] === this.attrIndexService.cateCodeAddress) {
		// 		addressLayers.push(refLayer);
		// 	} else if (refLayer.getProperties()[this.attrIndexService.refLayerCodeKey] === this.attrIndexService.cateCodeCenterline) {
		// 		centerlineLayers.push(refLayer);
		// 	}

		// 	const layerName = Object.keys(featsByLayer).find(l => featsByLayer[l].indexOf(lineFeat) > -1);
		// 	let props = layerName === this.mapLayerService.dataLayerName ? lineFeat.getProperties()[this.attrIndexService.attrKey] : lineFeat.getProperties();
		// 	props = props || {};
		// 	const model = this.mainDataService.modelBS.getValue();
		// 	const fb = await this.layerService.getSsapByRcl(props[this.attrIndexService.rcIdCol], model);
		// 	const addressFeats = [];
		// 	if (fb && fb.data) {
		// 		const addressGlobalIds = fb.data.map(i => i[this.attrIndexService.addrGlobalId]);
		// 		addressGlobalIds.forEach(id => {
		// 			let feat;
		// 			addressLayers.find(l => {
		// 				feat = l.getSource().getFeatureById(id);
		// 				return feat;
		// 			});
		// 			if (feat) {
		// 				addressFeats.push(feat);
		// 			}
		// 		});
		// 	}
		// 	let flashLayer = this.mapService.map.addedLayers[this.mapLayerService.ssapRclLinkLayerName];
		// 	if (!flashLayer) {
		// 		flashLayer = this.mapService.map.addLayer(this.mapLayerService.ssapRclLinkLayerName, {
		// 			style: this.mapLayerService.getBasicHighlightStyle
		// 			// style: this.cMapService.getCommonStyle({
		// 			// 	fillColor: color,
		// 			// 	imgFillColor: color,
		// 			// 	strokeColor: color,
		// 			// 	strokeWidth: 6,
		// 			// 	pointRadius: 6
		// 			// })
		// 		});
		// 	}
		// 	let i = 0;
		// 	const flashInterval = setInterval(() => {
		// 		if (i >= 5) {
		// 			clearInterval(flashInterval);
		// 		}
		// 		if (i % 2 === 0) {
		// 			flashLayer.getSource().clear();
		// 			// i = 1;
		// 		} else {
		// 			if (addressFeats.length) {
		// 				flashLayer.getSource().addFeatures(addressFeats);
		// 			}
		// 			flashLayer.getSource().addFeature(lineFeat);
		// 			// i = 0;
		// 		}
		// 		i++;
		// 	}, 200);
		// } else {
		// 	let flashLayer = this.mapService.map.addedLayers[this.mapLayerService.ssapRclLinkLayerName];
		// 	if (flashLayer) {
		// 		flashLayer.getSource().clear();
		// 	}
		// 	// this.toastr.info('Please click on a centerline.');
		// }
		
	}
	private async drawSsapRclLinkByCurrent() {
		if (this.selectedLayer.category.code !== this.attrIndexService.cateCodeCenterline) {
			return;
		}
		const selectedFeat = this.mapService.dataSelectInteraction.getFeatures().getArray()[0];
		if (!selectedFeat) {
			return;
		}
		await this.drawSsapRclLinkByCenterline(selectedFeat, this.mapLayerService.dataLayerName);
	}
	private async drawSsapRclLinkByCenterline(lineFeat: Feature, lineLayerName: string) {
		const map = this.mapService.map;
		if (lineFeat) {
			const dataLayer = map.addedLayers[this.mapLayerService.dataLayerName];
			const surroundingLayer = map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
			const refLayer = map.addedLayers[this.mapLayerService.bgReferenceLayerName];
			const addressLayers = [];
			if (this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
				addressLayers.push(dataLayer);
				addressLayers.push(surroundingLayer);
			}
			if (refLayer.getProperties()[this.attrIndexService.refLayerCodeKey] === this.attrIndexService.cateCodeAddress) {
				addressLayers.push(refLayer);
			}

			const layerName = lineLayerName;
			let props;
			if (layerName === this.mapLayerService.dataLayerName) {
				const attrs = this.mainDataService.getDataAttrs(lineFeat.getId());
				props = attrs || {}
			} else {
				props = lineFeat.getProperties();
			}
			// let props = layerName === this.mapLayerService.dataLayerName ? lineFeat.getProperties()[this.attrIndexService.attrKey] : lineFeat.getProperties();
			props = props || {};
			const model = this.mainDataService.modelBS.getValue();
			const fb = await this.layerService.getSsapByRcl(props[this.attrIndexService.rcIdCol], model);
			const addressFeats = [];
			if (fb && fb.data) {
				const addressGlobalIds = fb.data.map(i => i[this.attrIndexService.addrGlobalId]);
				addressGlobalIds.forEach(id => {
					let feat;
					addressLayers.find(l => {
						feat = l.getSource().getFeatureById(id);
						return feat;
					});
					if (feat) {
						addressFeats.push(feat);
					}
				});
			}
			let flashLayer = map.addedLayers[this.mapLayerService.ssapRclLinkLayerName];
			if (!flashLayer) {
				flashLayer = map.addLayer(this.mapLayerService.ssapRclLinkLayerName, {
					style: this.mapLayerService.getBasicHighlightStyle
					// style: this.cMapService.getCommonStyle({
					// 	fillColor: color,
					// 	imgFillColor: color,
					// 	strokeColor: color,
					// 	strokeWidth: 6,
					// 	pointRadius: 6
					// })
				});
			}
			let i = 0;
			const flashInterval = setInterval(() => {
				if (i >= 5) {
					clearInterval(flashInterval);
				}
				if (i % 2 === 0) {
					flashLayer.getSource().clear();
					// i = 1;
				} else {
					if (addressFeats.length) {
						flashLayer.getSource().addFeatures(addressFeats);
					}
					flashLayer.getSource().addFeature(lineFeat);
					// i = 0;
				}
				i++;
			}, 200);
		} else {
			let flashLayer = map.addedLayers[this.mapLayerService.ssapRclLinkLayerName];
			if (flashLayer) {
				flashLayer.getSource().clear();
			}
			// this.toastr.info('Please click on a centerline.');
		}
	}
	private startAddressesOnRoadMode() {
		this.isSsapRclLinkModeOn = true;
		// this.mapService.map.olMap.getViewport().style.cursor = 'crosshair';
		this.mapSharedService.changeCursor(this.mapService.map.olMap, 'crosshair');
		const layers = [];
		if (this.selectedLayer.category.code === this.attrIndexService.cateCodeCenterline) {
			layers.push(this.mapService.map.addedLayers[this.mapLayerService.dataLayerName]);
			layers.push(this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName]);
		}
		const refLayer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
		if (refLayer.getProperties()[this.attrIndexService.refLayerCodeKey] === this.attrIndexService.cateCodeCenterline) {
			layers.push(refLayer);
		}

		this.onMapClick_addressesOnRoad = async e => {
			const point = e.coordinate;
			const pixel = e.pixel;
			const feats = []
			const featsByLayer = {};
			this.mapService.map.olMap.forEachFeatureAtPixel(pixel, (feat, layer) => {
				if (layers.indexOf(layer) === -1) { return; }
				feats.push(feat);
				const layerName = layer.getProperties().layerName;
				if (!featsByLayer[layerName]) {
					featsByLayer[layerName] = [];
				}
				featsByLayer[layerName].push(feat);
			}, {
				hitTolerance: 10
			});
			const tempLayer = new VectorLayer({
				source: new VectorSource({
					features: feats
				})
			});
			const lineFeat = tempLayer.getSource().getClosestFeatureToCoordinate(point);
			if (lineFeat) {
				const layerName = Object.keys(featsByLayer).find(l => featsByLayer[l].indexOf(lineFeat) > -1);
				// let props = layerName === this.mapLayerService.dataLayerName ? lineFeat.getProperties()[this.attrIndexService.attrKey] : lineFeat.getProperties();
				let props;
				if (layerName === this.mapLayerService.dataLayerName) {
					const attrs = this.mainDataService.getDataAttrs(lineFeat.getId());
					props = attrs || {}
				} else {
					props = lineFeat.getProperties();
				}
				props = props || {};
				const model = this.mainDataService.modelBS.getValue();
				const fb = await this.layerService.getSsapByRcl(props[this.attrIndexService.rcIdCol], model);
				if (fb && fb.data) {
					const addressGlobalIds = fb.data.map(i => i[this.attrIndexService.addrGlobalId]);
					const addressFeats = [];
					const addressLayers = [];
					if (this.selectedLayer.category.code === this.attrIndexService.cateCodeAddress) {
						addressLayers.push(this.mapService.map.addedLayers[this.mapLayerService.dataLayerName]);
						addressLayers.push(this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName]);
					}
					const refLayer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
					if (refLayer.getProperties()[this.attrIndexService.refLayerCodeKey] === this.attrIndexService.cateCodeAddress) {
						addressLayers.push(refLayer);
					}
					addressGlobalIds.forEach(id => {
						let feat;
						addressLayers.find(l => {
							feat = l.getSource().getFeatureById(id);
							return feat;
						});
						if (feat) {
							addressFeats.push(feat);
						}
					});

					let flashLayer = this.mapService.map.addedLayers[this.mapLayerService.ssapRclLinkLayerName];
					if (!flashLayer) {
						flashLayer = this.mapService.map.addLayer(this.mapLayerService.ssapRclLinkLayerName, {
							style: this.mapLayerService.getBasicHighlightStyle
							// style: this.cMapService.getCommonStyle({
							// 	fillColor: color,
							// 	imgFillColor: color,
							// 	strokeColor: color,
							// 	strokeWidth: 6,
							// 	pointRadius: 6
							// })
						});
					}
					let i = 0;
					const flashInterval = setInterval(() => {
						if (i >= 5) {
							clearInterval(flashInterval);
						}
						if (i % 2 === 0) {
							flashLayer.getSource().clear();
							// i = 1;
						} else {
							flashLayer.getSource().addFeatures(addressFeats);
							flashLayer.getSource().addFeature(lineFeat);
							// i = 0;
						}
						i++;
					}, 200);
					// setTimeout(() => {
					// 	clearInterval(flashInterval);
					// 	this.mapService.map.olMap.removeLayer(flashLayer);
					// }, 2000);

					// this.mapService.map.addedLayers[this.mapLayerService.interactiveFishboneLayerName].getSource().addFeatures(results.addressFeatures);
					// this.mapService.map.addedLayers[this.mapLayerService.interactiveFishboneLayerName].getSource().addFeatures(results.spikeFeatures);
				} else {
					this.toastr.info('Address points and Centerline do not match to form a fishbone.');
				}
				this.stopAddressesOnRoadMode();
			} else {
				this.toastr.info('Please click on a centerline.');
			}
		}
		this.mapService.map.olMap.on('click', this.onMapClick_addressesOnRoad);
	}
	private stopAddressesOnRoadMode() {
		this.isSsapRclLinkModeOn = false;
		// this.mapService.map.olMap.getViewport().style.cursor = '';
		this.mapSharedService.changeCursor(this.mapService.map.olMap, '');
		this.mapService.map.olMap.un('click', this.onMapClick_addressesOnRoad);
		this.mapService.ssapRclLinkModeBS.next({
			isOn: false,
			source: 'main'
		});
	}
	//
	// private checkTopologyError() {
	// 	// const parser = this.getJstsParser();
	// 	// const features = this.mapService.map.addedLayers[this.dataLayerName].getSource().getFeatures();
	// 	// for (let i = 0; i < features.length - 1; i++) {
	// 	// 	const baseFeature = features[i];
	// 	// 	const geomA = parser.read(baseFeature.getGeometry());
	// 	// 	for (let j = i + 1; j < features.length; j++) {
	// 	// 		const targetFeature = features[j];
	// 	// 		const geomB = parser.read(targetFeature.getGeometry());
	// 	// 		const intersection = geomA.intersection(geomB);
	// 	// 	}
	// 	// }
	// 	// const overlaps = [];
	// }

	onSelectGeomErr(row) {

		
	}
	flashErrors(id, stopsAfter?: number) {
		if (this.qcFlashInterval || !id) {
			return;
		}
		const attrs = this.mainDataService.getDataAttrs(id);
		if (!attrs) {
			return;
		}
		const flashLayer = this.mapService.map.addedLayers[this.mapLayerService.flashLayerName];
		flashLayer.setVisible(true);
		let features = [];
		// Draw if there is geom error
		if (attrs[this.mapNotesColName]) {
			// TODO




			// const geoms = rec[this.geomQcColName].geoms; // geoms is an array of wkt string
			// if (geoms) {
			// 	features = features.concat(this.cMapService.drawDataByWkt(this.mapService.map, geoms.map(g => {
			// 		return {
			// 			wkt: g
			// 		};
			// 	}), flashLayer, {
			// 		skipZoomToLayer: true,
			// 		labelArr: rec[this.geomQcColName].labels
			// 	}));
			// }
		}
			// // Draw if there is topo error
			// if (rec[this.topoQcColName]) {
			// 	const geoms = rec[this.topoQcColName].geoms;
			// 	if (geoms) {
			// 		features = features.concat(this.cMapService.drawDataByWkt(this.mapService.map, geoms.map(g => {
			// 			return {
			// 				wkt: g
			// 			};
			// 		}), flashLayer, {
			// 			skipZoomToLayer: true,
			// 			labelArr: rec[this.topoQcColName].labels
			// 		}));
			// 	}
			// }
		if (features.length) {
			let i = 0
			this.qcFlashInterval = setInterval(() => {
				if (i === 0) {
					flashLayer.getSource().clear();
					i = 1;
				} else {
					flashLayer.getSource().addFeatures(features);
					i = 0;
				}
			}, 200);
			if (stopsAfter) {
				setTimeout(() => this.stopFlashErrors(), stopsAfter);
			}
		}
	}
	// flashErrors(rec, stopsAfter?: number) {
	// 	if (this.qcFlashInterval || !rec) {
	// 		return;
	// 	}
	// 	const flashLayer = this.mapService.map.addedLayers[this.mapLayerService.flashLayerName];
	// 	flashLayer.setVisible(true);
	// 	let features = [];
	// 	// Draw if there is geom error
	// 	if (rec[this.mapNotesColName]) {
	// 		// TODO




	// 		// const geoms = rec[this.geomQcColName].geoms; // geoms is an array of wkt string
	// 		// if (geoms) {
	// 		// 	features = features.concat(this.cMapService.drawDataByWkt(this.mapService.map, geoms.map(g => {
	// 		// 		return {
	// 		// 			wkt: g
	// 		// 		};
	// 		// 	}), flashLayer, {
	// 		// 		skipZoomToLayer: true,
	// 		// 		labelArr: rec[this.geomQcColName].labels
	// 		// 	}));
	// 		// }
	// 	}
	// 		// // Draw if there is topo error
	// 		// if (rec[this.topoQcColName]) {
	// 		// 	const geoms = rec[this.topoQcColName].geoms;
	// 		// 	if (geoms) {
	// 		// 		features = features.concat(this.cMapService.drawDataByWkt(this.mapService.map, geoms.map(g => {
	// 		// 			return {
	// 		// 				wkt: g
	// 		// 			};
	// 		// 		}), flashLayer, {
	// 		// 			skipZoomToLayer: true,
	// 		// 			labelArr: rec[this.topoQcColName].labels
	// 		// 		}));
	// 		// 	}
	// 		// }
	// 	if (features.length) {
	// 		let i = 0
	// 		this.qcFlashInterval = setInterval(() => {
	// 			if (i === 0) {
	// 				flashLayer.getSource().clear();
	// 				i = 1;
	// 			} else {
	// 				flashLayer.getSource().addFeatures(features);
	// 				i = 0;
	// 			}
	// 		}, 200);
	// 		if (stopsAfter) {
	// 			setTimeout(() => this.stopFlashErrors(), stopsAfter);
	// 		}
	// 	}
	// }
	stopFlashErrors() {
		if (this.qcFlashInterval) {
			clearInterval(this.qcFlashInterval);
			this.qcFlashInterval = null;
			setTimeout(() => {
				const flashLayer = this.mapService.map.addedLayers[this.mapLayerService.flashLayerName];
				flashLayer.getSource().clear();
				flashLayer.setVisible(false);
			}, 200);
		}
	}

	private onMouseoverCoord(coord: number[]) {
		this.cMapService.setCursorLocation(coord, this.mapService.map.addedLayers[this.mapLayerService.cursorLayerName]);
	}
	private clearMapData(skipModifyLayer?: boolean, skipRef?: boolean) {
		let layers = [
			this.mapService.map.addedLayers[this.mapLayerService.dataLayerName], 
			this.mapService.map.addedLayers[this.mapLayerService.qcErrorLayerName],
			this.mapService.map.addedLayers[this.mapLayerService.flashLayerName],
			this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName],
			this.mapService.map.addedLayers[this.mapLayerService.bgOptionalBdryLayerName],
			this.mapService.map.addedLayers[this.mapLayerService.countyBoundaryLayerName],
			this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName],
			this.mapService.map.addedLayers[this.mapLayerService.topoErrorLayerName],
			this.mapService.map.addedLayers[this.mapLayerService.topoResolvedLayerName],
			this.mapService.map.addedLayers[this.mapLayerService.ssapRclLinkLayerName]
		];
		if (!skipModifyLayer) {
			layers = layers.concat([
				this.mapService.map.addedLayers[this.mapLayerService.dataModifyLayerName] // TODO
			]);
		}
		if (!skipRef) {
			layers.push(this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName]);
		}
		this.cMapService.clearMap(this.mapService.map, layers, true);
	}

// #endregion 

// #region Panels
	// onToggleTableMapPanel(e: PanelToggleOutput) {
	// 	this.mapSplitRatio = e.splitRatio;
	// 	this.mapHideRatio = e.hideRatio;
	// }
	// private async toggleTable(isShow: boolean) {
	// 	this.showTable = isShow;
	// 	await new Promise<void>((resolve, reject) => {
	// 		setTimeout(() => {
	// 			this.onResize();
	// 			resolve();
	// 		});
	// 	});
	// }
	private toggleRightTabs(isShow: boolean) {
		this.showRightTabs = isShow;
		setTimeout(() => {
			this.onResize();
		});
	}
	private onResize() {
		if (this.resizeTimeout) {
			clearTimeout(this.resizeTimeout);
		}
		this.resizeTimeout = setTimeout(() => {
			// Don't get data for this updating size
			this.pauseGettingData = true;
			this.mapService.map.updateSize();
			if (this.dataTable) {
				this.dataTable.resize();
				this.manuallyScrollOnTable();
			}
			// if (this.cardSelectedRecord) {

				// TODO

				// this.selectRecordsOnMap([this.editCardRef.selectedRecord[this.demarcationService.dmIdColumn]], this.mapService.map.addedLayers[this.demarcationService.dmLayerName]);
				// this.selectRecordOnTable(this.editCardRef.selectedRecord[this.demarcationService.dmIdColumn]);
			// }
		}, 200);
	}
	// Temporary fix for ngx-datatable not draw until scroll // Reference: https://github.com/swimlane/ngx-datatable/issues/861
	private manuallyScrollOnTable() {
		setTimeout(() => {
			const tableElem = this.elemRef.nativeElement.querySelector('datatable-body');
			if (tableElem) {
				tableElem.scrollTop += 1;
				tableElem.scrollLeft += 1;
			}
		});
	}
	public onPaneResize(e, updateMapRatio?: boolean) {
		if (updateMapRatio) {
			this.mapSplitRatio = e.sizes[1];
		}
		this.onResize();
	}
// #endregion

	private updateIsSample() {
		this.isSample = this.isStoredDataSample || this.isDisplaySample;
		this.activityService.isDataSample.next(this.isSample);
		//
		// this.setTableSelectionType();
	}

	// runQc() {
	// 	if (!this.selectedLayer) {
	// 		return;
	// 	}
	// 	const rules = this.mainDataService.getQaCodesFromFilterOptions();
	// 	this.qcService.qcLayers(this.selectedLayer.id, null, rules);			
	// }
	async onChangeTab(e: FeatureTab<TabKey>) {
		//
		if (this.selectedTab && this.selectedTab.key !== e.key) {
			const isContinue = await this.preventUnsavedEdits();
			if (!isContinue) {
				this.verticalTabsComp.selectTab(this.tabs.indexOf(this.selectedTab));
				return;
			}
		}
		this.activityService.selectedTabBS.next({
			tabKey: e ? e.key : null
		});

		const prevTab = this.selectedTab;
		this.selectedTab = e;

		if (this.selectedTab && this.selectedTab.key === 'schema') {
			this.isSchemaTab = true;
		} else {
			this.isSchemaTab = false
			if (this.hasLayerChangedInSchemaTab) {
				setTimeout(async () => {
					await this.updateDataAfterLayerChange();
					this.hasLayerChangedInSchemaTab = false;
				});
				
			}
		}
		if (this.selectedTab && this.selectedTab.key === 'a3i') {
			this.isA3iTab = true;
			this.onResize();
		} else {
			this.isA3iTab = false;
			if (prevTab && prevTab.key === 'a3i') {
				this.onResize();
			}
		}
		// if (e.key === 'exception') {
		// 	if (!this.current.selectedLayer || !this.rows.length) {
		// 		this.exceptions = [];
		// 	} else {
		// 		this.commonService.setLoadingSpinner(true);
		// 		try {
		// 			await this.getExceptions();
		// 		} catch (err) {
		// 			console.log(err);
		// 		}
		// 		this.commonService.setLoadingSpinner(false);
		// 	}
		// }
	}

		// // Check: Right click on map - start editing
		// checkEnableMapStartEditing = (): boolean => {
		// 	this.disableReasonMapEditing = '';
		// 	if (this.editModeDisabled) {
		// 		return false;
		// 	}
		// 	if (this.contentKey === 'published') {
		// 		return false;
		// 	}
		// 	if (this.isSample) {
		// 		this.disableReasonMapEditing = 'Editing is turned off while data is sampled.';
		// 		return false;
		// 	}
		// 	if (!this.rightClickFeature || this.isMapEditing) {
		// 		return false;
		// 	}
		// 	let isSelfAgency = null;
		// 	if (this.rightClickFeature) {
		// 		// Collaborative: Check if feature belongs to same agency as customer
		// 		if (this.enableDiscrepancyAgencyRule && this.selectedLayer.isFishbone !== true && this.selectedLayer.category.isCollaborative) {
		// 			const prop = this.rightClickFeature.getProperties();
		// 			isSelfAgency = this.isSelfAgency(prop[this.attrKey]);
		// 		}
		// 	}
		// 	if (isSelfAgency !== null && isSelfAgency !== true) {
		// 		this.disableReasonMapEditing = 'Only features that belong to current agency can be edited';
		// 		return false;
		// 	} else if (!this.isMapFilterOn) {
		// 		this.disableReasonMapEditing = 'Please turn on map filter to start editing';
		// 		return false;
		// 	}
		// 	return true;
		// }
	disableCardEdit = () => {
		if (this.editModeDisabled) {
			return true;
		}
		if (this.contentKey === 'published') {
			return true;
		}
		if (this.isSample) {
			return true;
		}
		const currentCardRecord = this.currentCardId ? this.mainDataService.getDataAttrs(this.currentCardId) : null;
		if (this.selectedLayer.category.isCollaborative && currentCardRecord) {
			// Only allow editing in same disc agency
			const isSelfAgency = this.isSelfAgency(currentCardRecord);
			if (!isSelfAgency) {
				return true;
			}
		}
		return false;
	}

	private async updateLayerList(statusOnly?: boolean) {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			await this.layerService.getLayers(this.selectedCustomerId, statusOnly);
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	// If statusOnly, no need to update selected layer
	private async onLayersUpdate(statusOnly?: boolean) {
		const layers = this.layerService.layerListBS.getValue().layers;
		// Update bdry layers
		await this.layerService.getBdryLayers();
		//
		layers.sort((a, b) => {
			if (a.category.name > b.category.name) {
				return 1;
			} else if (a.category.name < b.category.name) {
				return -1;
			} else {
				return 0;
			}
		}); // This should be set before updateInerLayers

		let displayedLayers: AppLayer[];
		switch (this.contentKey) {
			case 'live':
				displayedLayers = layers.filter(l => l.state.num > 0 && (l.maintainType === 'LIVE' || l.maintainType === 'COLLABORATIVE'));

				// this.current.layers = layers.filter(l => !!l.state && l.maintainType === 'LIVE');
				break;
			case 'published': // TODO
				displayedLayers = this.layerService.layerListBS.getValue().publishedLayers;
				break;
		}
		this.activityService.displayedLayerListBS.next({
			layers: displayedLayers
		});

		let selectedLayer: AppLayer;
		let keepFilters: boolean;
		if (this.prevSelectedLayer) {
			keepFilters = true;
			selectedLayer = displayedLayers.find((l) => l.state.num > 0 && l.category.code === this.prevSelectedLayer.category.code);
		} 

		if (!this.selectedLayer) {
			selectedLayer = displayedLayers[0];
			// selectedLayer = displayedLayers.find(l => l.category.code === 'ROADCL')
		}
		this.activityService.selectedLayerBS.next({
			layer: selectedLayer,
			keepFilters: keepFilters
		});
	}
	private checkGenralExecute() {
		if (this.isNavigationStart) {
			return false;
		}
		return true;
	}
	async ngOnInit() {
		let isInit = true;

		this.defaultGutterSize = this.attrIndexService.defaultGutterSize;

		this.addrUuidCol = this.attrIndexService.interlayerGlobalId1; // this.attrIndexService.addrUuidCol;
		this.rcUuidCol2 = this.attrIndexService.rcUuidCol2;
		this.rcUuidCol = this.attrIndexService.rcUuidCol;
		this.fishboneRcLayerIdCol = this.attrIndexService.fishboneRcLayerIdCol;
		//
		this.isEditedCol = this.attrIndexService.isEditedKey;
		this.toDeleteCol = this.attrIndexService.isDeletedKey;
		this.isIdOnlyKey = this.attrIndexService.isIdOnlyKey;
		this.attrKey = this.attrIndexService.attrKey;
		// this.originDataKey = this.attrIndexService.originalDataKey;
		this.qaNotesColName = this.attrIndexService.qaNotesColName;
		this.mapNotesColName = this.attrIndexService.mapNotesColName;
		this.qaNotesGeomColName = this.attrIndexService.qaNotesGeomColName;
		this.exceptionColName = this.attrIndexService.exceptionColName;
		this.geomColName_manual = this.attrIndexService.geomColManual;
		this.addrFishboneCol = this.attrIndexService.addrFishboneCol;
		this.qaErrorLevelColName = this.attrIndexService.qaErrorLevelColName;

		this.pageSizeDefault = this.tableService.defaultTableConfig.pageSize;
		this.pageSize = this.pageSizeDefault;

		// Store schema columns in service
		this.mainDataService.schemas = this.schemas;

		this.editModeDisabled = !!this.editService.checkEditModeDisabled();

		// this.editRecordList = this.editService.editRecordList;

		this.selectedCustomerSub = this.userService.selectedCustomer.subscribe(async (data) => {
			if (data) {
				const selectedCustomerId = data.id;
				if (selectedCustomerId === this.selectedCustomerId) {
					return;
				}
				if (isInit) {

				} else {
					// Check edited data
					const isContinue = await this.preventUnsavedEdits();
					if (!isContinue) {
						const prevCusId = this.selectedCustomerId;
						this.paneHeaderService.changeCustomerSubject.next(prevCusId);
						return;
					}
	
					// Set selected customer
					this.selectedCustomerId = selectedCustomerId;
					await this.onChangeCustomer();
				}
			}
		});
		this.route.data.subscribe(async (data) => {
			// await this.onContentChange(data.content);
			const contentKey = data.content;
			this.mainDataService.contentMenuItemKeyBS.next(contentKey);
			if (this.contentKey === contentKey) {
				return;
			} else {
				this.contentKey = contentKey;
			}
		});
		this.routerEventSub = this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				this.isNavigationStart = true;
			} else if (event instanceof GuardsCheckEnd && !event.shouldActivate) {
				this.isNavigationStart = false;
			}
		});
			// Nena domain should be obtained before getting standard schema
			// await this.editCardService.getNenaDomains();
			// await this.editCardService.getNctDomains();
		
		this.schemaDefinedBySub = this.mainDataService.schemasDefinedByBS.subscribe(data => {
			this.schemaKey = data[this.contentKey].currentDefinedBy;
			this.onSchemaDataChange();
		});
		this.schemaDataSub = this.mainDataService.schemaDataBS.subscribe(data => {
			this.onSchemaDataChange();
		});
		this.modelSub = this.mainDataService.modelBS.subscribe(async data => {
			if (this.modelKey !== data) {
				this.modelKey = data;
				this.setColumns(this.filterColumnsByModel());
				this.updateFilterColumns();
				this.updateBatchColumns();
				if (!this.isDataAllFields && !isInit) {
					await this.getData({
						pageNumber: 1,
						rowCount: 1
					}, {
						keepEditedData: true,
						// keepPrevColumns: true,
						keepSelectedData: true
					});
					await this.selectAfterRetrieveData();
				}
				// Trigger fishbone style change
				if (this.isFishboneOn && this.mapReso < this.mapLayerService.fishboneReso) {
					this.manuallyTriggerFishboneStyle();
				}
			}
		});
		this.mapFilterSub = this.activityService.mapFilterBS.subscribe(async data => {
			if (this.isMapFilterOn !== data.isOn) {
				this.isMapFilterOn = data.isOn;
				// if (!this.isFishboneOn) {
					this.updateMyLayerTableConfig();
				// }
				if (!isInit) {
					if (this.isMapFilterOn) {
						this.cMapService.clearMap(this.mapService.map, 
							[this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName],
							// this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName], // do not clear ref data if only mapFilter is toggled
							this.mapService.map.addedLayers[this.mapLayerService.topojsonLayerName],
							// TODO				
						], true);
					}
					await this.getData({
						pageNumber: 1,
						rowCount: 1
					}, {
						keepPrevColumns: true,
						keepEditedData: true,
						keepSelectedData: true
					});
				}
			}
		});
		this.mapLabelSub = this.mapService.labelPainerSubject.subscribe(data => {
			switch (data) {
				case 'clear':
					this.clearLineLabels();
					break;
				case 'start':
					if (!this.isAddingLabel) {
						this.isAddingLabel = true;
						this.startAddLineLabels();
					}
					break;
				case 'stop':
					if (this.isAddingLabel) {
						this.isAddingLabel = false;
						this.stopAddLineLabels();
					}
			}
		});
		this.mapAddressesOnRoadModeSub = this.mapService.ssapRclLinkModeBS.subscribe(data => {
			if (isInit || data.source === 'main') {
				return;
			}
			this.isSsapRclLinkModeOn = data.isOn;
			if (data.isOn) {
				if (!this.mapService.ssapRclLinkEvent) {
					const clickListener = this.mapService.map.olMap.on('click', this.ssapRclLinkCallback)
					this.mapService.ssapRclLinkEvent = clickListener;
				}
			} else {
				this.mapService.map.olMap.un('click', this.ssapRclLinkCallback);
				this.mapService.ssapRclLinkEvent = null;
				let flashLayer = this.mapService.map.addedLayers[this.mapLayerService.ssapRclLinkLayerName];
				if (flashLayer) {
					flashLayer.getSource().clear();
				}
			}
			// if (data.isOn) {
			// 	this.startAddressesOnRoadMode();
			// } else {
			// 	this.stopAddressesOnRoadMode();
			// }
		});
		this.mapEditingSub = this.mapService.mapEditing.subscribe(data => {
			if (isInit || data.source === 'main') {
				return;
			}
			if (data.isOn && !this.isMapEditing) {
				this.startMapEditing(data.selectedId, data.skipGetTopo);
			} else if (!data.isOn && this.isMapEditing) {
				this.stopMapEditing();
			}
		})

		this.featMapAddSub = this.mapService.addNewGeomSubject.subscribe(data => {
			// TODO: feat map control add button trigger
			this.addRecord();
		})

		this.hoverCoordSub = this.activityService.hoverCoord.subscribe(data => {
			if (data) {
				if (this.hoverCoordTimeout) {
					clearTimeout(this.hoverCoordTimeout);
				}
				this.hoverCoordTimeout = setTimeout(() => {
					this.onMouseoverCoord(data.coord);
				});
			}
		});

		// Update layers on qc finishing
		this.qcFinishSub = this.qcService.onQcFinish.subscribe(async () => {
				// TODO 
				// // Do nothing if customer has changed
				// if (this.selectedCustomerId !== data.customerId) {
				// 	return;
				// }
			// if (this.current.contentKey === 'collaborative') {
			// 	return;
			// } else 
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				// if (this.isFishboneOn) {
				// 	await this.updateFishboneState(true);
				// 	this.commonService.setLoadingSpinner(false, spinnerId);
				// 	return;
				// }
				await this.updateLayerList();
				console.log('uuuuuuuuuuuupdate layer list after qc')
				// Update schema data 
				await this.mainDataService.getSchemaData();
				this.activityService.refreshData.next();
			} catch (err) {
				console.log(err);
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		});
		this.fbFinishSub = this.fishboneService.onFbFinish.subscribe(() => {
			this.activityService.refreshData.next();
		});

		this.attrFilterSub = this.attrFilterService.attrFilters.subscribe(async data => {
			this.attrFilters = data.filters;
			if (!isInit && !data.skipGetData) {
				await this.getData({
					pageNumber: 1,
					rowCount: 1
				}, {
					keepPrevColumns: true,
					keepEditedData: true,
					keepSelectedData: true
				});
			}
		});
		this.qcFilterInfoSub = this.mainDataService.qcFilterInfo.subscribe(async data => {
			//
			if (!isInit && data.source !== 'code' && !data.skipGetData) {
				await this.getData({
					pageNumber: 1,
					rowCount: 1
				}, {
					keepPrevColumns: true,
					keepEditedData: true,
					keepSelectedData: true
				});
			}
		});
		this.fishboneFilterInfoSub = this.mainDataService.fishboneFilterInfo.subscribe(async data => {
			if (!isInit) {
				await this.getData({
					pageNumber: 1,
					rowCount: 1
				}, {
					keepPrevColumns: true,
					keepEditedData: true
				});
			}
		});
		this.interactiveFishboneSub = this.fishboneService.interactiveFishboneSubject.subscribe(data => {
			if (data === 'start' && !this.isAddingInteractiveFB) {
				this.startInteractiveFishbone();
			} else if (data === 'stop' && this.isAddingInteractiveFB) {
				this.stopInteractiveFishbone();
			}
		});
		this.tooltipHelpSub = this.tooltipHelpService.isHelpOnBS.subscribe(data => {
			this.isTooltipHelpOn = data;
			this.cdRef.detectChanges();
		});
		this.refreshDataSub = this.activityService.refreshData.subscribe(async data => {
			if (data) {
				if (data.updateLayerList) {
					// update layer state
					await this.updateLayerList(true);
				} else if (data.updateSchema) { // If updateLayerList is true, schema will be updated in the process
					// Update filter option count
					await this.updateFilterOptions(true, true);
					// Update schema data 
					await this.mainDataService.getSchemaData();
				}	
			}
			await this.getData({
				pageNumber: 1,
				rowCount: 1
			}, {
				keepPrevColumns: true
			});
		});
		this.applyAttrFilterSub = this.activityService.applyAttrFilterSubject.subscribe(async () => {
			await this.getData({
				pageNumber: 1,
				rowCount: 1
			}, {
				keepPrevColumns: true,
				keepEditedData: true,
				keepSelectedData: true
			});
		});
		this.cancelSub = this.activityService.cancelChangesSubject.subscribe(async data => {
			await this.cancel();
		});
		// this.layerControlSub = this.mapService.layerControlToggle.subscribe(async () => {
		// 	this.isLayerControlOpen = !this.isLayerControlOpen;
		// 	if (this.isLayerControlOpen) {
		// 		const data: LayerControlModalData = {
		// 			dataLayer: {
		// 				cateCode: this.selectedLayer.category.code
		// 			}
		// 		}
		// 		const options = {
		// 			data: data
		// 		};
		// 		const rsp = await this.modalService.openModalWindow(FeatLayerControlComponent, options);
		// 		this.isLayerControlOpen = false;

		// 	}
		// });
		this.layerListSub = this.layerService.layerListBS.subscribe(async data => {
			if (!this.checkGenralExecute()) {
				return;
			}
			await this.onLayersUpdate(data.statusOnly);
		});
		this.bgRefLayerUpdateSub = this.mapService.bgRefLayerUpdate.subscribe(async data => {
			await this.drawBgRefLayer(this.mapReso);
		})
		this.bgBdryLayerUpdateSub = this.mapService.bgBdryLayerUpdate.subscribe(async data => {
			await this.drawBgBdryLayer();
		});
		this.selectedLayerSub = this.activityService.selectedLayerBS.subscribe(async data => {
			if (!this.checkGenralExecute() || isInit) { // because selectedLayer will be set in layersListBS changes
				return;
			}
			console.log('on sub selectedLayerBS', data)
			const layer = data.layer;
			//
			if (!layer && !this.selectedLayer) {
				return;
			} else {
				// Clear
				this.resoCenterService.resoFeedBS.next({
					record: null,
					feeds: null,
					recordId: null
				});
				this.resoCenterDomainService.resoFeedDomainBS.next({
					feeds: null,
					layerId: null
				});
				this.domainService.nestedColumnPropRelationIndex = null;

				// if (this.activityService.selectedRecord.getValue()) {
				// 	this.activityService.selectedRecord.next(null);
				// }
				if (this.activityService.selectedRecordsBS.getValue()) {
					this.activityService.selectedRecordsBS.next(null);
				}
				// if (data && this.selectedLayer && data.category.code === this.selectedLayer.category.code) {
				// 	this.selectedLayer = data; // layer state might change
				// 	return;
				// }
				this.selectedLayer = layer;
				// Update archive mode
				if (layer) {
					const selectedTab = this.activityService.selectedTabBS.getValue();
					const tabKey = selectedTab ? selectedTab.tabKey : null;
					this.archiveModeService.resetArchiveMode(tabKey, layer);
				}
				//
				const spinnerId = this.commonService.getRandomId();
				this.commonService.setLoadingSpinner(true, spinnerId);
				try {
					if (data.source !== 'onSelectLayer') {
						await this.onSelectLayer(data.keepFilters);
					}
				} catch (err) {
					console.log(err);
				}
				this.commonService.setLoadingSpinner(false, spinnerId);
			}
		});

		this.currentCardSub = this.activityService.currentCardBS.subscribe(data => {
			if (isInit || !data || !this.verticalTabsComp) {
				return;
			}
			if (data.source !== 'main') {
				this.updateCurrentCard(data.id);
			}
		})

		this.selectedRecordsSub = this.activityService.selectedRecordsBS.subscribe(async data => {
			if (isInit || !this.verticalTabsComp) {
				return;
			}
			const selectedLayer = this.selectedLayer;
			if (!data) {
				if (selectedLayer && selectedLayer.state.num === 2) { // content state
					this.resoCenterService.resoFeedBS.next({
						record: null,
						feeds: null,
						recordId: null
					});
					this.updateTabsVisibility();
				}
				return;
			}
			if (data.ids && data.ids.length) {
				this.socketSidekickService.onSync({
					globalIds: data.ids
				}, 'globalId');
			}
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				switch (data.source) {
					case 'table':
						if (!this.isMapFilterOn) {
							await this.drawRecordsOnMap(data.ids, this.selectedLayer);
							this.flashErrors(data.ids[0], 1400); // TODO
							// Draw surround so that the cleared data on dataLayer (from last draw) will be drawn on surrounding layer
							await this.drawBgSurroundings(this.mapReso);
						}
						// Highlight
						await this.selectRecordsOnMap(data.ids);
						if (this.isSsapRclLinkModeOn) {
							await this.drawSsapRclLinkByCurrent();
						}
						//
						if (data.zoomToRec) {
							this.mapControlsService.zoomToRecordSubject.next();
							if (this.selectedTab && this.selectedTab.key !== 'data') {
								this.selectDataTab();
							}
						}
							// // Update exceptions // NOTE: exceptions should be updated BEFORE updateCurrentCard
							// await this.getExceptionsForRec();
						//

						// const row = this.selectedRows[0];
						// await this.updateCurrentCard(row);
						break;
					case 'map':
						this.selectRecordsOnTable(data.ids);
							// // Update exceptions
							// // NOTE: exceptions should be updated BEFORE updateCurrentCard
							// await this.getExceptionsForRec();
						// //
						break;
					default:
						this.selectRecordsOnTable(data.ids);
						// this.updateCurrentCard(data.ids[0]);
						if (!this.isMapFilterOn) {
							await this.drawRecordsOnMap(data.ids, this.selectedLayer);
							this.flashErrors(data.ids[0], 1400);
							// Draw surround so that the cleared data on dataLayer (from last draw) will be drawn on surrounding layer
							await this.drawBgSurroundings(this.mapReso);
						}
						await this.selectRecordsOnMap(data.ids);
						if (this.isSsapRclLinkModeOn) {
							await this.drawSsapRclLinkByCurrent();
						}
						break;
				}
				this.updateCurrentCard(data.ids[0]);			
				
				// TODO: update currentCard
				if (data.ids.length) {
					const lastId = data.ids[data.ids.length - 1];
					if (!this.currentCardId || this.currentCardId !== lastId) {
						this.updateCurrentCard(lastId);
					}
				}

				// Resolution center
				await this.updateRc();

				// if (this.selectedTab && (this.selectedTab.key === 'filterOptions' || this.selectedTab.key === 'batch')) {
				// 	this.selectDataTab();
				// }
			} catch (err) {
				console.log(err);
				this.toastr.error(err.message);
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		});
		this.selectedTabSub = this.activityService.selectedTabBS.subscribe(data => {
			// Update archive mode
			if (this.selectedLayer) {
				const tabKey = data ? data.tabKey : null;
				this.archiveModeService.resetArchiveMode(tabKey, this.selectedLayer);
			}
		});
		this.zoomToRecordSub = this.mapControlsService.zoomToRecordSubject.subscribe(async () => {
			let selectedFeats = this.mapService.dataSelectInteraction.getFeatures().getArray();
			// Zoom to rec & additional rec for RAO
			if (this.selectedTab && this.selectedTab.key === 'resoCenter') {
				const qcLayer = this.mapService.map.addedLayers[this.mapLayerService.qcErrorLayerName];
				const qcFeats = qcLayer.getSource().getFeatures();
				selectedFeats = selectedFeats.concat(qcFeats);
			}
			if (selectedFeats.length) {
				const extent = this.mapService.map.getFeaturesExtent(selectedFeats);
				this.mapService.map.zoomToExtent(extent, {
					minReso: this.cMapService.zoomToLayerMinReso
				});
			}
		});

		this.flipRoadSub = this.flipRoadService.flipRoadSubject.subscribe(data => {
			if (!this.selectedTab) {
				return;
			}
			let id = data.id || this.currentCardId;
			if (!id) {
				return;
			}
			const afterFlip: AfterFlipData = {
				id: id
			}
			const featId = id;
			const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
			const qcLayer = this.mapService.map.addedLayers[this.mapLayerService.qcErrorLayerName];
			let roadFeat = dataLayer.getSource().getFeatureById(featId);
			if (!roadFeat) {
				roadFeat = qcLayer.getSource().getFeatureById(featId);
			}
			if (roadFeat && data.geom) {
				const geom = roadFeat.getGeometry();
				const geomType: GeometryType = geom.getType();
				let newCoords: any[];
				if (geomType === 'LineString') {
					newCoords = geom.getCoordinates().reverse();
				} else if (geomType === 'MultiLineString') {
					newCoords = geom.getCoordinates().map(line => {
						return line.reverse();
					});
					newCoords.reverse();
				}
				geom.setCoordinates(newCoords);
				roadFeat.changed(); // To update feature style
				// Update stored geom
				const wktString = this.updateFeatStoredGeom(roadFeat);

				switch (this.selectedTab.key) {
					case 'resoCenter':
						this.resoCenterService.setRecordAttrs(featId, this.geomColName_manual, wktString);
						// this.resoCenterService.records[featId].props[this.geomColName_manual] = wktString;
						break;
					case 'data':
						const attrs = this.mainDataService.getDataAttrs(featId);
						if (attrs) {
							this.mainDataService.addRecToCard(featId, this.selectedLayer.category.code);
						}
				}
				afterFlip.flipedWkt = wktString;
			}
			if (data.transposeCols && data.transposeCols.length && this.selectedTab) {
				if (this.selectedTab.key === 'resoCenter') {
					const recInfo = this.resoCenterService.getRecordInfo(featId);
					data.transposeCols.forEach(c => {
						const valueLeft = recInfo.props[c.leftProp];
						this.resoCenterService.setRecordAttrs(featId, c.leftProp, recInfo.props[c.rightProp]);
						this.resoCenterService.setRecordAttrs(featId, c.rightProp, valueLeft);
					});
				} else if (this.selectedTab.key === 'data') {
					const attrs = this.mainDataService.getDataAttrs(featId);
					data.transposeCols.forEach(c => {
						const valueLeft = attrs[c.leftProp];
						this.mainDataService.setDataAttrs(featId, c.leftProp, attrs[c.rightProp]);
						this.mainDataService.setDataAttrs(featId, c.rightProp, valueLeft);
					});
					if (!attrs[this.isEditedCol]) {
						this.mainDataService.addRecToCard(featId);
					}
				}
				afterFlip.transposeCols = data.transposeCols;
			}

			this.flipRoadService.afterFlipRoadSubject.next(afterFlip);
		});
		this.updateExceptionsSub = this.activityService.updateExceptionsSubject.subscribe(async data => {
			await this.updateRc();
			await this.updateFilterOptions(null, true);
		});
		this.resetFeatureSub = this.activityService.resetFeatures.subscribe(data => {
			this.mapService.resetFeaturesGeom(data.ids);
		});
		this.rcDrawAdditionalSub = this.resoCenterService.drawAdditionalRcSubject.subscribe(data => {
			if (data && data.recordsInfo) {
				const layer = this.mapService.map.addedLayers[this.mapLayerService.qcErrorLayerName];
				const features = this.cMapService.drawDataByWkt(this.mapService.map, data.recordsInfo.map(i => {
					return {
						wkt: i.wkt,
						id: i.id,
					}
				}), layer, {
					skipZoomToLayer: true,
					skipClearLayer: true
				});
				features.forEach(f => {
					const color = colors.mapError;
					const commonStyle = this.cMapService.getCommonStyle({
						strokeColor: color,
						strokeWidth: 2
					});
					f.setStyle((feat, reso) => {
						const arrowStyle = this.mapSharedService.getLineArrowStyle(feat, reso, null, {
							color: color
						}, true);
						return arrowStyle ? [commonStyle, arrowStyle] : [commonStyle];
					});
				})
			}
		});
		this.splitLineSub = this.splitMergeService.splitLineBS.subscribe(data => {
			if (!data) {
				return;
			}
			if (data.isCancel && this.isSplitLine) {
				const originalId = data.id;
				const edited = this.activityService.editRecordListBS.getValue();
				const layerNames = [this.mapLayerService.dataLayerName, this.mapLayerService.dataModifyLayerName];
				const splitIds = edited.ids.filter(id => {
					const attrs = this.mainDataService.getDataAttrs(id);
					if (attrs[this.attrIndexService.idBeforeSplitKey] === originalId) {
						return true;
					}
				});
				splitIds.forEach(id => {
					layerNames.forEach(name => {
						const layer = this.mapService.map.addedLayers[name];
						const feat = layer.getSource().getFeatureById(id);
						if (feat) {
							layer.getSource().removeFeature(feat);

							// TODO!!!!!!!!!!
							// Remove topo relation stored in topo.startVertex.feats & topo.endVertex.feats
						}
					});
					this.mainDataService.removeCard(id);
					this.mainDataService.removeDataFromStoredRecords(id);
				});
				// Do not use getOriginalData here, since you want to restore it to the state before split rather than original state
				const attrs = this.mainDataService.getDataAttrs(originalId);
				if (!attrs) {
					return;
				}
				this.mainDataService.setDataAttrs(originalId, this.attrIndexService.isDeletedKey, false);
				if (attrs[this.geomColName_manual]) {
					const layer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
					let feature = layer.getSource().getFeatureById(originalId);
					if (!feature) {
						feature = new Feature();
						feature.setId(originalId);
						layer.getSource().addFeature(feature);
					}
					const wktFormat = new WKT();
					const geom = wktFormat.readGeometry(attrs[this.geomColName_manual]);
					feature.setGeometry(geom);
					const hiddenEditedIds = this.activityService.editRecordListHiddenBS.getValue().ids;
					const hiddenIdx = hiddenEditedIds.find(id => id === originalId);
					if (hiddenIdx > -1) {
						hiddenEditedIds.splice(hiddenIdx, 1);
						this.activityService.editRecordListHiddenBS.next({
							ids: hiddenEditedIds
						});
					}
					if (attrs[this.attrIndexService.isEditedKey]) {
						const editedIds = this.activityService.editRecordListBS.getValue().ids;
						if (editedIds.indexOf(originalId) === -1) {
							this.mainDataService.addRecToCard(originalId);
						}
					}
				}
			}
		})
		this.splitLineToolSub = this.splitMergeService.splitToolBS.subscribe(data => {
			if (data) {
				if (data.action === 'start' && !this.isSplitLine) {
					this.isSplitLine = true;
					this.startSplitLine();
				} else if (data.action === 'stop' && this.isSplitLine) {
					this.isSplitLine = false;
					this.stopSplitLine();
				}
			}
		});
		this.mergeLineToolSub = this.splitMergeService.mergeToolBS.subscribe(data => {
			if (data) {
				if (data.action === 'start' && !this.isMergeLine) {
					this.isMergeLine = true;
					this.startMergeLine();
				} else if (data.action === 'stop' && this.isMergeLine) {
					this.isMergeLine = false;
					this.stopMergeLine();
				}
			}
		});
		this.mergeLineSub = this.splitMergeService.mergeLineBS.subscribe(data => {
			// if (data && data.isApply && data.mergedRec && data.ids) {
			// 	data.ids.forEach(id => {
			// 		this.mainDataService.addRecToCard(id, null, null, true);
			// 	});
			// 	const newCard = this.mainDataService.addNewCard(this.getIdCol());
			// 	newCard
			// }
		});
		this.showPolygonEditSub = this.editFeatureService.showPolygonEditBS.subscribe(data => {
			this.showPolygonEditContextmenu = data.showEditContextmenu;
			this.polygonEditContextmenuText = data.menuText || 'Edit';
		});
		this.bdryWizardSub = this.editFeatureService.bdryWizardBS.subscribe(async data => {
			this.isBdryWizardOn = data.isOn;
			//
			const refLayerMaxReso = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName].getMaxResolution();
			const mapReso = this.mapService.map.olMap.getView().getResolution();
			const isCurrentRefWithinDrawReso = mapReso <= refLayerMaxReso;
			if (!isCurrentRefWithinDrawReso) {
				const spinnerId = this.commonService.getRandomId();
				this.commonService.setLoadingSpinner(true, spinnerId);
				try {
					await this.drawBgRefLayer(mapReso);
				} catch (err) {
					console.log(err);
				}
				this.commonService.setLoadingSpinner(false, spinnerId);
			}

			this.resetBgRefLayers();
		});

		this.changeTabSub = this.activityService.changeTabSubject.subscribe(data => {
			if (!data || !this.verticalTabsComp) {
				return;
			}
			if (!this.selectedTab || this.selectedTab.key !== data.tabKey) {
				const tabIdx = this.tabs.findIndex(t => t.key === data.tabKey);
				this.verticalTabsComp.selectTab(tabIdx);
			}
			if (this.selectedTab && this.selectedTab.key === 'data' && data.dataTabMode) {
				// TODO
			}
		});
		this.fishboneControlSub = this.fishboneService.fishboneControlBS.subscribe(data => {
			if (!data) {
				return;
			}
			this.isFishboneOn = data.isOn;
			this.manuallyTriggerFishboneStyle();
			// const fbLayer = this.mapService.map.addedLayers[this.mapLayerService.addrFishboneLayerName];
			// const fbBgLayer = this.mapService.map.addedLayers[this.mapLayerService.addrBgFishboneLayerName];
			// if (data.isOn) {
			// 	this.drawAddrFishbone();
			// } else {
			// 	if (fbLayer) {
			// 		this.mapService.map.removeLayer(this.mapLayerService.addrFishboneLayerName);
			// 	}
			// 	if (fbBgLayer) {
			// 		this.mapService.map.removeLayer(this.mapLayerService.addrBgFishboneLayerName);
			// 	}
			// 	const dataLayer = this.mapService.map.addedLayers[this.mapLayerService.dataLayerName];
			// 	if (dataLayer.getProperties()[this.attrIndexService.layerStyleKey]) {
			// 		dataLayer.setStyle(dataLayer.getProperties()[this.attrIndexService.layerStyleKey]);
			// 	}
			// 	const cateCode = this.selectedLayer ? this.selectedLayer.category.code : '';
			// 	if (cateCode === this.attrIndexService.cateCodeAddress) {
			// 		const bgSurroundingLayer = this.mapService.map.addedLayers[this.mapLayerService.bgSurroundingsLayerName];
			// 		if (bgSurroundingLayer.getProperties()[this.attrIndexService.layerStyleKey]) {
			// 			bgSurroundingLayer.setStyle(bgSurroundingLayer.getProperties()[this.attrIndexService.layerStyleKey]);
			// 		}
			// 	} else if (cateCode === this.attrIndexService.cateCodeCenterline) {
			// 		const bgRefLayer = this.mapService.map.addedLayers[this.mapLayerService.bgReferenceLayerName];
			// 		if (bgRefLayer.getProperties()[this.attrIndexService.layerStyleKey]) {
			// 			bgRefLayer.setStyle(bgRefLayer.getProperties()[this.attrIndexService.layerStyleKey]);
			// 		}
			// 	}
			// }
		})

		isInit = false;
	}
	async ngAfterViewInit() {
		this.addMapFunctions();
		this.addMapListeners();

		this.showFishboneLayer = this.checkHasFishbone();

		this.initTabs();
	}
	ngOnDestroy() {
		this.activityService.mapMoveProcessingBS.next(null);

		this.routerEventSub.unsubscribe();
		this.schemaDefinedBySub.unsubscribe();
		this.schemaDataSub.unsubscribe();
		// this.viewSub.unsubscribe();
		this.modelSub.unsubscribe();
		this.hoverCoordSub.unsubscribe();
		this.selectedCustomerSub.unsubscribe();
		this.qcFinishSub.unsubscribe();
		this.fbFinishSub.unsubscribe();
		this.attrFilterSub.unsubscribe();
		this.qcFilterInfoSub.unsubscribe();
		// this.editCardsSub.unsubscribe();
		this.fishboneFilterInfoSub.unsubscribe();
		this.interactiveFishboneSub.unsubscribe();
		this.tooltipHelpSub.unsubscribe();
		this.refreshDataSub.unsubscribe();
		this.cancelSub.unsubscribe();
		this.applyAttrFilterSub.unsubscribe();
		// this.layerControlSub.unsubscribe();
		this.layerListSub.unsubscribe();
		this.bgRefLayerUpdateSub.unsubscribe();
		this.bgBdryLayerUpdateSub.unsubscribe();
		this.selectedLayerSub.unsubscribe();
		// this.selectedRecordSub.unsubscribe();
		this.selectedRecordsSub.unsubscribe();
		this.currentCardSub.unsubscribe();
		this.selectedTabSub.unsubscribe();
		this.mapFilterSub.unsubscribe();
		this.mapLabelSub.unsubscribe();
		this.mapEditingSub.unsubscribe();
		this.mapAddressesOnRoadModeSub.unsubscribe();
		this.featMapAddSub.unsubscribe();
		this.zoomToRecordSub.unsubscribe();
		this.flipRoadSub.unsubscribe();
		this.updateExceptionsSub.unsubscribe();
		this.resetFeatureSub.unsubscribe();
		this.rcDrawAdditionalSub.unsubscribe();
			// TODO 
				// if (this.isSplitLine) {
				// 	this.stopSplitLine();
				// }
		this.splitLineSub.unsubscribe();
		this.splitLineToolSub.unsubscribe();
		this.mergeLineToolSub.unsubscribe();
		if (this.isMergeLine) {
			this.stopMergeLine();
		}
		this.mergeLineSub.unsubscribe();
		this.showPolygonEditSub.unsubscribe();
		this.bdryWizardSub.unsubscribe();
		this.changeTabSub.unsubscribe();
		this.fishboneControlSub.unsubscribe();
		//
		this.mainDataService.contentMenuItemKeyBS.next(null);
	}
	canDeactivate() {
		return !this.checkHasChangedData();
	}

}
